import React from "react";
import ReactDOM from "react-dom";
import {
  Nav,
  Navbar,
  NavbarBrand,
  NavDropdown,
  Tab,
  Tabs,
  Button,
  OverlayTrigger,
  Popover
} from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";


import { Navigate } from "react-router-dom";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
// import "../css/main.css";
import { EntityLockBean, RestAttributeCacheInputBean } from "../ds/ds.js";
import {
  CloseIcon,
  FilterIcon,
  AttributesGeneralIcon,
  AttributesCustomerIcon,
  AttributesVendorIcon,
  AttributesProductionIcon,
  AttributesAccountingIcon,
  AttributesWebIcon,
  AttributesItemIcon,
  MasterItemIcon,
  MasterCustomerIcon,
  MasterVendorIcon,
  MasterItemCostIcon,
  SalesSalesOrderIcon,
  SalesMassSalesOrderIcon,
  SalesPickTicketIcon,
  SalesInvoiceIcon,
  SalesCommisionMaintenanceIcon,
  SalesPrintBulkPickTicketIcon,
  SalesMassSalesOrderPrintIcon,
  SalesPickTicketRollEntityIcon,
  SalesCommercialInvoiceForMultipleInvoiceIcon,
  SalesAdvancedMassOrderPickticketIcon,
  SalesInvoiceForMultipleInvoiceIcon,
  SalesMailInvoicesIcon,
  SalesSalesMassMaintenanceIcon,
  CPMPreProductionMaintenanceIcon,
  CPMEntryMaintenanceIcon,
  CPMReportIcon,
  PurchaseOrderIcon,
  PurchaseMassPurchaseOrderPrintIcon,
  PurchaseMassPurchaseOrderCancelIcon,
  PurchaseIntransitIcon,
  PurchaseOrderReceiptIcon,
  PurchaseVendorInvoiceIcon,
  AccountsReceivableIcon,
  AccountsCreditMemoIcon,
  AccountsCheckTransitionIcon,
  AccountsBatchCheckTransitionIcon,
  AccountsBankAdjustmentIcon,
  AccountsDepositIcon,
  AccountsLetterOfCreditIcon,
  AccountsCheckBounceIcon,
  AccountsCustomerReturnIcon,
  AccountsPostDatedCheckEntryIcon,
  InboundOrderIcon,
  InboundReceiptIcon,
  InboundBarcodeIcon,
  InventoryAdjustmentIcon,
  InventoryTransferIcon,
  InventoryPrintRollIcon,
  InventoryPrintPOIntransitRollIcon,
  InventoryMassInventoryTransferIcon,
  InventoryPhysicalInvAdjustmentsIcon,
  InventoryRollInventoryMainteranceIcon,
  InventoryManualInventoryAllocationIcon,
  InventoryRollDataConversionIcon,
  JobWebItemExportIcon,
  JobWebItemImportIcon,
  JobWebSKUInventoryReprortIcon,
  JobEcommJobStatusIcon,
  JobEcommWebOrderStatusIcon,
  JobWebItemExcelToERPImportIcon,
  InquiryAllItemATSIcon,
  InquiryItemStatisticsIcon,
  InquiryPrintoutTrackInquiryIcon,
  InquiryItemListWithPriceAndCostIcon,
  InquiryAllItemCustomInquiryIcon,
  InquiryCustomerItemATSInquiryIcon,
  InquiryMailTrackIcon,
  InquiryItemWeeklyMonthlyATSIcon,
  InquiryOnOrderIcon,
  InquiryCPMIcon,
  InquirySalesIcon,
  InquiryInboundIcon,
  InquiryInfoIcon,
  InquiryInventoryIcon,
  InquirySalesAnaysisIcon,
  InquiryPurchaseIcon,
  InquiryStatisticsIcon,
  InquiryAccountsIcon,
  InquiryPaymentHistoryIcon,
  SecurityUserMaintenanceIcon,
  SecurityRoleMaintenanceIcon,
  SystemReleaseLockIcon,
  SystemRefreshCacheIcon,
  ChartIcon,
  AnalyticsIcon,
  FaEye,
  REFRESHICON,
  WORKORDERICON,
  FabricCatalogGenerationIcon
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty } from "../gui_components/Util.js";
import { AllModuleList } from "../ModuleManager.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { EntityLockService } from "../services/EntityLockService.js";
import { MasterService } from "../services/MasterService.js";

import { ChevronDown, ChevronRight, Home, BarChart2, Settings, TrendingUp, ListChecks, Database, ShoppingCart, Calculator, BookOpen, ShoppingBag, Factory, PanelLeft, LayoutGrid, AppWindow, ChevronLeft, CreditCard, DollarSign, FileText, Calendar, Wrench, Truck, Package, Shield ,LayoutDashboard} from "lucide-react";
import { RiFileList3Fill, RiTruckFill, RiBoxesFill, RiBarChartBoxFill, RiSettings3Fill, RiSearchEyeFill, RiShieldUserFill, RiServerFill } from "react-icons/ri";
import { FaChevronLeft, FaChevronRight, FaChevronDown, FaChevronUp } from "react-icons/fa";
import logo from "../images/AdvanceERP.png";

import { Droppable, Draggable } from "react-beautiful-dnd";
import { DragDropContext } from "@hello-pangea/dnd";
//import UseAutoLogout from "../UseAutoLogout.js";




const getMainMenus = (access) => ({
  Attributes: {
    icon: <ListChecks size={18} />,
    isAccessible: access.attributeIsAccessible,
    subMenus: {
      General: {
        icon: <Database size={14} />,
        isAccessible: access.generalAttributeIsAccessible,
        items: [
          { key: "serviceDetails", label: "Service Details", isAccessible: access.serviceDetailsIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "invoicePrintoutType", label: "Invoice Printout Type", isAccessible: access.invoicePrintoutTypeIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "businessDivisionAttribute", label: "Business Division", isAccessible: access.businessDivisionIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "uomAttribute", label: "UOM", isAccessible: access.uomIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "currencyAttribute", label: "Currency", isAccessible: access.currencyIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "styleAttribute", label: "Style", isAccessible: access.styleIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "styleTypeAttribute", label: "Style Type", isAccessible: access.styleTypeIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "typeCategoryAttribute", label: "Type Category", isAccessible: access.typeCategoryIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "contentAttribute", label: "Content", isAccessible: access.contentIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "productDivisionAttribute", label: "Product Division", isAccessible: access.productDivisionIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "colorAttribute", label: "Color", isAccessible: access.colorIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "compositionTypeAttribute", label: "Composition Type", isAccessible: access.compositionTypeIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "styleItemTypeAttribute", label: "Style Item Type", isAccessible: access.styleItemTypeIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "countryAttribute", label: "Country", isAccessible: access.countryIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "seasonAttribute", label: "Season", isAccessible: access.seasonIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "locationAttribute", label: "Location", isAccessible: access.locationIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "binLocation", label: "Bin Location", isAccessible: access.binLocationIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "royaltyClientAttribute", label: "Royalty Client", isAccessible: access.royaltyClientIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "inventoryAdjustmentReasonAttribute", label: "Inventory Adjustment Reason", isAccessible: access.inventoryAdjustmentReasonIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "currencyExchangeRateAttribute", label: "Currency Exchange Rate", isAccessible: access.currencyExchangeRateIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "employeeAttribute", label: "Employee", isAccessible: access.employeeIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "harmonizedTariffScheduleAttribute", label: "Harmonized Tariff Schedule", isAccessible: access.harmonizedTariffScheduleIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "productStatusAttribute", label: "Product Status", isAccessible: access.productStatusIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "fabricVendorMiscellaneousCostDetailAttribute", label: "Fabric Vendor Miscellaneous Cost Detail", isAccessible: access.fabricVendorMiscellaneousCostDetailIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "fiscalYearAttribute", label: "Fiscal Year", isAccessible: access.fiscalYearIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "commentAttribute", label: "Comment", isAccessible: access.commentIsAccessible, icon: <AttributesGeneralIcon /> },
          { key: "shipToAttribute", label: "Ship To", isAccessible: access.shipToIsAccessible, icon: <AttributesGeneralIcon /> },
        ]
      },

      Customer: {
        icon: <AttributesCustomerIcon size={14} />,
        isAccessible: access.customerAttributeIsAccessible,
        items: [
          { key: "customerDivisionAttribute", label: "Customer Division", isAccessible: access.customerDivisionIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "cityAttribute", label: "City", isAccessible: access.cityIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "logisticMethodAttribute", label: "Logistic Method", isAccessible: access.logisticMethodIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "customerSpecialTypeAttribute", label: "Customer Special Type", isAccessible: access.customerSpecialTypeIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "customerTypeAttribute", label: "Price Type", isAccessible: access.customerTypesIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "shipViaAttribute", label: "Ship Via", isAccessible: access.shipViaIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "freightMethodAttribute", label: "Freight Method", isAccessible: access.freightMethodIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "customerSalesZoneAttribute", label: "Customer Sales Zone", isAccessible: access.customerSalesZoneIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "boxTypeAttribute", label: "Box Type", isAccessible: access.boxTypeIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "paymentTermAttribute", label: "Payment Term", isAccessible: access.paymentTermIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "stateAttribute", label: "State", isAccessible: access.stateIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "invoiceTemplateAttribute", label: "Invoice Template", isAccessible: access.invoiceTemplateIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "paymentMethodAttribute", label: "Payment Method", isAccessible: access.paymentMethodIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "customerDeliveryAttribute", label: "Customer Delivery", isAccessible: access.customerDeliveryIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "invoiceCancelReasonAttribute", label: "Invoice Cancel Reason", isAccessible: access.invoiceCancelReasonIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "invoiceUnApprovalReasonAttribute", label: "Invoice UnApproval Reason", isAccessible: access.invoiceUnApprovalReasonIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "invoiceNonMerchandiseReasonAttribute", label: "Invoice Non Merchandise Reason", isAccessible: access.invoiceNonMerchandiseReasonIsAccessible, icon: <AttributesCustomerIcon /> },
          { key: "periodSalesCommissionAdjustmentReasonAttribute", label: "Period Sales Commission Adjustment Reason", isAccessible: access.periodSalesCommissionAdjustmentReasonIsAccessible, icon: <AttributesCustomerIcon /> },
		{
            key: "invoiceModelAttribute",
            label: "Invoice Model",
            isAccessible: access.invoiceTemplateIsAccessible,
            icon: <AttributesCustomerIcon />,
          },	  
        ]
      },

      Vendor: {
        icon: <AttributesVendorIcon size={14} />,
        isAccessible: access.vendorAttributeIsAccessible,
        items: [
          { key: "vendorTypeAttribute", label: "Vendor Type", isAccessible: access.vendorTypeIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "fobCityAttribute", label: "FOB City", isAccessible: access.fobCityIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "incoTermAttribute", label: "Inco Term", isAccessible: access.incoTermIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "vendorShipViaAttribute", label: "Vendor Ship Via", isAccessible: access.vendorShipViaIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "vendorTermAttribute", label: "Vendor Term", isAccessible: access.vendorTermIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "shipmentTermAttribute", label: "Shipment Term", isAccessible: access.shipmentTermIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "vendorCategoryAttribute", label: "Vendor Category", isAccessible: access.vendorCategoryIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "purchaseOrderCancelReasonAttribute", label: "Purchase Order Cancel Reason", isAccessible: access.purchaseOrderCancelReasonIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "purchaseOrderUnApprovalReasonAttribute", label: "Purchase Order UnApproval Reason", isAccessible: access.purchaseOrderUnApprovalReasonIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "miscellaneousChargeReasonAttribute", label: "Miscellaneous Charge Reason", isAccessible: access.miscellaneousChargeReasonIsAccessible, icon: <AttributesVendorIcon /> },
          { key: "purchaseOrderModelAttribute", label: "Purchase Order Model", isAccessible: access.purchaseOrderModelIsAccessible, icon: <AttributesVendorIcon /> },
        ]
      },

      Production: {
        icon: <AttributesProductionIcon size={14} />,
        isAccessible: access.productionAttributeIsAccessible,
        items: [
          { key: "preProductionChangeReasonAttribute", label: "Pre Production Change Reason", isAccessible: access.preProductionChangeReasonIsAccessible, icon: <AttributesProductionIcon /> },
          { key: "stageCollectionAttribute", label: "Stage Collection", isAccessible: access.stageCollectionIsAccessible, icon: <AttributesProductionIcon /> },
        ]
      },

      Accounting: {
        icon: <AttributesAccountingIcon size={14} />,
        isAccessible: access.accountAttributeIsAccessible,
        items: [
          { key: "generalLedgerAccountTypeAttribute", label: "General Ledger Account Type", isAccessible: access.generalLedgerAccountTypeIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "generalLedgerAccountAttribute", label: "General Ledger Account", isAccessible: access.generalLedgerAccountIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "accountReceivableDiscountAttribute", label: "Account Receivable Discount", isAccessible: access.accountReceivableDiscountIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "customerTenderReasonAttribute", label: "Customer Tender Reason", isAccessible: access.customerTenderReasonIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "customerTenderCancelReasonAttribute", label: "Customer Tender Cancel Reason", isAccessible: access.customerTenderCancelReasonIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "customerTenderUnApprovalReasonAttribute", label: "Customer Tender UnApproval Reason", isAccessible: access.customerTenderUnApprovalReasonIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "accountReceivableReversalReasonAttribute", label: "Account Receivable Reversal Reason", isAccessible: access.accountReceivableReversalReasonIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "expenseTypeAttribute", label: "Expense Type", isAccessible: access.expenseTypeIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "expenseSubTypeAttribute", label: "Expense Sub Type", isAccessible: access.expenseSubTypeIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "bankAdjustmentReasonAttribute", label: "Bank Adjustment Reason", isAccessible: access.bankAdjustmentReasonIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "depositCancelReasonAttribute", label: "Deposit Cancel Reason", isAccessible: access.depositCancelReasonIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "depositReversalReasonAttribute", label: "Deposit Reversal Reason", isAccessible: access.depositReversalReasonIsAccessible, icon: <AttributesAccountingIcon /> },
          { key: "bankAccountAttribute", label: "Bank Account", isAccessible: access.bankAccountIsAccessible, icon: <AttributesAccountingIcon /> },
        ]
      },

      Web: {
        icon: <AttributesWebIcon size={14} />,
        isAccessible: access.webAttributeIsAccessible,
        items: [
          { key: "targetWebSiteDetailAttribute", label: "Target WebSite Detail", isAccessible: access.targetWebSiteDetailAttributeIsAccessible, icon: <AttributesWebIcon /> },
        ]
      },

      Fabric: {
        icon: <AttributesItemIcon size={14} />,
        isAccessible: access.fabricDetailAttributeIsAccessible,
        items: [
          { key: "fabricDetailAttribute", label: access.is3PL ? "Item Construction" : "Fabric Construction", isAccessible: access.fabricConstructAccessible, icon: <AttributesItemIcon /> },
          { key: "designDirectionAttribute", label: "Design Direction", isAccessible: access.designDirectionIsAccessible, icon: <AttributesItemIcon /> },
          { key: "backedAttribute", label: "Backed", isAccessible: access.backedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "backedTypesAttribute", label: "Backed Types", isAccessible: access.backedTypesIsAccessible, icon: <AttributesItemIcon /> },
          { key: "boundBackTypesAttribute", label: "Bound Back Types", isAccessible: access.boundBackTypesIsAccessible, icon: <AttributesItemIcon /> },
          { key: "cardedOrCombedAttribute", label: "Carded Or Combed", isAccessible: access.cardedOrCombedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "fabricDetailsAttribute", label: access.is3PL ? "Item Details" : "Fabric Details", isAccessible: access.fabricDetailsIsAccessible, icon: <AttributesItemIcon /> },
          { key: "fillingYarnsTexturedAttribute", label: "Filling Yarns Textured", isAccessible: access.fillingYarnsTexturedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "fillingYarnsTwistedAttribute", label: "Filling Yarns Twisted", isAccessible: access.fillingYarnsTwistedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "nappedAttribute", label: "Napped", isAccessible: access.nappedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "printedAttribute", label: "Printed", isAccessible: access.printedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "warpYarnsAttribute", label: "Warp Yarns", isAccessible: access.warpYarnsIsAccessible, icon: <AttributesItemIcon /> },
          { key: "warpYarnsTexturedAttribute", label: "Warp Yarns Textured", isAccessible: access.warpYarnsTexturedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "warpYarnsTwistedAttribute", label: "Warp Yarns Twisted", isAccessible: access.warpYarnsTwistedIsAccessible, icon: <AttributesItemIcon /> },
          { key: "washedAttribute", label: "Washed", isAccessible: access.washedIsAccessible, icon: <AttributesItemIcon /> },
        ]
      },
    }
  },

 

  Master: {
    icon: <Database size={18} />,
    isAccessible: access.masterIsAccessible,
    subMenus: {
      // ── Item v1 ──
      Item_v1: {
        icon: <MasterItemIcon size={14} />,
        label: access.is3PL ? "Item" : "Fabric Style",
        isAccessible: access.itemIsAccessible && access.isVersion_1,
        directRoute: true,
        directKey: "fabricStyleMaster",
        items: [],
      },

      // ── Item v2 ──
      Item_v2: {
        icon: <MasterItemIcon size={14} />,
        label: access.is3PL ? "Item" : "Fabric Style",
        isAccessible: access.itemIsAccessible && access.isVersion_2,
        directRoute: true,
        directKey: "fabricStyleMaster_v2",
        items: [],
      },

      // ── Item v3 ──
      Item_v3: {
        icon: <MasterItemIcon size={14} />,
        label: access.is3PL ? "Item" : "Fabric Style",
        isAccessible: access.itemIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "fabricStyleMaster_v3",
        items: [],
      },
	  FabricStatistics: {
        icon: <MasterItemCostIcon size={14} />,
        label: "FabricStatistics",
        isAccessible: access.fabricStatisticsDetailIsAccessible,
        directRoute: true,
        directKey: "fabricStatisticsDetailMaster",
        items: [],
      },

      Customer_v1: {
        icon: <MasterCustomerIcon size={14} />,
        label: "Customer",
        isAccessible: access.customerIsAccessible && access.isVersion_1,
        directRoute: true,
        directKey: "customerMaster",
        items: [],
      },
      Customer_v2: {
        icon: <MasterCustomerIcon size={14} />,
        label: "Customer",
        isAccessible: access.customerIsAccessible && access.isVersion_2,
        directRoute: true,
        directKey: "customerMaster_v2",
        items: [],
      },
      Customer_v3: {
        icon: <MasterCustomerIcon size={14} />,
        label: "Customer",
        isAccessible: access.customerIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "customerMaster_v3",
        items: [],
      },
      Vendor: {
        icon: <MasterVendorIcon size={14} />,
        label: "Vendor",
        isAccessible: access.vendorIsAccessible,
        directRoute: true,
        directKey: "vendorMaster",
        items: [],
      },
      FabricCost: {
        icon: <MasterItemCostIcon size={14} />,
        label: "Fabric Cost",
        isAccessible: access.fabricCostIsAccessible,
        directRoute: true,
        directKey: "fabricStyleCostMaster",
        items: [],
      },



    },
  },

  // ========== SALES MODULE ==========
  Sales: {
    icon: <ShoppingCart size={18} />,
    isAccessible: access.salesIsAccessible,
    subMenus: {
      SalesOrder_v1: {
        icon: <SalesSalesOrderIcon size={14} />,
        label: "SalesOrder",
        isAccessible: access.salesOrderIsAccessible && access.isVersion_1,
        directRoute: true,
        directKey: "salesOrder",
        items: [],
      },
      SalesOrder_v2: {
        icon: <SalesSalesOrderIcon size={14} />,
        label: "SalesOrder",
        isAccessible: access.salesOrderIsAccessible && access.isVersion_2,
        directRoute: true,
        directKey: "salesOrder_v2",
        items: [],
      },
      SalesOrder_v3: {
        icon: <SalesSalesOrderIcon size={14} />,
        label: "SalesOrder",
        isAccessible: access.salesOrderIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "salesOrder_v3",
        items: [],
      },
      massSalesOrderPickTicketGeneration: {
        icon: <SalesMassSalesOrderIcon size={14} />,
        label: "Mass SalesOrder PickTicket Generation",
        isAccessible: access.massSalesOrderPickTicketGenerationIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "massSalesOrderPickTicketGeneration",
        items: [],
      },
      PickTicket: {
        icon: <SalesPickTicketIcon size={14} />,
        label: "PickTicket",
        isAccessible: access.pickTicketIsAccessible && access.isVersion_1,
        directRoute: true,
        directKey: "pickTicket",
        items: [],
      },
      PickTicket_v2: {
        icon: <SalesPickTicketIcon size={14} />,
        label: "PickTicket",
        isAccessible: access.pickTicketIsAccessible && access.isVersion_2,
        directRoute: true,
        directKey: "pickTicket_v2",
        items: [],
      },
      PickTicket_v3: {
        icon: <SalesPickTicketIcon size={14} />,
        label: "PickTicket",
        isAccessible: access.pickTicketIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "pickTicket_v3",
        items: [],
      },
      Invoice: {
        icon: <SalesInvoiceIcon size={14} />,
        label: "Invoice",
        isAccessible: access.invoiceIsAccessible && (access.isVersion_1 || access.isVersion_2),
        directRoute: true,
        directKey: "invoice",
        items: [],
      },
      Invoice_v2: {
        icon: <SalesInvoiceIcon size={14} />,
        label: "Invoice",
        isAccessible: access.invoiceIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "invoice_v3",
        items: [],
      },
      SalesCommission: {
        icon: <SalesCommisionMaintenanceIcon size={14} />,
        label: "Sales Commission Maintenance",
        isAccessible: access.salesCommissionIsAcessible && (access.isVersion_1 || access.isVersion_2),
        directRoute: true,
        directKey: "salesCommission",
        items: [],
      },
      SalesCommission_v2: {
        icon: <SalesCommisionMaintenanceIcon size={14} />,
        label: "Sales Commission Maintenance",
        isAccessible: access.salesCommissionIsAcessible && access.isVersion_3,
        directRoute: true,
        directKey: "salesCommission_v3",
        items: [],
      },
      PrintBulkPickTicketMaintenance: {
        icon: <SalesPrintBulkPickTicketIcon size={14} />,
        label: "Print Bulk PickTicket Maintenance",
        isAccessible: access.printBulkPickTicketMaintenanceIsAccessible,
        directRoute: true,
        directKey: "printBulkPickTicket",
        items: [],
      },
      MassSalesOrderPrint: {
        icon: <SalesMassSalesOrderPrintIcon size={14} />,
        label: "Mass Sales Order Print",
        isAccessible: access.massSalesOrderPrintModule_IsAccessible,
        directRoute: true,
        directKey: "massSalesOrderPrint",
        items: [],
      },
      PickTicketRollUtility: {
        icon: <SalesPickTicketRollEntityIcon size={14} />,
        label: "Pick Ticket Roll Utility",
        isAccessible: access.pickTicketRollUtilityIsAccessible,
        directRoute: true,
        directKey: "ptRollUtility",
        items: [],
      },
      CommercialInvoiceForMultipleInvoice: {
        icon: <SalesCommercialInvoiceForMultipleInvoiceIcon size={14} />,
        label: "CommercialInvoice For MultipleInvoice",
        isAccessible: access.commercialInvoiceForInvoicesIsAccessible,
        directRoute: true,
        directKey: "commercialInvoiceForMultipleInvoice",
        items: [],
      },

      AdvancedMassSalesOrderPickTicketGeneration: {
        icon: <SalesAdvancedMassOrderPickticketIcon size={14} />,
        label: "Advanced Mass SalesOrder PickTicket Generation",
        isAccessible: access.advancedMassSalesOrderPickTicketGenerationIsAccessible,
        directRoute: true,
        directKey: "advancedSalesPickTicketGeneration",
        items: [],
      },

      InvoiceForMultiplePickTicket: {
        icon: <SalesInvoiceForMultipleInvoiceIcon size={14} />,
        label: "Invoice For Multiple PickTicket",
        isAccessible: access.invoiceForMultiplePickTicketIsAccessible,
        directRoute: true,
        directKey: "invoiceForMultiplePickTicket",
        items: [],
      },

      MailInvoices: {
        icon: <SalesMailInvoicesIcon size={14} />,
        label: "Mail Invoices",
        isAccessible: access.mailInvoicesIsAccessible,
        directRoute: true,
        directKey: "mailInvoices",
        items: [],
      },
      MassMaintenance: {
        icon: <SalesSalesMassMaintenanceIcon size={14} />,
        label: "Mass Maintenance",
        isAccessible: access.massMaintenanceIsAccessible,

        items: [
          {
            icon: <SalesSalesMassMaintenanceIcon size={14} />,
            label: "Approve SalesOrder",
            isAccessible: access.approveSalesOrderIsAccessible,

            key: "approveSalesOrder",
          },
          {
            icon: <SalesSalesMassMaintenanceIcon size={14} />,
            label: "Cancel BackOrder",
            isAccessible: access.cancelBackOrderIsAccessible,

            key: "cancelBackOrder",
          },
          {
            icon: <SalesSalesMassMaintenanceIcon size={14} />,
            label: "MassCancel SalesOrder",
            isAccessible: access.massCancelSalesOrderIsAccessible,

            key: "cancelSalesOrder",
          },
          {
            icon: <SalesSalesMassMaintenanceIcon size={14} />,
            label: "Generate PickTicket",
            isAccessible: access.generatePickTicketIsAccessible,

            key: "generatePickTicket",
          },
          {
            icon: <SalesSalesMassMaintenanceIcon size={14} />,
            label: "Generate Invoice",
            isAccessible: access.generateInvoiceIsAccessible,

            key: "generateInvoice",
          },
          {
            icon: <SalesSalesMassMaintenanceIcon size={14} />,
            label: "Approve Invoice",
            isAccessible: access.approveInvoiceIsAccessible,

            key: "approveInvoice",
          },
        ],
      },


    }
  },
 
  CPM: {
  icon: <CPMEntryMaintenanceIcon size={18} />,
  isAccessible:
    access.CpmIsAccessible ,
    

  subMenus: {

    DevelopmentCPM_v2: {
      icon: <CPMPreProductionMaintenanceIcon size={14} />,
      label: "Development CPM",
      isAccessible:
        access.developmentCPMIsAccessible &&
        access.isVersion_2,
      directRoute: true,
      directKey: "cpm",
      items: [],
    },

    PreProductionMaintenance: {
      icon: <CPMPreProductionMaintenanceIcon size={14} />,
      label: "PreProduction Maintenance",
      isAccessible:
        access.developmentCPMIsAccessible &&
        !access.isVersion_2,
      directRoute: true,
      directKey: "preProduction",
      items: [],
    },

    CPMEntryMaintenance: {
      icon: <CPMEntryMaintenanceIcon size={14} />,
      label: "CPM Entry Maintenance",
      isAccessible: access.cpmEntryMaintenanceIsAccessible,
      directRoute: true,
      directKey: "cpmEntry",
      items: [],
    },

    CPMReportInquiry: {
      icon: <CPMReportIcon size={14} />,
      label: "CPM Report",
      isAccessible: access.cpmReportInquiryIsAccessible,
      directRoute: true,
      directKey: "cpmInq",
      items: [],
    },

  },
},
  // ========== PURCHASE MODULE ==========
  Purchase: {
    icon: <ShoppingBag size={18} />,
    isAccessible: access.purchaseIsAccessible,
    subMenus: {

      PurchaseOrder: {
        icon: <PurchaseOrderIcon size={14} />,
        label: "Purchase Order",
        isAccessible: access.purchaseOrderIsAccessible && access.isVersion_1,
        directRoute: true,
        directKey: "purchaseOrder",
        items: [],
      },
      PurchaseOrder_v2: {
        icon: <PurchaseOrderIcon size={14} />,
        label: "Purchase Order",
        isAccessible: access.purchaseOrderIsAccessible && access.isVersion_2,
        directRoute: true,
        directKey: "purchaseOrder_v2",
        items: [],
      },
      PurchaseOrder_v3: {
        icon: <PurchaseOrderIcon size={14} />,
        label: "Purchase Order",
        isAccessible: access.purchaseOrderIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "purchaseOrder_v3",
        items: [],
      },
      MassPurchaseOrderPrint: {
        icon: <PurchaseMassPurchaseOrderPrintIcon size={14} />,
        label: "Mass PurchaseOrder Print",
        isAccessible: access.massPurchaseOrderIsAccessible,
        directRoute: true,
        directKey: "massPurchaseOrder",
        items: [],
      },

      MassCancelPurchaseOrder: {
        icon: <PurchaseMassPurchaseOrderCancelIcon size={14} />,
        label: "Mass Cancel Purchase Order",
        isAccessible: access.massCancelPurchaseIsAccessible,
        directRoute: true,
        directKey: "massCancelPurchase",
        items: [],
      },

      PurchaseOrderInTransit_v1: {
        icon: <PurchaseIntransitIcon size={14} />,
        label: "Purchase InTransit",
        isAccessible:
          access.purchaseOrderInTransitIsAccessible && access.isVersion_1,
        directRoute: true,
        directKey: "purchaseOrderInTransit",
        items: [],
      },

      PurchaseOrderInTransit_v2: {
        icon: <PurchaseIntransitIcon size={14} />,
        label: "Purchase InTransit",
        isAccessible:
          access.purchaseOrderInTransitIsAccessible && access.isVersion_2,
        directRoute: true,
        directKey: "purchaseOrderInTransit_v2",
        items: [],
      },

      PurchaseOrderInTransit_v3: {
        icon: <PurchaseIntransitIcon size={14} />,
        label: "Purchase InTransit",
        isAccessible:
          access.purchaseOrderInTransitIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "purchaseOrderInTransit_v3",
        items: [],
      },

      PurchaseOrderReceipt_v1_v2: {
        icon: <PurchaseOrderReceiptIcon size={14} />,
        label: "Purchase Order Receipt",
        isAccessible:
          access.purchaseOrderReceiptIsAccessible &&
          (access.isVersion_1 || access.isVersion_2),
        directRoute: true,
        directKey: "purchaseOrderReceipt",
        items: [],
      },

      PurchaseOrderReceipt_v3: {
        icon: <PurchaseOrderReceiptIcon size={14} />,
        label: "Purchase Order Receipt",
        isAccessible:
          access.purchaseOrderReceiptIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "purchaseOrderReceipt_v3",
        items: [],
      },

      VendorInvoice_v1_v2: {
        icon: <PurchaseVendorInvoiceIcon size={14} />,
        label: "Vendor Invoice",
        isAccessible:
          access.vendorInvoiceIsAccessible &&
          (access.isVersion_1 || access.isVersion_2),
        directRoute: true,
        directKey: "vendorInvoice",
        items: [],
      },

      VendorInvoice_v3: {
        icon: <PurchaseVendorInvoiceIcon size={14} />,
        label: "Vendor Invoice",
        isAccessible:
          access.vendorInvoiceIsAccessible && access.isVersion_3,
        directRoute: true,
        directKey: "vendorInvoice_v3",
        items: [],
      },

    
    }
  },

  // ========== WORK ORDER MODULE ==========
  // WorkOrder: {
  //   icon: <Factory size={18} />,
  //   isAccessible: access.workIsAccessible,
  //   subMenus: {

  //     WorkOrder: {
  //       icon: <WORKORDERICON size={14} />,
  //       label: "Work Order",
  //       isAccessible:
  //         access.workIsAccessible ,
  //       directRoute: true,
  //       directKey: "workOrder",
  //       items: [],
  //     },
  //      WorkOrderReceipt: {
  //       icon: <WORKORDERICON size={14} />,
  //       label: "Work Order Receipt",
  //       isAccessible:
  //         access.workOrderReceiptIsAccessible ,
  //       directRoute: true,
  //       directKey: "workOrderReceipt",
  //       items: [],
  //     },
      
  //   }
  // },

  // ========== ACCOUNTING MODULE ==========

  Accounting: {
  icon: <RiFileList3Fill size={18} />,
  isAccessible: access.accountModuleIsAccessible,

  subMenus: {
    DebitMemo: {
      icon: <AccountsPostDatedCheckEntryIcon size={14} />,
      label: "Debit Memo Module",
      isAccessible: access.debitMemoIsAccessible,
      directRoute: true,
      directKey: "debitMemoModule",
      items: [],
    },

    AccountReceivable: {
      icon: <AccountsReceivableIcon size={14} />,
      label: "Account Receivable",
      isAccessible: access.accountReceivableIsAccessible &&  (access.isVersion_1 || access.isVersion_2),
      directRoute: true,
      directKey:"accountReceivable",
      items: [],
    },
     AccountReceivable_v2: {
      icon: <AccountsReceivableIcon size={14} />,
      label: "Account Receivable",
      isAccessible: access.accountReceivableIsAccessible &&  access.isVersion_3,
      directRoute: true,
      directKey: "accountReceivable_v3",
      items: [],
    },

    CreditMemo: {
      icon: <AccountsCreditMemoIcon size={14} />,
      label: "Credit Memo",
      isAccessible: access.creditMemoIsAccessible &&  (access.isVersion_1 || access.isVersion_2),
      directRoute: true,
      directKey:"creditMemo",
      items: [],
    },
     CreditMemo_v2: {
      icon: <AccountsCreditMemoIcon size={14} />,
      label: "Credit Memo",
      isAccessible: access.creditMemoIsAccessible &&  access.isVersion_3,
      directRoute: true,
      directKey: 
        "creditMemo_v3"
       ,
      items: [],
    },

    CheckTransaction: {
      icon: <AccountsCheckTransitionIcon size={14} />,
      label: "Check Transaction",
      isAccessible: access.checkTransactionIsAccessible&&  (access.isVersion_1 || access.isVersion_2),
      directRoute: true,
      directKey:"checkTransaction",
      items: [],
    },
     CheckTransaction_v2: {
      icon: <AccountsCheckTransitionIcon size={14} />,
      label: "Check Transaction",
      isAccessible: access.checkTransactionIsAccessible &&  access.isVersion_3,
      directRoute: true,
      directKey:
        "checkTransaction_v3"
        ,
      items: [],
    },

    BatchCheckTransaction: {
      icon: <AccountsBatchCheckTransitionIcon size={14} />,
      label: "Batch Check Transaction",
      isAccessible: access.batchCheckTransactionModuleIsAccessible,
      directRoute: true,
      directKey: "batchCheckTransaction",
      items: [],
    },

    BankAdjustment: {
      icon: <AccountsBankAdjustmentIcon size={14} />,
      label: "Bank Adjustment",
      isAccessible: access.bankAdjustmentIsAccessible,
      directRoute: true,
      directKey: "bankAdjustment",
      items: [],
    },

    Deposit: {
      icon: <AccountsDepositIcon size={14} />,
      label: "Deposit",
      isAccessible: access.depositIsAccessible,
      directRoute: true,
      directKey: "deposit",
      items: [],
    },

    LetterOfCredit: {
      icon: <AccountsLetterOfCreditIcon size={14} />,
      label: "Letter Of Credit",
      isAccessible: access.locIsAccessible,
      directRoute: true,
      directKey: "letterOfCredits",
      items: [],
    },

    CheckBounce: {
      icon: <AccountsCheckBounceIcon size={14} />,
      label: "Check Bounce",
      isAccessible: access.checkBounceIsAccessible,
      directRoute: true,
      directKey: "checkBounce",
      items: [],
    },

    CustomerReturn: {
      icon: <AccountsCustomerReturnIcon size={14} />,
      label: "Customer Return",
      isAccessible: access.customerReturnIsAcessible,
      directRoute: true,
      directKey: "customerReturn",
      items: [],
    },

    PostDatedCheckEntry: {
      icon: <AccountsPostDatedCheckEntryIcon size={14} />,
      label: "Post Dated Check Entry",
      isAccessible: access.postDatedCheckEntryIsAccessible,
      directRoute: true,
      directKey: "postDatedCheckEntry",
      items: [],
    },
  },
},

 

  // ========== LOGISTICS MODULE ==========
  Logistics: {
    icon: <RiTruckFill size={18} />,
    isAccessible: access.logisticModuleIsAccessible 
    && access.is3PL,
    subMenus: {
      logesticOrder: {
      icon: <InboundOrderIcon size={14} />,
      label: "InBound Order",
      isAccessible: access.logisticOrderAccessible,
      directRoute: true,
      directKey: "logesticOrder",
      items: [],
    },
    logesticReceipt: {
      icon: <InboundReceiptIcon size={14} />,
      label: "InBound Receipt",
      isAccessible: access.logisticReceiptAccessible,
      directRoute: true,
      directKey: "logesticReceipt",
      items: [],
    },
    palletBarCodeGeneratorModule: {
      icon: <InboundReceiptIcon size={14} />,
      label: " Pallet BarCode Generator",
      isAccessible: access.palletBarCodeGeneratorModuleIsAccessible&& access.is3PL,
      directRoute: true,
      directKey: "palletBarCodeGenerator",
      items: [],
    },
      
    }
  },

  // ========== INVENTORY MODULE ==========
  

  Inventory: {
  icon: <RiBarChartBoxFill size={18} />,
  isAccessible: access.inventoryModuleIsAccessible,

  subMenus: {
    // INVENTORY ADJUSTMENT
    InventoryAdjustment: {
      icon: <InventoryAdjustmentIcon size={14} />,
      label: "Inventory Adjustment",
      isAccessible:
        access.inventoryAdjustmentIsAccessible &&
        (access.isVersion_1 || access.isVersion_2),
      directRoute: true,
      directKey: "inventoryAdjustment",
      items: [],
    },

    InventoryAdjustment_v3: {
      icon: <InventoryAdjustmentIcon size={14} />,
      label: "Inventory Adjustment",
      isAccessible:
        access.inventoryAdjustmentIsAccessible &&
        access.isVersion_3,
      directRoute: true,
      directKey: "inventoryAdjustment_v3",
      items: [],
    },

    // INVENTORY TRANSFER
    InventoryTransfer: {
      icon: <InventoryTransferIcon size={14} />,
      label: "Inventory Transfer",
      isAccessible:
        access.inventoryTransferIsAccessible &&
        (access.isVersion_1 || access.isVersion_2),
      directRoute: true,
      directKey: "inventoryTransfer",
      items: [],
    },

    InventoryTransfer_v3: {
      icon: <InventoryTransferIcon size={14} />,
      label: "Inventory Transfer",
      isAccessible:
        access.inventoryTransferIsAccessible &&
        access.isVersion_3,
      directRoute: true,
      directKey: "inventoryTransfer_v3",
      items: [],
    },

    // COMMON (ALL VERSIONS)
    PrintRoll: {
      icon: <InventoryPrintRollIcon size={14} />,
      label: "Print Roll",
      isAccessible: access.printRollIsAccessible,
      directRoute: true,
      directKey: "printRoll",
      items: [],
    },

    PrintPOInTransitRoll: {
      icon: <InventoryPrintPOIntransitRollIcon size={14} />,
      label: "Print PO InTransit Roll",
      isAccessible: access.printPOInTransitRollIsAccessible,
      directRoute: true,
      directKey: "printPOInTransitRoll",
      items: [],
    },

    MassInventoryTransfer: {
      icon: <InventoryMassInventoryTransferIcon size={14} />,
      label: "Mass Inventory Transfer",
      isAccessible: access.massInventoryTransferIsAccessible,
      directRoute: true,
      directKey: "massInventoryTransfer",
      items: [],
    },

    PhysicalInventoryAdjustments: {
      icon: <InventoryPhysicalInvAdjustmentsIcon size={14} />,
      label: "Physical Inv Adjustments",
      isAccessible: access.physicalInventoryAdjustmentsIsAccessible,
      directRoute: true,
      directKey: "physicalInvAdjustments",
      items: [],
    },

    RollInventoryMaintenance: {
      icon: <InventoryRollInventoryMainteranceIcon size={14} />,
      label: "Roll Inventory Maintenance",
      isAccessible: access.rollInventoryIsAccessible,
      directRoute: true,
      directKey: "rollInventory",
      items: [],
    },

    ManualInventoryAllocation: {
      icon: <InventoryManualInventoryAllocationIcon size={14} />,
      label: "Manual Inventory Allocation",
      isAccessible: access.manualInventoryAllocationIsAccessible,
      directRoute: true,
      directKey: "manualInvAllocation",
      items: [],
    },

    RollDataConversion: {
      icon: <InventoryRollDataConversionIcon size={14} />,
      label: "Roll Data Conversion",
      isAccessible: access.rollDataConversionIsAccessible,
      directRoute: true,
      directKey: "rollDataConversion",
      items: [],
    },
  },
},


  // ========== JOBS MODULE ==========
  
 Job: {
  icon: <RiSettings3Fill size={18} />,
  isAccessible: access.JobModuleIsAccessible,
  subMenus: {

    WebItemExport: {
      icon: <JobWebItemExportIcon size={14} />,
      label: "Web Item Export",
      isAccessible: access.WebItemExportIsAccessible,
      directRoute: true,
      directKey: "webItemExport",
      items: [],
    },

    WebItemImport: {
      icon: <JobWebItemImportIcon size={14} />,
      label: "Web Item Import",
      isAccessible: access.WebItemImportIsAccessible,
      directRoute: true,
      directKey: "webItemImport",
      items: [],
    },

    WebSKUInventoryExport: {
      icon: <JobWebSKUInventoryReprortIcon size={14} />,
      label: "Web SKU Inventory Export",
      isAccessible: access.WebSKUInventoryExportIsAccessible,
      directRoute: true,
      directKey: "webSkuInventoryExport",
      items: [],
    },

    EcomJobStatus: {
      icon: <JobEcommJobStatusIcon size={14} />,
      label: "Ecom Job Status",
      isAccessible: access.ecomJobStatusDetailsIsAccessible,
      directRoute: true,
      directKey: "ecomJobStatusDetails",
      items: [],
    },

    EcomWebOrderStatus: {
      icon: <JobEcommWebOrderStatusIcon size={14} />,
      label: "Ecom Web Order Status",
      isAccessible: access.ecomWebOrderStatusDetailsIsAccessible,
      directRoute: true,
      directKey: "ecomWebOrderStatusDetails",
      items: [],
    },

    WebItemExcelToERPImport: {
      icon: <JobWebItemExcelToERPImportIcon size={14} />,
      label: "Web Item Excel to ERP Import",
      isAccessible: access.webItemExcelToERPImportIsAcessible,
      directRoute: true,
      directKey: "webItemExcelToERP",
      items: [],
    },

  },
},
 


  // ========== INQUIRY MODULE ==========
  
  Inquiry: {
  icon: <RiSearchEyeFill size={18} />,
  isAccessible: access.inquiryIsAccessible,
  subMenus: {

    // ── ATS ──
    fabricAts_v1: {
      icon: <InquiryAllItemATSIcon size={14} />,
      label: access.is3PL ? "All Item ATS" : "All Fabric ATS",
      isAccessible: access.allFabricAtsIsAccessible && access.isVersion_1,
      directRoute: true,
      directKey: "fabricAts",
      items: [],
    },
    fabricAts_v2: {
      icon: <InquiryAllItemATSIcon size={14} />,
      label: "All Fabric ATS",
      isAccessible: access.allFabricAtsIsAccessible && access.isVersion_2,
      directRoute: true,
      directKey: "fabricAts_v2",
      items: [],
    },
    fabricAts_v3: {
      icon: <InquiryAllItemATSIcon size={14} />,
      label: "All Fabric ATS",
      isAccessible: access.allFabricAtsIsAccessible && access.isVersion_3,
      directRoute: true,
      directKey: "fabricAts_v3",
      items: [],
    },

    allCustomerAts_v1: {
      icon: <InquiryAllItemCustomInquiryIcon size={14} />,
      label: access.is3PL ? "All Item Customer ATS Inquiry" : "All Fabric Customer ATS Inquiry",
      isAccessible: access.allFabricCustomerATSIsAccessible && access.isVersion_1,
      directRoute: true,
      directKey: "allCustomerAts",
      items: [],
    },
    allCustomerAts_v2: {
      icon: <InquiryAllItemCustomInquiryIcon size={14} />,
      label: access.is3PL ? "All Item Customer ATS Inquiry" : "All Fabric Customer ATS Inquiry",
      isAccessible: access.allFabricCustomerATSIsAccessible && access.isVersion_2,
      directRoute: true,
      directKey: "allCustomerAts_v2",
      items: [],
    },

    customerAts_v1: {
      icon: <InquiryCustomerItemATSInquiryIcon size={14} />,
      label: access.is3PL ? "Customer Item ATS Inquiry" : "Customer Fabric ATS Inquiry",
      isAccessible: access.customerFabricsATSIsAccessible && access.isVersion_1,
      directRoute: true,
      directKey: "customerAts",
      items: [],
    },
    customerAts_v2: {
      icon: <InquiryCustomerItemATSInquiryIcon size={14} />,
      label: "Customer Fabric ATS Inquiry",
      isAccessible: access.customerFabricsATSIsAccessible && access.isVersion_2,
      directRoute: true,
      directKey: "customerAts_v2",
      items: [],
    },

    FabricWeeklyMonthly: {
      icon: <InquiryItemWeeklyMonthlyATSIcon size={14} />,
      label: access.is3PL ? "Item Weekly Monthly ATS" : "Fabric Weekly Monthly ATS",
      isAccessible: access.fabricWeeklyMonthlyAtsIsAccessible,
      directRoute: true,
      directKey: "FabricWeeklyMonthly",
      items: [],
    },

    fabricStatistics: {
      icon: <InquiryItemStatisticsIcon size={14} />,
      label: access.is3PL ? "Item Statistics" : "Fabric Statistics",
      isAccessible: access.fabricStatisticsIsAccessible,
      directRoute: true,
      directKey: "fabricStatistics",
      items: [],
    },

    printOutTrackInquiry: {
      icon: <InquiryPrintoutTrackInquiryIcon size={14} />,
      label: "Print Out Track Inquiry",
      isAccessible: access.printOutTrackInquiryIsAccessible,
      directRoute: true,
      directKey: "printOutTrackInquiry",
      items: [],
    },

    fabricStylePriceListPriceCostInquiry: {
      icon: <InquiryItemListWithPriceAndCostIcon size={14} />,
      label: access.is3PL
        ? "Item List With Price and Cost Inquiry"
        : "Fabric Style List With Price and Cost Inquiry",
      isAccessible: access.fabricStylePriceListPriceCostInquiryIsAccessible,
      directRoute: true,
      directKey: "fabricStylePriceListPriceCostInquiry",
      items: [],
    },

    mailTrack: {
      icon: <InquiryMailTrackIcon size={14} />,
      label: "Mail Track Inquiry",
      isAccessible: access.mailTrackIsAccessible,
      directRoute: true,
      directKey: "mailTrack",
      items: [],
    },

    
    fabricCatalog: {
      icon: <FabricCatalogGenerationIcon size={14} />,
      label: "FabricCatalogGeneration",
      isAccessible: access.fabricCatalogIsAccessible,
      directRoute: true,
      directKey: "fabricCatalog",
      items: [],
    },
    // track: {
    //   icon: <InquiryMailTrackIcon size={14} />,
    //   label: "Track Inquiry",
    //   isAccessible: access.trackIsAccessible,
    //   directRoute: true,
    //   directKey: "track",
    //   items: [],
    // },

    // ── OnOrder ──
    OnOrder: {
      icon: <InquiryOnOrderIcon size={14} />,
      isAccessible: access.onOrderInquiryIsAccessible,
      items: [
        { key: "customerOnOrder",    label: "Customer On Order Inquiry", isAccessible: access.customerOnOrderInquiryIsAccessible && access.isVersion_1, icon: <InquiryOnOrderIcon /> },
        { key: "customerOnOrder_v2", label: "Customer On Order Inquiry", isAccessible: access.customerOnOrderInquiryIsAccessible && access.isVersion_2, icon: <InquiryOnOrderIcon /> },
        { key: "customerOnOrder_v3", label: "Customer On Order Inquiry", isAccessible: access.customerOnOrderInquiryIsAccessible && access.isVersion_3, icon: <InquiryOnOrderIcon /> },
        { key: "vendorOnOrder",      label: "Vendor On Order Inquiry",   isAccessible: access.vendorOnOrderInquiryIsAccessible && access.isVersion_1,   icon: <InquiryOnOrderIcon /> },
        { key: "vendorOnOrder_v2",   label: "Vendor On Order Inquiry",   isAccessible: access.vendorOnOrderInquiryIsAccessible && access.isVersion_2,   icon: <InquiryOnOrderIcon /> },
        { key: "vendorOnOrder_v3",   label: "Vendor On Order Inquiry",   isAccessible: access.vendorOnOrderInquiryIsAccessible && access.isVersion_3,   icon: <InquiryOnOrderIcon /> },
        { key: "fabricOnOrder",      label: access.is3PL ? "Item On Order Inquiry" : "Fabric On Order Inquiry", isAccessible: access.fabricOnOrderInquiryIsAccessible, icon: <InquiryOnOrderIcon /> },
        { key: "custServiceSO",      label: "Customer Service SalesOrder", isAccessible: access.customerServiceSalesOrderInquiryIsAccessible && (access.isVersion_1 || access.isVersion_2), icon: <InquiryOnOrderIcon /> },
        { key: "custServiceSO_v3",   label: "Customer Service SalesOrder", isAccessible: access.customerServiceSalesOrderInquiryIsAccessible && access.isVersion_3, icon: <InquiryOnOrderIcon /> },
      ],
    },

    // ── Sales ──
    SalesInquiry: {
      icon: <InquirySalesIcon size={14} />,
      isAccessible: access.salesInquiryIsAccessible,
      items: [
        { key: "salesYearly",    label: "Sales Yearly Inquiry",   isAccessible: access.salesYearlyInquiryIsAccessible && (access.isVersion_1), icon: <InquirySalesIcon /> },
        { key: "customerSalesDetails",    label: "Customer Sales Details Inquiry",   isAccessible: access.customerSalesDetailsInquiryIsAccessible && (access.isVersion_1 || access.isVersion_2), icon: <InquirySalesIcon /> },
        { key: "customerSalesDetails_v3", label: "Customer Sales Details Inquiry",   isAccessible: access.customerSalesDetailsInquiryIsAccessible && access.isVersion_3,                         icon: <InquirySalesIcon /> },
        { key: "salesServiceDetails",     label: "Sales Service Report Details",     isAccessible: access.salesServiceReportDetailsInquiryIsAccessible && access.is3PL,                          icon: <InquirySalesIcon /> },
        { key: "salesAndPurchaseInq",     label: "Sales And Purchase Details Inquiry", isAccessible: access.salesAndPurchaseDetailsInquiryIsAccessible && !access.is3PL,                         icon: <InquirySalesIcon /> },
        { key: "salesCommodityDetails",   label: "Sales Commodity Report Details",   isAccessible: access.salesCommodityReportDetailsInquiryIsAccessible && access.is3PL,                        icon: <InquirySalesIcon /> },
        { key: "salesPrice",              label: "Sales Price Inquiry",              isAccessible: access.salesPriceInquiryIsAccessible,                                                          icon: <InquirySalesIcon /> },
        { key: "customerSalesOrderAndInvoiceDetailReportInquiry", label: "Customer SalesOrder And Invoice Detail Report", isAccessible: access.customerSalesOrderAndInvoiceDetailReportInquiryIsAccessible, icon: <InquirySalesIcon /> },
        { key: "mostRecentCustomerSalesDetailInquiry", label: "Most Recent Customer Sales Details Inquiry", isAccessible: access.mostRecentCustomerSalesDetailInquiryIsAccessible, icon: <InquirySalesIcon /> },
        { key: "invoiceFabricStyleYearly", label: access.is3PL ? "Invoice Item Yearly Inquiry" : "Invoice FabricStyle Yearly Inquiry", isAccessible: access.invoicFabricStyleYearlyInquiryIsAccessible, icon: <InquirySalesIcon /> },
        { key: "invoiceRegister",          label: "Invoice Register Inquiry",        isAccessible: access.invoiceRegisterInquiryIsAccessible && access.isVersion_1,   icon: <InquirySalesIcon /> },
        { key: "invoiceRegister_v2",       label: "Invoice Register Inquiry",        isAccessible: access.invoiceRegisterInquiryIsAccessible && access.isVersion_2,   icon: <InquirySalesIcon /> },
        { key: "invoiceRegister_v3",       label: "Invoice Register Inquiry",        isAccessible: access.invoiceRegisterInquiryIsAccessible && access.isVersion_3,   icon: <InquirySalesIcon /> },
        { key: "salesOrderRegister",       label: "SalesOrder Register Inquiry",     isAccessible: access.salesOrderRegisterInquiryIsAccessible && (access.isVersion_1 || access.isVersion_2),  icon: <InquirySalesIcon /> },
        { key: "salesOrderRegister_v3",    label: "SalesOrder Register Inquiry",     isAccessible: access.salesOrderRegisterInquiryIsAccessible && access.isVersion_3, icon: <InquirySalesIcon /> },
        { key: "salesBackOrder",           label: "Sales BackOrder Inquiry",         isAccessible: access.salesBackOrderInquiryIsAccessible,                          icon: <InquirySalesIcon /> },
        { key: "customerService",          label: "Customer Service Inquiry",        isAccessible: access.CustomerServiceInquiry_IsAccessible && (access.isVersion_1 || access.isVersion_2),    icon: <InquirySalesIcon /> },
        { key: "customerService_v3",       label: "Customer Service Inquiry",        isAccessible: access.CustomerServiceInquiry_IsAccessible && access.isVersion_3,  icon: <InquirySalesIcon /> },
        { key: "pickedAndNotInvoiced",     label: "Picked And Not Invoiced List Inquiry", isAccessible: access.pickedAndNotInvoicedListInquiry_IsAccessible,          icon: <InquirySalesIcon /> },
        { key: "invoicedAndNotApproved",   label: "Invoiced And Not Approved List Inquiry", isAccessible: access.invoicedAndNotApprovedListInquiry_IsAccessible,      icon: <InquirySalesIcon /> },
        { key: "upsPickupSummary",         label: "UPS Pickup Summary Inquiry",      isAccessible: access.upsPickupSummaryInquiry_IsAccessible,                       icon: <InquirySalesIcon /> },
        { key: "openPickTicket",           label: "Open PickTicket Inquiry",         isAccessible: access.openPickTicketInquiry_IsAcessible,                          icon: <InquirySalesIcon /> },
        { key: "PickTicketPicker",         label: "PickTicket Picker Details",       isAccessible: access.pickTicketPickerDetailInquiry_isAcessible,                  icon: <InquirySalesIcon /> },
        { key: "pickedAndShippedList",     label: "Picked And Shipped List Inquiry", isAccessible: access.pickedAndShippedListInquiry_IsAcessible,                    icon: <InquirySalesIcon /> },
        { key: "salesOrderRegisterDetailsInquiry", label: "SalesOrder Register Details", isAccessible: access.salesOrderRegisterDetailsInquiry_IsAcessible,          icon: <InquirySalesIcon /> },
        { key: "salesOrderCancelDetails",  label: "SalesOrder Cancel Details",       isAccessible: access.salesOrderCancelDetailsInquiry_isAcessible,                 icon: <InquirySalesIcon /> },
        { key: "bookingReport",            label: "Booking Report Inquiry",          isAccessible: access.bookingReportInquiry_IsAcessible,                           icon: <InquirySalesIcon /> },
        { key: "shippingReport",           label: "Shipping Report Inquiry",         isAccessible: access.shippingReportInquiry_IsAcessible,                          icon: <InquirySalesIcon /> },
        { key: "salesPersonCommision",     label: "SalesPerson Commission Inquiry",  isAccessible: access.salesPersonCommisionInquiry_IsAcessble,                     icon: <InquirySalesIcon /> },
        { key: "returnSalesPersonCommision", label: "Return SalesPerson Commission Inquiry", isAccessible: access.returnSalesPersonCommissionInquiry_IsAcessible,    icon: <InquirySalesIcon /> },
        { key: "customerAndFabricSales",   label: access.is3PL ? "Customer And Item Sales Inquiry" : "Customer And Fabric Sales Inquiry", isAccessible: access.customerAndFabricSalesInquiry_IsAcessible, icon: <InquirySalesIcon /> },
      ],
    },

    // ── Sales Analysis ──
    SalesAnalysis: {
      icon: <InquirySalesAnaysisIcon size={14} />,
      isAccessible: access.salesAndAnalysisInquiryIsAccessible,
      items: [
        { key: "fabricStyleSales",       label: access.is3PL ? "Item Sales Inquiry" : "FabricStyle Sales Inquiry", isAccessible: access.fabricStyleSalesInquiryIsAccessible,         icon: <InquirySalesAnaysisIcon /> },
        { key: "salesOrderStatus",       label: "SalesOrder Status Inquiry",      isAccessible: access.salesOrderInquiryIsAccessible,                    icon: <InquirySalesAnaysisIcon /> },
        { key: "salesAnalysis",          label: "Sales Analysis Inquiry",         isAccessible: access.salesAnalysisInquiryIsAccessible,                 icon: <InquirySalesAnaysisIcon /> },
        { key: "customerSalesAnalysis",  label: "Customer Sales Analysis Inquiry", isAccessible: access.customerSalesAnalysisInquiryIsAccessible,        icon: <InquirySalesAnaysisIcon /> },
        { key: "fiscalYearBooking",      label: "Fiscal Year Booking Inquiry",    isAccessible: access.FiscalYearBookingInquiryIsAccessible,              icon: <InquirySalesAnaysisIcon /> },
        { key: "fabricStyleYearly",      label: access.is3PL ? "Item Yearly Inquiry" : "FabricStyle Yearly Inquiry", isAccessible: access.FabricStyleYearlyInquiryIsAccessible, icon: <InquirySalesAnaysisIcon /> },
        { key: "yearlySalesAnalysis",    label: "Yearly SalesAnalysis Inquiry",   isAccessible: access.yearlySalesAnalysisInquiryIsAccessible,           icon: <InquirySalesAnaysisIcon /> },
      ],
    },

    // ── CPM Inquiry ──
    CPMInquiry: {
      icon: <InquiryCPMIcon size={14} />,
      isAccessible: access.cpmInquiryIsAccessible,
      items: [
        { key: "cpmInq", label: "CPM Report Details", isAccessible: access.cpmReportInquiryIsAccessible, icon: <InquiryCPMIcon /> },
      ],
    },

    // ── Purchase ──
    PurchaseInquiry: {
      icon: <InquiryPurchaseIcon size={14} />,
      isAccessible: access.purchaseInquiryIsAccessible,
      items: [
        { key: "poUnApprovedInfo",                    label: "PO UnApproved Info",                                                          isAccessible: access.poUnApprovedInfoInquiryIsAccessible,                    icon: <InquiryPurchaseIcon /> },
        { key: "fabricStylePurchaseHistory",   label: access.is3PL ? "Item Purchase History" : "FabricStyle Purchase History",       isAccessible: access.fabricStylePurchaseHistoryInquiryIsAccessible,          icon: <InquiryPurchaseIcon /> },
        { key: "poInTransitInfo",                     label: "Purchase InTransit Info Inquiry",                                             isAccessible: access.poInTransitInfoInquiryIsAccessible,                     icon: <InquiryPurchaseIcon /> },
        { key: "poReceiptDetails",                    label: "PurchaseOrder Receipt Details Inquiry",                                       isAccessible: access.purchaseOrderReceiptDetailsInquiryIsAccessible,          icon: <InquiryPurchaseIcon /> },
        { key: "receiptRollBinDetails",               label: "Receipt Roll Bin Details Inquiry",                                            isAccessible: access.receiptRollBinDetailsInquiryIsAccessible,               icon: <InquiryPurchaseIcon /> },
        { key: "latePurchaseOrderDetails",            label: "Late PurchaseOrder Details Inquiry",                                          isAccessible: access.latePurchaseOrderDetailsInquiryIsAccessible,            icon: <InquiryPurchaseIcon /> },
        { key: "fabricStylesReceivedDetails",         label: access.is3PL ? "Items Received Details Inquiry" : "FabricStyles Received Details Inquiry", isAccessible: access.fabricStylesReceivedDetailsInquiryIsAccessible, icon: <InquiryPurchaseIcon /> },
      ],
    },

    // ── Accounts ──
    AccountsInquiry: {
      icon: <InquiryAccountsIcon size={14} />,
      isAccessible: access.accountsInquiryMeuIsAccessible,
      items: [
        { key: "customerTransaction",         label: "Customer Transaction",              isAccessible: access.customerTransactionInquiryIsAccessible,                                         icon: <InquiryAccountsIcon /> },
        { key: "customerBalance",             label: "Customer Balance",                  isAccessible: access.customerBalanceInquiryIsAccessible,                                             icon: <InquiryAccountsIcon /> },
        { key: "customerStatement",           label: "Customer Statement",                isAccessible: access.customerStatementInquiryIsAccessible,                                           icon: <InquiryAccountsIcon /> },
        { key: "creditMemoDetailsInquiry",    label: "CreditMemo Details Inquiry",        isAccessible: access.creditMemoDetailsInquiryIsAccessible,                                           icon: <InquiryAccountsIcon /> },
        { key: "bankBalance",                 label: "Bank Account Balance History",      isAccessible: access.bankBalanceInquiryIsAccessible,                                                 icon: <InquiryAccountsIcon /> },
        { key: "pastDueInvoice",              label: "PastDueInvoice With CCPayment",     isAccessible: access.pastDueInvoiceWithCCPaymentInquiryIsAccessible,                                 icon: <InquiryAccountsIcon /> },
        { key: "customerAging",               label: "Customer Current Aging",            isAccessible: access.customerCurrentAgingInquiryIsAccessible && (access.isVersion_1 || access.isVersion_2), icon: <InquiryAccountsIcon /> },
        { key: "customerAging_v3",            label: "Customer Current Aging",            isAccessible: access.customerCurrentAgingInquiryIsAccessible && access.isVersion_3,                 icon: <InquiryAccountsIcon /> },
        { key: "allCustomerOnlineAging",      label: "All Customer Online Aging",         isAccessible: access.allCustomerOnlineAgingInquiryIsAccessible && (access.isVersion_1 || access.isVersion_2), icon: <InquiryAccountsIcon /> },
        { key: "allCustomerOnlineAging_v3",   label: "All Customer Online Aging",         isAccessible: access.allCustomerOnlineAgingInquiryIsAccessible && access.isVersion_3,               icon: <InquiryAccountsIcon /> },
        { key: "salesPersonCurrentAging",     label: "SalesPerson Current Aging",         isAccessible: access.salesPersonCurrentAgingInquiryIsAccessible,                                     icon: <InquiryAccountsIcon /> },
      ],
    },

    // ── Payment History ──
    PaymentHistory: {
      icon: <InquiryPaymentHistoryIcon size={14} />,
      isAccessible: access.paymentHistoryInquiryMenuIsAccessible,
      items: [
        { key: "postedARDayRegister",                      label: "Posted AR Day Register",                   isAccessible: access.postedARDayRegisterInquiryIsAccessible,                      icon: <InquiryPaymentHistoryIcon /> },
        { key: "postedAndBouncedCheck",                    label: "Posted And Bounced Check",                 isAccessible: access.postedAndBouncedCheckInquiryIsAccessible,                    icon: <InquiryPaymentHistoryIcon /> },
        { key: "postedARCashPaymentRegister",       label: "Posted AR Cash Payment Register",          isAccessible: access.postedARCashPaymentRegisterInquiryIsAccessible,              icon: <InquiryPaymentHistoryIcon /> },
        { key: "postedARCardPaymentRegister",       label: "Posted AR Card Payment Register",          isAccessible: access.postedARCardPaymentRegisterInquiryIsAccessible,              icon: <InquiryPaymentHistoryIcon /> },
        { key: "postedARWireTransferPaymentRegister", label: "Posted AR Wire Transfer Payment Register", isAccessible: access.postedARWireTransferPaymentRegisterInquiryIsAccessible,  icon: <InquiryPaymentHistoryIcon /> },
        { key: "postedARCheckPaymentRegister",      label: "Posted AR Check Payment Register",         isAccessible: access.postedARCheckPaymentRegisterInquiryIsAccessible,            icon: <InquiryPaymentHistoryIcon /> },
        { key: "checkPaymentHistory",                      label: "Check Payment History",                    isAccessible: access.checkPaymentHistoryInquiryIsAccessible,                      icon: <InquiryPaymentHistoryIcon /> },
        { key: "cardPaymentHistory",                       label: "Card Payment History",                     isAccessible: access.cardPaymentHistoryInquiryIsAccessible,                       icon: <InquiryPaymentHistoryIcon /> },
        { key: "postedARACHPaymentRegister",        label: "Posted AR ACH Payment Register",           isAccessible: access.postedARACHPaymentRegisterInquiryIsAccessible,              icon: <InquiryPaymentHistoryIcon /> },
        { key: "achPaymentHistory",                        label: "ACH Payment History",                      isAccessible: access.achPaymentHistoryInquiryIsAccessible,                       icon: <InquiryPaymentHistoryIcon /> },
        { key: "wirePaymentHistory",                       label: "Wire Payment History",                     isAccessible: access.wirePaymentHistoryInquiryIsAccessible,                      icon: <InquiryPaymentHistoryIcon /> },
        { key: "bouncedCheck",                             label: "Bounced Check",                            isAccessible: access.bouncedCheckInquiryIsAccessible,                            icon: <InquiryPaymentHistoryIcon /> },
        { key: "unPostedARList",                           label: "UnPosted AR List",                         isAccessible: access.unPostedARListInquiryIsAccessible,                          icon: <InquiryPaymentHistoryIcon /> },
        { key: "creditMemoPaymentHistory",                 label: "CreditMemo PaymentHistory",                isAccessible: access.creditMemoPaymentHistoryInquiryIsAccessible,                icon: <InquiryPaymentHistoryIcon /> },
        { key: "CashPaymentActivities",                    label: "Cash Payment Activities",                  isAccessible: access.CashPaymentActivityInquiryIsAccessible,                     icon: <InquiryPaymentHistoryIcon /> },
        { key: "postDatedCheckDetail",                     label: "Post Dated Check Detail",                  isAccessible: access.PostDatedChecksDetailInquiryIsAccessible,                   icon: <InquiryPaymentHistoryIcon /> },
      ],
    },

    // ── Inventory ──
    InventoryInquiry: {
      icon: <InquiryInventoryIcon size={14} />,
      isAccessible: access.inventoryInquiryIsAccessible,
      items: [
        { key: "lotBasedInventoryInOut",              label: "Lot Based Inventory In/Out",               isAccessible: access.lotBasedInventoryInOutInquiryIsAccessible && access.isStandard,                                           icon: <InquiryInventoryIcon /> },
        { key: "dailyInventorys",                     label: "Daily Inventory Track",                    isAccessible: access.dailyInventoryTrackMaintenanceIsAccessible,                                                               icon: <InquiryInventoryIcon /> },
        { key: "dailyInventoryProcess",               label: "Daily Inventory Process Track Detail",     isAccessible: access.dailyInventoryProcessTrackDetailInquiry,                                                                  icon: <InquiryInventoryIcon /> },
        { key: "webInventory",                        label: "Web Inventory",                            isAccessible: access.webInventoryMaintenanceIsAccessible && !access.is3PL,                                                    icon: <InquiryInventoryIcon /> },
        { key: "rollingInventoryReport",              label: "Rolling Inventory Report Details",         isAccessible: access.rollingInventoryReportDetailsInquiryIsAccessible && access.is3PL,                                        icon: <InquiryInventoryIcon /> },
        { key: "binInventory",                        label: "Bin Inventory",                            isAccessible: access.binLocationInventoryInquiryIsAccessible,                                                                  icon: <InquiryInventoryIcon /> },
        { key: "inventoryBinSummary",                 label: "Inventory Bin Summary",                    isAccessible: access.inventoryBinSummaryInquiryIsAccessible && access.isVersion_1 && !access.is3PL,                           icon: <InquiryInventoryIcon /> },
        { key: "inventoryBinSummary_v2",              label: "Inventory Bin Summary",                    isAccessible: access.inventoryBinSummaryInquiryIsAccessible && access.isVersion_2,                                            icon: <InquiryInventoryIcon /> },
        { key: "skuInventoryLotBased",                label: "SKU Inventory Lot Based",                  isAccessible: access.skuInventoryLotBasedInquiryIsAccessible,                                                                  icon: <InquiryInventoryIcon /> },
        { key: "skuBatchInventory",                   label: "SKU Batch Inventory",                      isAccessible: access.skuBatchInventoryInquiryIsAccessible && access.isVersion_1,                                              icon: <InquiryInventoryIcon /> },
        { key: "skuBatchInventory_v2",                label: "SKU Batch Inventory",                      isAccessible: access.skuBatchInventoryInquiryIsAccessible && access.isVersion_2,                                              icon: <InquiryInventoryIcon /> },
        { key: "skuBatchInventory_v3",                label: "SKU Batch Inventory",                      isAccessible: access.skuBatchInventoryInquiryIsAccessible && access.isVersion_3,                                              icon: <InquiryInventoryIcon /> },
        { key: "skuInventoryTrack",                   label: "SKU Inventory Track",                      isAccessible: access.skuInventoryTrackInquiryIsAccessible && !access.is3PL && !access.isStandard,                             icon: <InquiryInventoryIcon /> },
        { key: "skuBatchInventoryTrack",              label: "SKU Batch Inventory Track",                isAccessible: access.skuBatchInventoryTrackInquiryIsAccessible && (access.isVersion_1 || access.isVersion_2),                 icon: <InquiryInventoryIcon /> },
        { key: "skuBatchInventoryTrack_v3",           label: "SKU Batch Inventory Track",                isAccessible: access.skuBatchInventoryTrackInquiryIsAccessible && access.isVersion_3,                                         icon: <InquiryInventoryIcon /> },
        { key: "skuInventory",                        label: "SKU Inventory SKU Based",                  isAccessible: access.skuInventorySkuBasedInquiryIsAccessible && access.isVersion_1 && !access.is3PL && !access.isStandard,    icon: <InquiryInventoryIcon /> },
        { key: "skuInventory_v2",                     label: "SKU Inventory SKU Based",                  isAccessible: access.skuInventorySkuBasedInquiryIsAccessible && access.isVersion_2,                                           icon: <InquiryInventoryIcon /> },
        { key: "skuInventory_v3",                     label: "SKU Inventory SKU Based",                  isAccessible: access.skuInventorySkuBasedInquiryIsAccessible && access.isVersion_3,                                           icon: <InquiryInventoryIcon /> },
        { key: "obseleteInventory",                   label: "Obselete Inventory",                       isAccessible: access.obseleteInventoryInquiryIsAccessible && (access.isVersion_1 || access.isVersion_3),                      icon: <InquiryInventoryIcon /> },
        { key: "obseleteInventory_v2",                label: "Obselete Inventory",                       isAccessible: access.obseleteInventoryInquiryIsAccessible && access.isVersion_2,                                              icon: <InquiryInventoryIcon /> },
        { key: "physicalVerificationTrack",    label: "Physical Verification Track",              isAccessible: access.physicalVerificationTrackInquiryIsAcessible && access.isVersion_1,                                       icon: <InquiryInventoryIcon /> },
        { key: "physicalVerificationTrack_v3",        label: "Physical Verification Track",              isAccessible: access.physicalVerificationTrackInquiryIsAcessible && access.isVersion_3,                                       icon: <InquiryInventoryIcon /> },
        { key: "holdingWarehouseInventory",           label: "Holding WareHouse Inventory",              isAccessible: access.holdingWareHouseInventoryInquiryIsAccessible,                                                             icon: <InquiryInventoryIcon /> },
        { key: "fabricStyleInventoryValuation",       label: access.is3PL ? "Item Inventory Valuation Info" : "FabricStyle Inventory Valuation Info",  isAccessible: access.fabricStyleInventoryValuationInfosInquiryIsAcessible && access.isVersion_1, icon: <InquiryInventoryIcon /> },
        { key: "fabricStyleInventoryValuation_v2",    label: access.is3PL ? "Item Inventory Valuation Info" : "FabricStyle Inventory Valuation Info",  isAccessible: access.fabricStyleInventoryValuationInfosInquiryIsAcessible && access.isVersion_2, icon: <InquiryInventoryIcon /> },
        { key: "fabricStyleInventoryValuation_v3",    label: access.is3PL ? "Item Inventory Valuation Info" : "FabricStyle Inventory Valuation Info",  isAccessible: access.fabricStyleInventoryValuationInfosInquiryIsAcessible && access.isVersion_3, icon: <InquiryInventoryIcon /> },
        { key: "customerAllocationIntransitInfo",     label: "Customer Allocation Intransit Info",       isAccessible: access.customerAllocationIntransitInfoInquiryIsAccessible,                                                       icon: <InquiryInventoryIcon /> },
        { key: "inventoryAdjustmentHistory",          label: "Inventory Adjustment History",             isAccessible: access.inventoryAdjustmentHistoryInquiryIsAccessible,                                                           icon: <InquiryInventoryIcon /> },
      ],
    },

    // ── Summary Info ──
    SummaryInfo: {
      icon: <InquiryInfoIcon size={14} />,
      isAccessible: access.summaryInfoInquiryIsAccessible,
      items: [
        { key: "poSummaryInfo",            label: "PurchaseOrder Summary Info",         isAccessible: access.purchaseOrderSummaryInfoInquiryIsAccessible,        icon: <InquiryInfoIcon /> },
        { key: "invoiceSummaryInfo",       label: "Invoice Summary Info",               isAccessible: access.invoiceSummaryInfoInquiryIsAccessible,              icon: <InquiryInfoIcon /> },
        { key: "soSummaryInfo",            label: "SalesOrder Summary Info",            isAccessible: access.salesOrderSummaryInfoInquiryIsAccessible,           icon: <InquiryInfoIcon /> },
        { key: "pickTicketSummaryInfo",    label: "PickTicket Summary Info",            isAccessible: access.pickTicketSummaryInfoInquiryIsAccessible,           icon: <InquiryInfoIcon /> },
        { key: "prSummaryInfo",            label: "PurchaseOrder Receipt Summary Info", isAccessible: access.purchaseOrderReceiptSummaryInfoInquiryIsAccessible, icon: <InquiryInfoIcon /> },
        { key: "creditMemoSummaryInfo",    label: "CreditMemo Summary Info",            isAccessible: access.creditMemoSummaryInfoInquiryIsAccessible,           icon: <InquiryInfoIcon /> },
      ],
    },

    // ── Info List ──
    InfoList: {
      icon: <InquiryInfoIcon size={14} />,
      isAccessible: access.infoListInquiryIsAccessible,
      items: [
        { key: "fabricInfo",            label: access.is3PL ? "Item Info Inquiry" : "Fabric Info Inquiry",  isAccessible: access.fabricInfoInquiryIsAccessible,            icon: <InquiryInfoIcon /> },
        { key: "fabricStyleSKUDetails", label: access.is3PL ? "Item SKU" : "FabricStyle SKU",               isAccessible: access.fabricStyleSKUIsAccessible,               icon: <InquiryInfoIcon /> },
        { key: "customerInfo",          label: "Customer Info Inquiry",                                      isAccessible: access.customerInfoInquiryIsAccessible,          icon: <InquiryInfoIcon /> },
        { key: "vendorInfo",            label: "Vendor Info Inquiry",                                        isAccessible: access.vendorInfoInquiryIsAccessible,            icon: <InquiryInfoIcon /> },
        { key: "productAvailability",   label: "Product Availability Inquiry",                               isAccessible: access.productAvailabilityInquiryIsAccessible,   icon: <InquiryInfoIcon /> },
      ],
    },

    // ── Statistics ──
    Statistics: {
      icon: <InquiryStatisticsIcon size={14} />,
      isAccessible: access.statisticsInquiryIsAccessible,
      items: [
        { key: "customerStatistics",    label: "Customer Statistics",  isAccessible: access.customerStatisticsInquiryIsAccessible,                                           icon: <InquiryStatisticsIcon /> },
        { key: "vendorStatistics",      label: "Vendor Statistics",    isAccessible: access.vendorStatisticsInquiryIsAccessible && (access.isVersion_1 || access.isVersion_2), icon: <InquiryStatisticsIcon /> },
        { key: "vendorStatistics_v3",   label: "Vendor Statistics",    isAccessible: access.vendorStatisticsInquiryIsAccessible && access.isVersion_3,                      icon: <InquiryStatisticsIcon /> },
        { key: "fabricStatistics",      label: access.is3PL ? "Item Statistics" : "Fabric Statistics", isAccessible: access.fabricStatisticsIsAccessible,                  icon: <InquiryItemStatisticsIcon /> },
      ],
    },

    // ── Inbound (3PL only) ──
    InboundInquiry: {
      icon: <InquiryInboundIcon size={14} />,
   isAccessible: (access.LogisticsIsAccessible && access.is3PL),
      items: [
        { key: "inboundOpenOrderNotReceived", label: "Inbound OpenOrder Not Received Inquiry", isAccessible: access.inboundOpenOrderNotReceivedIsAccessible, icon: <InquiryInboundIcon /> },
        { key: "inboundReceiptNotInvoiced",   label: "Inbound Receipt Not Invoiced Inquiry",   isAccessible: access.inboundReceiptNotInvoicedIsAccessible,   icon: <InquiryInboundIcon /> },
      ],
    },

  },
},

  // ========== SECURITY MODULE ==========
  
  Security: {
  icon: <RiShieldUserFill size={18} />,
  isAccessible:
    access.securityModuleIsAccessible,

  subMenus: {

    UserMaintenance: {
      icon: <SecurityUserMaintenanceIcon size={14} />,
      label: "User Maintenance",
      isAccessible: access.userMaintenanceIsAccessible,
      directRoute: true,
      directKey: "userMaintenance",
      items: [],
    },

    RoleMaintenance: {
      icon: <SecurityRoleMaintenanceIcon size={14} />,
      label: "Role Maintenance",
      isAccessible: access.roleMaintenanceIsAccessible,
      directRoute: true,
      directKey: "roleMaintenance",
      items: [],
    },

  },
},

  // ========== SYSTEM MODULE ==========
  
  System: {
  icon: <RiServerFill size={18} />,
  isAccessible:
    access.systemModuleIsAccessible,
   

  subMenus: {

    ReleaseLock: {
      icon: <SystemReleaseLockIcon size={14} />,
      label: "Release Lock",
      isAccessible: access.releaseLockIsAccessible,
      directRoute: true,
      directKey: "releaseLock",
      items: [],
    },

    RefreshCache: {
      icon: <SystemRefreshCacheIcon size={14} />,
      label: "Refresh Cache",
      directRoute: true,
      isAccessible: true,
      // action: "",   // 🔑 non-routing action
       action: "refreshCache_v1",   // 🔑 non-routing action
      items: [],
    },

  },
},

});


// ========== MAIN COMPONENT ==========
class AppStarter extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
       this.sidebarRef = React.createRef();
        this.topMenuRef = React.createRef();

    // Initialize empty - will be populated in componentDidMount
    this.mainMenus = {};

    this.state = {
      moduleList: [],
      userCode: "",
      selectedModuleKey: "",
      isVersion_1: true,
      isVersion_2: false,
      isVersion_3: false,
      appVersion: "",
      isShowbinLookup: false,
      is3PL: false,
      isStandard: false,
      isLoading: false,
      loadingText: "",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isSidebarOpen: false,
      isDropdownOpen: false,
      isActive: true,
      isInquiryOpen: false,
      isSalesOpen: false,
      isOpen: false,
      homeOpen: false,
      salesOpen: false,
      cpmOpen: false,
      overviewOpen: false,
      summaryOpen: false,
      generalOpen: false,
      openMenus: {},
      openSlideMenus: {},
      openSubMenus: {},
      width: false,
      activeSubmenu: null,
      flyoutOpen: false,
      flyoutTop: 0,
      openMainMenu: null,
      activeSubMenu: null,
      sidebarOpen:localStorage.getItem("sidebarOpen") === "true",
      showTop: false,
      showSide: false,
      isChangeMenu: localStorage.getItem("isChangeMenu") === "true",
      activeTopMenu: null,
      activeTopSubMenu: null,
      permissionsLoaded: false,
      permissions: null,
      activeMenuKey: null,
      activeSubMenu: null,
      flyoutItemRect: null,  // stores the clicked submenu item's rect at click-time
      searchQuery: "",
      searchResults: [],
      isSearchFocused: false,
      searchHighlightIndex: -1,
    };

    this.allModuleList = [];
    AllModuleList().map((m) => (this.allModuleList[m.key] = m));

    this.submenuRefs = {};
    this._tooltipHideTimer = null;
  }

  // ========== CALCULATE ALL PERMISSIONS IN ONE PLACE ==========
  calculatePermissions = () => {

    // ===========================
    // GENERAL ATTRIBUTES
    // ===========================
    const businessDivisionIsAccessible = SecurityAccessManager.BusinessDivisionMaintenance_IsAccessible();
    const uomIsAccessible = SecurityAccessManager.UomMaintenance_IsAccessible();
    const currencyIsAccessible = SecurityAccessManager.CurrencyMaintanance_IsAccessible();
    const styleIsAccessible = SecurityAccessManager.ProductTypeMaintenance_IsAccessible();
    const styleTypeIsAccessible = SecurityAccessManager.PatternTypeMaintenance_IsAccessible();
    const typeCategoryIsAccessible = SecurityAccessManager.TypeCategoryMaintenance_IsAccessible();
    const contentIsAccessible = SecurityAccessManager.MakeTypeMaintenance_IsAccessible();
    const productDivisionIsAccessible = SecurityAccessManager.ProductDivisionMaintenance_IsAccessible();
    const colorIsAccessible = SecurityAccessManager.ColorMaintenance_IsAccessible();
    const compositionTypeIsAccessible = SecurityAccessManager.CompositionTypeMaintenance_IsAccessible();
    const styleItemTypeIsAccessible = SecurityAccessManager.StyleItemTypeMaintenance_IsAccessible();
    const countryIsAccessible = SecurityAccessManager.CountryMaintenance_IsAccessible();
    const seasonIsAccessible = SecurityAccessManager.SeasonMaintenance_IsAccessible();
    const locationIsAccessible = SecurityAccessManager.LocationMaintenance_IsAccessible();
    const binLocationIsAccessible = SecurityAccessManager.BinLocationMaintenance_IsAccessible();
    const royaltyClientIsAccessible = SecurityAccessManager.RoyaltyClientMaintenance_IsAccessible();
    const inventoryAdjustmentReasonIsAccessible = SecurityAccessManager.InventoryAdjustmentReasonMaintenance_IsAccessible();
    const currencyExchangeRateIsAccessible = SecurityAccessManager.CurrencyExchangeRateMaintenance_IsAccessible();
    const employeeIsAccessible = SecurityAccessManager.EmployeeMaintanance_IsAccessible();
    const harmonizedTariffScheduleIsAccessible = SecurityAccessManager.HarmonizedTariffScheduleMaintenance_IsAccessible();
    const productStatusIsAccessible = SecurityAccessManager.ProductStatusMaintenance_IsAccessible();
    const fabricVendorMiscellaneousCostDetailIsAccessible = SecurityAccessManager.FabricVendorMiscellaneousCostDetailMaintenance_IsAccessible();
    const fiscalYearIsAccessible = SecurityAccessManager.FiscalYearMaintenance_IsAccessible();
    const commentIsAccessible = SecurityAccessManager.CommentMaintenance_IsAccessible();
    const shipToIsAccessible = SecurityAccessManager.ShipToMaintenance_IsAccessible();
    const serviceDetailsIsAccessible = SecurityAccessManager.serviceDetails_IsAccessible();
    const invoicePrintoutTypeIsAccessible = SecurityAccessManager.InvoicePrintoutType_IsAccessible();

    const generalAttributeIsAccessible =
      businessDivisionIsAccessible ||
      uomIsAccessible ||
      currencyIsAccessible ||
      styleIsAccessible ||
      styleTypeIsAccessible ||
      typeCategoryIsAccessible ||
      contentIsAccessible ||
      productDivisionIsAccessible ||
      colorIsAccessible ||
      compositionTypeIsAccessible ||
      styleItemTypeIsAccessible ||
      countryIsAccessible ||
      seasonIsAccessible ||
      locationIsAccessible ||
      binLocationIsAccessible ||
      royaltyClientIsAccessible ||
      inventoryAdjustmentReasonIsAccessible ||
      currencyExchangeRateIsAccessible ||
      employeeIsAccessible ||
      harmonizedTariffScheduleIsAccessible ||
      productStatusIsAccessible ||
      fabricVendorMiscellaneousCostDetailIsAccessible ||
      fiscalYearIsAccessible ||
      commentIsAccessible ||
      shipToIsAccessible ||
      serviceDetailsIsAccessible ||
      invoicePrintoutTypeIsAccessible;

    // ===========================
    // CUSTOMER ATTRIBUTES
    // ===========================
    const customerDivisionIsAccessible = SecurityAccessManager.CustomerDivisionMaintenance_IsAccessible();
    const cityIsAccessible = SecurityAccessManager.CityMaintenance_IsAccessible();
    const logisticMethodIsAccessible = SecurityAccessManager.LogisticMethodMaintenance_IsAccessible();
    const customerSpecialTypeIsAccessible = SecurityAccessManager.CustomerSpecialTypeMaintenance_IsAccessible();
    const customerTypesIsAccessible = SecurityAccessManager.CustomerTypeMaintenance_IsAccessible();
    const shipViaIsAccessible = SecurityAccessManager.ShipViaMaintenance_IsAccessible();
    const freightMethodIsAccessible = SecurityAccessManager.FreightMethodMaintenance_IsAccessible();
    const customerSalesZoneIsAccessible = SecurityAccessManager.CustomerSalesZoneMaintenance_IsAccessible();
    const boxTypeIsAccessible = SecurityAccessManager.BoxTypeMaintenance_IsAccessible();
    const paymentTermIsAccessible = SecurityAccessManager.PaymentTermMaintenance_IsAccessible();
    const stateIsAccessible = SecurityAccessManager.StateMaintenance_IsAccessible();
    const invoiceTemplateIsAccessible = SecurityAccessManager.InvoiceTemplateMaintenance_IsAccessible();
    const paymentMethodIsAccessible = SecurityAccessManager.PaymentMethodMaintenance_IsAccessible();
    const customerDeliveryIsAccessible = SecurityAccessManager.CustomerDeliveryMaintenance_IsAccessible();
    const invoiceCancelReasonIsAccessible = SecurityAccessManager.InvoiceCancelReasonMaintenance_IsAccessible();
    const invoiceUnApprovalReasonIsAccessible = SecurityAccessManager.InvoiceUnapprovalReasonMaintenance_IsAccessible();
    const invoiceNonMerchandiseReasonIsAccessible = SecurityAccessManager.InvoiceNonMerchandiseReasonMaintenance_IsAccessible();
    const periodSalesCommissionAdjustmentReasonIsAccessible = SecurityAccessManager.SalesCommissionAdjustmentReasonMaintenance_IsAccessible();
	const invoiceModelIsAccessible = SecurityAccessManager.InvoiceModelMaintenance_IsAccessible();


    const customerAttributeIsAccessible =
      customerDivisionIsAccessible ||
      cityIsAccessible ||
      logisticMethodIsAccessible ||
      customerSpecialTypeIsAccessible ||
      customerTypesIsAccessible ||
      shipViaIsAccessible ||
      freightMethodIsAccessible ||
      customerSalesZoneIsAccessible ||
      boxTypeIsAccessible ||
      paymentTermIsAccessible ||
      stateIsAccessible ||
      invoiceTemplateIsAccessible ||
      paymentMethodIsAccessible ||
      customerDeliveryIsAccessible ||
      invoiceCancelReasonIsAccessible ||
      invoiceUnApprovalReasonIsAccessible ||
      invoiceNonMerchandiseReasonIsAccessible ||
      periodSalesCommissionAdjustmentReasonIsAccessible ||
	  invoiceModelIsAccessible;	 

    // ===========================
    // VENDOR ATTRIBUTES
    // ===========================
    const vendorTypeIsAccessible = SecurityAccessManager.VendorTypeMaintenance_IsAccessible();
    const fobCityIsAccessible = SecurityAccessManager.FobCityMaintenance_IsAccessible();
    const incoTermIsAccessible = SecurityAccessManager.IncoTermMaintenance_IsAccessible();
    const vendorShipViaIsAccessible = SecurityAccessManager.VendorShipViaMaintenance_IsAccessible();
    const vendorTermIsAccessible = SecurityAccessManager.VendorTermMaintenance_IsAccessible();
    const shipmentTermIsAccessible = SecurityAccessManager.ShipmentTermMaintenance_IsAccessible();
    const vendorCategoryIsAccessible = SecurityAccessManager.VendorCategoryMaintenance_IsAccessible();
    const purchaseOrderCancelReasonIsAccessible = SecurityAccessManager.PurchaseOrderCancelReasonMaintenance_IsAccessible();
    const purchaseOrderUnApprovalReasonIsAccessible = SecurityAccessManager.PurchaseOrderUnApprovalReasonMaintenance_IsAccessible();
    const miscellaneousChargeReasonIsAccessible = SecurityAccessManager.MiscellaneousChargeReasonMaintenance_IsAccessible();
    const purchaseOrderModelIsAccessible = SecurityAccessManager.PurchaseOrderModelMaintenance_IsAccessible();

    const vendorAttributeIsAccessible =
      vendorTypeIsAccessible ||
      fobCityIsAccessible ||
      incoTermIsAccessible ||
      vendorShipViaIsAccessible ||
      vendorTermIsAccessible ||
      shipmentTermIsAccessible ||
      vendorCategoryIsAccessible ||
      purchaseOrderCancelReasonIsAccessible ||
      purchaseOrderUnApprovalReasonIsAccessible ||
      miscellaneousChargeReasonIsAccessible ||
      purchaseOrderModelIsAccessible;

    // ===========================
    // PRODUCTION ATTRIBUTES
    // ===========================
    const preProductionChangeReasonIsAccessible = SecurityAccessManager.PreProductionChangeReasonMaintenance_IsAccessible();
    const stageCollectionIsAccessible = SecurityAccessManager.StageCollectionMaintenance_IsAccessible();

    const productionAttributeIsAccessible =
      preProductionChangeReasonIsAccessible ||
      stageCollectionIsAccessible;

    // ===========================
    // ACCOUNT ATTRIBUTES
    // ===========================
    const generalLedgerAccountTypeIsAccessible = SecurityAccessManager.GeneralLedgerAccountTypeMaintenance_IsAccessible();
    const generalLedgerAccountIsAccessible = SecurityAccessManager.GeneralLedgerAccountMaintenance_IsAccessible();
    const accountReceivableDiscountIsAccessible = SecurityAccessManager.ArDiscountReasonMaintenance_IsAccessible();
    const customerTenderReasonIsAccessible = SecurityAccessManager.CustomerTenderReasonMaintenance_IsAccessible();
    const customerTenderCancelReasonIsAccessible = SecurityAccessManager.CustomerTenderCancelReasonMaintenance_IsAccessible();
    const customerTenderUnApprovalReasonIsAccessible = SecurityAccessManager.CustomerTenderUnapporveReasonMaintenance_IsAccessible();
    const accountReceivableReversalReasonIsAccessible = SecurityAccessManager.ArReversalReasonMaintenance_IsAccessible();
    const expenseTypeIsAccessible = SecurityAccessManager.ExpenseTypeMaintenance_IsAccessible();
    const expenseSubTypeIsAccessible = SecurityAccessManager.ExpenseSubTypeMaintenance_IsAccessible();
    const bankAdjustmentReasonIsAccessible = SecurityAccessManager.BankAdjustmentReasonMaintenance_IsAccessible();
    const depositCancelReasonIsAccessible = SecurityAccessManager.DepositCancelReasonMaintenance_IsAccessible();
    const depositReversalReasonIsAccessible = SecurityAccessManager.DepositReversalReasonMaintenance_IsAccessible();
    const bankAccountIsAccessible = SecurityAccessManager.BankAccountMaintenance_IsAccessible();

    const accountAttributeIsAccessible =
      generalLedgerAccountTypeIsAccessible ||
      generalLedgerAccountIsAccessible ||
      accountReceivableDiscountIsAccessible ||
      customerTenderReasonIsAccessible ||
      customerTenderCancelReasonIsAccessible ||
      customerTenderUnApprovalReasonIsAccessible ||
      accountReceivableReversalReasonIsAccessible ||
      expenseTypeIsAccessible ||
      expenseSubTypeIsAccessible ||
      bankAdjustmentReasonIsAccessible ||
      depositCancelReasonIsAccessible ||
      depositReversalReasonIsAccessible ||
      bankAccountIsAccessible;

    // ===========================
    // WEB ATTRIBUTES
    // ===========================
    const targetWebSiteDetailAttributeIsAccessible = SecurityAccessManager.TargetWebSiteDetail_IsAccessible();
    const webAttributeIsAccessible = targetWebSiteDetailAttributeIsAccessible;

    // ===========================
    // FABRIC ATTRIBUTES
    // ===========================
    const fabricConstructAccessible = SecurityAccessManager.FabricDetailMaintenance_IsAccessible();
    const designDirectionIsAccessible = SecurityAccessManager.FabricDetailDesignDirectionMaintenance_IsAccessible();
    const backedIsAccessible = SecurityAccessManager.FabricDetailBackedMaintenance_IsAccessible();
    const backedTypesIsAccessible = SecurityAccessManager.FabricDetailBakedTypesMaintenance_IsAccessible();
    const boundBackTypesIsAccessible = SecurityAccessManager.FabricDetailBoundBackTypesMaintenance_IsAccessible();
    const cardedOrCombedIsAccessible = SecurityAccessManager.FabricDetailcardedOrCombedMaintenance_IsAccessible();
    const fabricDetailsIsAccessible = SecurityAccessManager.FabricDetailFilingYarnsMaintenance_IsAccessible();
    const fillingYarnsTexturedIsAccessible = SecurityAccessManager.FabricDetailFillingYarnTexturedMaintenance_IsAccessible();
    const fillingYarnsTwistedIsAccessible = SecurityAccessManager.FabricDetailFillingYarnStwistedMaintenance_IsAccessible();
    const nappedIsAccessible = SecurityAccessManager.FabricDetailNappedMaintenance_IsAccessible();
    const printedIsAccessible = SecurityAccessManager.FabricDetailPrintedMaintenance_IsAccessible();
    const warpYarnsIsAccessible = SecurityAccessManager.FabricDetailWarpYarnsMaintenance_IsAccessible();
    const warpYarnsTexturedIsAccessible = SecurityAccessManager.FabricDetailWarpYarnsTexturedMaintenance_IsAccessible();
    const warpYarnsTwistedIsAccessible = SecurityAccessManager.FabricDetailWarpYarnsTwistedMaintenance_IsAccessible();
    const washedIsAccessible = SecurityAccessManager.FabricDetailWashedMaintenance_IsAccessible();

    const fabricDetailAttributeIsAccessible =
      fabricConstructAccessible ||
      designDirectionIsAccessible ||
      backedIsAccessible ||
      backedTypesIsAccessible ||
      boundBackTypesIsAccessible ||
      cardedOrCombedIsAccessible ||
      fabricDetailsIsAccessible ||
      fillingYarnsTexturedIsAccessible ||
      fillingYarnsTwistedIsAccessible ||
      nappedIsAccessible ||
      printedIsAccessible ||
      warpYarnsIsAccessible ||
      warpYarnsTexturedIsAccessible ||
      warpYarnsTwistedIsAccessible ||
      washedIsAccessible;

    // ===========================
    // ATTRIBUTE (PARENT)
    // ===========================
    const attributeIsAccessible =
      generalAttributeIsAccessible ||
      customerAttributeIsAccessible ||
      vendorAttributeIsAccessible ||
      productionAttributeIsAccessible ||
      accountAttributeIsAccessible ||
      fabricDetailAttributeIsAccessible;

    // ===========================
    // MASTER MODULE
    // ===========================
    const itemIsAccessible = SecurityAccessManager.ItemMaintenance_IsAccessible();
    const customerIsAccessible = SecurityAccessManager.CustomerMaintenance_IsAccessible();
    const vendorIsAccessible = SecurityAccessManager.VendorMaintenance_IsAccessible();
    const fabricCostIsAccessible = SecurityAccessManager.FabricStyleCostSheetMaintenance_IsAccessible();
    const styleMasterIsAccessible = SecurityAccessManager.TestTrue_IsAccessible();
	const fabricStatisticsDetailIsAccessible = SecurityAccessManager.FabricStyleStatistics_IsAccessible();
	
    const masterIsAccessible =
      itemIsAccessible ||
      customerIsAccessible ||
      vendorIsAccessible ||
      styleMasterIsAccessible ||
      fabricCostIsAccessible ||
	  fabricStatisticsDetailIsAccessible;

    // ===========================
    // SALES MODULE
    // ===========================
    const salesOrderIsAccessible = SecurityAccessManager.SalesOrderMaintenance_IsAccessible();
    const pickTicketIsAccessible = SecurityAccessManager.PickticketMaintenance_IsAccessible();
    const massSalesOrderPickTicketGenerationIsAccessible = SecurityAccessManager.MassSalesOrderPickTicketGenerationMaintenance_IsAccessible();
    const invoiceIsAccessible = SecurityAccessManager.InvoiceMaintenance_IsAccessible();
    const salesCommissionIsAcessible = SecurityAccessManager.SalesCommissionMaintenance_Accessible();
    const approveSalesOrderIsAccessible = SecurityAccessManager.MassApproveSalesOrders_IsAccessible();
    const cancelBackOrderIsAccessible = SecurityAccessManager.MassCancelBackOrders_IsAccessible();
    const massCancelSalesOrderIsAccessible = SecurityAccessManager.MassCancelSalesOrder_IsAccessible();
    const generatePickTicketIsAccessible = SecurityAccessManager.MassGenaratePickTickets_IsAccessible();
    const generateInvoiceIsAccessible = SecurityAccessManager.MassGenarateInvoices_IsAccessible();
    const approveInvoiceIsAccessible = SecurityAccessManager.MassApproveInvoices_IsAccessible();
    const printBulkPickTicketMaintenanceIsAccessible = SecurityAccessManager.BulkPickTicketInquiry_IsAccessible();
    const massSalesOrderPrintModule_IsAccessible = SecurityAccessManager.MassSalesOrderInquiry_IsAccessible();
    const pickTicketRollUtilityIsAccessible = SecurityAccessManager.PrintPickTickLabelMaintenance_IsAccessible();
    const commercialInvoiceForInvoicesIsAccessible = SecurityAccessManager.CommercailInvoiceForMultipleInvoice_IsAccessible();
    const advancedMassSalesOrderPickTicketGenerationIsAccessible = SecurityAccessManager.AdvancedMassSalesOrderPickTicketGenerationInquiry_IsAccessible();
    const invoiceForMultiplePickTicketIsAccessible = SecurityAccessManager.InvoiceForMultiplePickticket_IsAccessible();
    const mailInvoicesIsAccessible = SecurityAccessManager.MultiInvoiceMail_IsAccessible();

    const massMaintenanceIsAccessible =
      approveSalesOrderIsAccessible ||
      cancelBackOrderIsAccessible ||
      massCancelSalesOrderIsAccessible ||
      generatePickTicketIsAccessible ||
      generateInvoiceIsAccessible ||
      approveInvoiceIsAccessible;

    const salesIsAccessible =
      salesOrderIsAccessible ||
      massSalesOrderPickTicketGenerationIsAccessible ||
      pickTicketIsAccessible ||
      invoiceIsAccessible ||
      salesCommissionIsAcessible ||
      massMaintenanceIsAccessible ||
      printBulkPickTicketMaintenanceIsAccessible ||
      massSalesOrderPrintModule_IsAccessible ||
      pickTicketRollUtilityIsAccessible ||
      commercialInvoiceForInvoicesIsAccessible ||
      advancedMassSalesOrderPickTicketGenerationIsAccessible ||
      invoiceForMultiplePickTicketIsAccessible ||
      mailInvoicesIsAccessible;

    // ===========================
    // PURCHASE MODULE
    // ===========================
    const purchaseOrderIsAccessible = SecurityAccessManager.PurchaseOrderMaintenance_IsAccessible();
    const purchaseOrderReceiptIsAccessible = SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible();
    const purchaseOrderInTransitIsAccessible = SecurityAccessManager.PurchaseOrderInTransitMaintenance_IsAccessible();
    const massPurchaseOrderIsAccessible = SecurityAccessManager.MassPurchaseOrderMaintenance_IsAccessible();
    const massCancelPurchaseIsAccessible = SecurityAccessManager.MassCancelPurchaseOrder_IsAccessible();
    const vendorInvoiceIsAccessible = SecurityAccessManager.VendorInvoice_IsAccessible();

    const purchaseIsAccessible =
      purchaseOrderIsAccessible ||
      purchaseOrderReceiptIsAccessible ||
      purchaseOrderInTransitIsAccessible ||
      massPurchaseOrderIsAccessible ||
      massCancelPurchaseIsAccessible ||
      vendorInvoiceIsAccessible;

    // ===========================
    // WORK ORDER MODULE
    // ===========================
    // const workOrderIsAccessible = SecurityAccessManager.WorkOrderMaintenance_IsAccessible();
    // const workOrderReceiptIsAccessible = SecurityAccessManager.WorkOrderReceiptMaintenance_IsAccessible();

    // const workIsAccessible =
    //   workOrderIsAccessible ||
    //   workOrderReceiptIsAccessible;

    // ===========================
    // ACCOUNT MODULE
    // ===========================
    const accountReceivableIsAccessible = SecurityAccessManager.AccountReceivableMaintenance_IsAccessible();
    const creditMemoIsAccessible = SecurityAccessManager.CreditMemoMaintenance_IsAccessible();
    const checkTransactionIsAccessible = SecurityAccessManager.CheckTransactionMaintenance_IsAccessible();
    const batchCheckTransactionModuleIsAccessible = SecurityAccessManager.BatchCheckTransactionMaintenance_IsAccessible();
    const bankAdjustmentIsAccessible = SecurityAccessManager.BankAdjustmentMaintenance_IsAccessible();
    const depositIsAccessible = SecurityAccessManager.DepositMaintenance_IsAccessible();
    const locIsAccessible = SecurityAccessManager.LetterOfCreditMaintainance_IsAccessible();
    const checkBounceIsAccessible = SecurityAccessManager.CheckBounceProcessMaintainance_IsAccessible();
    const customerReturnIsAcessible = SecurityAccessManager.CustomerReturnMaintenance_IsAccessible();
    const postDatedCheckEntryIsAccessible = SecurityAccessManager.PostDatedCheckEntryMaintenance_IsAccessible();
    const debitMemoIsAccessible = SecurityAccessManager.DebitMemoMaintenance_IsAccessible();

    const accountModuleIsAccessible =
      accountReceivableIsAccessible ||
      creditMemoIsAccessible ||
      checkTransactionIsAccessible ||
      bankAdjustmentIsAccessible ||
      batchCheckTransactionModuleIsAccessible ||
      depositIsAccessible ||
      locIsAccessible ||
      checkBounceIsAccessible ||
      customerReturnIsAcessible ||
      postDatedCheckEntryIsAccessible ||
      debitMemoIsAccessible;

    // ===========================
    // LOGISTIC MODULE
    // ===========================
    const logisticOrderAccessible = SecurityAccessManager.LogesticOrder_IsAccessible();
    const logisticReceiptAccessible = SecurityAccessManager.LogesticReceipt_IsAccessible();
    const palletBarCodeGeneratorModuleIsAccessible = SecurityAccessManager.PalletBarCodeGeneratorModule_IsAccessible();

    const logisticModuleIsAccessible =
      logisticOrderAccessible ||
      logisticReceiptAccessible ||
      palletBarCodeGeneratorModuleIsAccessible;

    // ===========================
    // INVENTORY MODULE
    // ===========================
    const inventoryAdjustmentIsAccessible = SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible();
    const inventoryTransferIsAccessible = SecurityAccessManager.InventoryTransferMaintenance_IsAccessible();
    const printRollIsAccessible = SecurityAccessManager.PrintRollBarCodeMaintenance_IsAccessible();
    const printPOInTransitRollIsAccessible = SecurityAccessManager.PrintInTransitRollSKUBarCodeMaintenance_IsAccessible();
    const massInventoryTransferIsAccessible = SecurityAccessManager.MassInventoryTransfer_IsAccessible();
    const physicalInventoryAdjustmentsIsAccessible = SecurityAccessManager.PhysicalInventoryAdjustmentMaintainance_IsAccessible();
    const rollInventoryIsAccessible = SecurityAccessManager.SkuBatchInventoryMaintenance_IsAccessible();
    const manualInventoryAllocationIsAccessible = SecurityAccessManager.CustomerAllocationMaintenance_IsAccessible();
    const rollDataConversionIsAccessible = SecurityAccessManager.RollDataConversionMaintenance_IsAccessible();

    const inventoryModuleIsAccessible =
      inventoryAdjustmentIsAccessible ||
      inventoryTransferIsAccessible ||
      printRollIsAccessible ||
      printPOInTransitRollIsAccessible ||
      massInventoryTransferIsAccessible ||
      physicalInventoryAdjustmentsIsAccessible ||
      rollInventoryIsAccessible ||
      manualInventoryAllocationIsAccessible ||
      rollDataConversionIsAccessible;

    // ===========================
    // JOB MODULE
    // ===========================
    const WebItemExportIsAccessible = SecurityAccessManager.WebItemExport_IsAccessible();
    const WebItemImportIsAccessible = SecurityAccessManager.WebItemImport_IsAccessible();
    const WebSKUInventoryExportIsAccessible = SecurityAccessManager.WebSKUInventoryExport_IsAccessible();
    const ecomJobStatusDetailsIsAccessible = SecurityAccessManager.EcomJobStatusDetails_IsAccessible();
    const ecomWebOrderStatusDetailsIsAccessible = SecurityAccessManager.EcomWebOrderStatusDetails_IsAccessible();
    const webItemExcelToERPImportIsAcessible = SecurityAccessManager.WebFabricExcelToERPImport_IsAccessible();

    const JobModuleIsAccessible =
      WebItemExportIsAccessible ||
      WebItemImportIsAccessible ||
      WebSKUInventoryExportIsAccessible ||
      ecomJobStatusDetailsIsAccessible ||
      ecomWebOrderStatusDetailsIsAccessible ||
      webItemExcelToERPImportIsAcessible;

    // ===========================
    // CPM MODULE
    // ===========================
    const developmentCPMIsAccessible = SecurityAccessManager.PreProductionMaintenance_IsAccessible();
    const cpmEntryMaintenanceIsAccessible = SecurityAccessManager.CriticalPathManagementMaintainance_IsAccessible();
    const cpmReportInquiryIsAccessible = SecurityAccessManager.cpmReportInquiry_IsAccessible();

    const CpmIsAccessible =
      developmentCPMIsAccessible ||
      cpmEntryMaintenanceIsAccessible ||
      cpmReportInquiryIsAccessible;

    // ===========================
    // INQUIRY MODULE (EXTENSIVE)
    // ===========================
    const testIsAccessible = SecurityAccessManager.TestTrue_IsAccessible();
    const allFabricAtsIsAccessible = SecurityAccessManager.AllFabricATSInquiry_IsAccessible();
    const allFabricCustomerATSIsAccessible = SecurityAccessManager.AllFabricCustomerATSInquiry_IsAccessible();
    const customerFabricsATSIsAccessible = SecurityAccessManager.CustomerFabricATSInquiry_IsAccessible();
    const mailTrackIsAccessible = SecurityAccessManager.MailTrackInquiry_IsAccessible();
    // const trackIsAccessible = SecurityAccessManager.MailTrackInquiry_IsAccessible();
    const fabricWeeklyMonthlyAtsIsAccessible = SecurityAccessManager.FabricWeeklyMonthlyATSInquiry_IsAccessible();
    const customerOnOrderInquiryIsAccessible = SecurityAccessManager.CustomerOnOrderInquiry_IsAccessible();
    const vendorOnOrderInquiryIsAccessible = SecurityAccessManager.VendorOnOrderInquiry_IsAccessible();
    const fabricOnOrderInquiryIsAccessible = SecurityAccessManager.FabricOnOrderInquiry_IsAccessible();
    const customerServiceSalesOrderInquiryIsAccessible = SecurityAccessManager.CustomerServiceSalesOrderInquiry_IsAccessible();
    const customerSalesDetailsInquiryIsAccessible = SecurityAccessManager.CustomerSalesDetailsInquiry_IsAccessible();
    const invoiceRegisterInquiryIsAccessible = SecurityAccessManager.InvoiceRegisterInquiry_IsAccessible();
    const salesOrderRegisterInquiryIsAccessible = SecurityAccessManager.SalesOrderRegisterInquiry_IsAccessible();
    const salesBackOrderInquiryIsAccessible = SecurityAccessManager.SalesBackOrderInquiry_IsAccessible();
    const CustomerServiceInquiry_IsAccessible = SecurityAccessManager.CustomerServiceInquiry_IsAccessible();
    const pickedAndNotInvoicedListInquiry_IsAccessible = SecurityAccessManager.PickedNotInvoicedListInquiry_IsAccessible();
    const invoicedAndNotApprovedListInquiry_IsAccessible = SecurityAccessManager.InvoicedNotApprovedListInquiry_IsAccessible();
    const upsPickupSummaryInquiry_IsAccessible = SecurityAccessManager.UPSPickupSummeryInquiry_IsAccessible();
    const openPickTicketInquiry_IsAcessible = SecurityAccessManager.OpenPickTicketInquiry_IsAccessible();
    const pickTicketPickerDetailInquiry_isAcessible = SecurityAccessManager.PickTicketPickerDetailListInquiry_IsAccessible();
    const pickedAndShippedListInquiry_IsAcessible = SecurityAccessManager.PickedandShippedListInquiry_IsAccessible();
    const salesOrderRegisterDetailsInquiry_IsAcessible = SecurityAccessManager.SalesOrderRegisterDetailsInquiry_IsAccessible();
    const salesOrderCancelDetailsInquiry_isAcessible = SecurityAccessManager.SalesOrderLineCancelDetailsInquiry_IsAccessible();
    const bookingReportInquiry_IsAcessible = SecurityAccessManager.BookingReportInquiry_IsAccessible();
    const shippingReportInquiry_IsAcessible = SecurityAccessManager.ShippingReportInquiry_IsAccessible();
    const salesPersonCommisionInquiry_IsAcessble = SecurityAccessManager.SalesPersonCommissionInquiry_IsAccessible();
    const returnSalesPersonCommissionInquiry_IsAcessible = SecurityAccessManager.ReturnSalesPersonCommissionInquiry_IsAccessible();
    const customerAndFabricSalesInquiry_IsAcessible = SecurityAccessManager.CustomerAndFabricSalesInquiry_IsAccessible();
    const customerBalanceInquiryIsAccessible = SecurityAccessManager.CustomerBalanceInquiry_IsAccessible();
    const bankBalanceInquiryIsAccessible = SecurityAccessManager.BankAccountBalanceHistoryTrackInquiry_IsAccessible();
    const pastDueInvoiceWithCCPaymentInquiryIsAccessible = SecurityAccessManager.PastDueInvoicesWithCCPaymentInquiry_IsAccessible();
    const customerCurrentAgingInquiryIsAccessible = SecurityAccessManager.CustomerCurrentAgingInquiry_IsAccessible();
    const allCustomerOnlineAgingInquiryIsAccessible = SecurityAccessManager.AllCustomerOnlineAgingInquiry_IsAccessible();
    const postedARDayRegisterInquiryIsAccessible = SecurityAccessManager.PostedARDayRegisterInquiry_IsAccessible();
    const postedAndBouncedCheckInquiryIsAccessible = SecurityAccessManager.PostedandBouncedCheckInquiry_IsAccessible();
    const postedARCashPaymentRegisterInquiryIsAccessible = SecurityAccessManager.PostedARCashPaymentRegisterInquiry_IsAccessible();
    const postedARCardPaymentRegisterInquiryIsAccessible = SecurityAccessManager.PostedARCardPaymentRegisterInquiry_IsAccessible();
    const postedARWireTransferPaymentRegisterInquiryIsAccessible = SecurityAccessManager.PostedARWirePaymentRegisterInquiry_IsAccessible();
    const postedARCheckPaymentRegisterInquiryIsAccessible = SecurityAccessManager.PostedARCheckPaymentRegisterInquiryIsAccessible();
    const customerTransactionInquiryIsAccessible = SecurityAccessManager.CustomerTransactionInquiry_IsAccessible();
    const salesPersonCurrentAgingInquiryIsAccessible = SecurityAccessManager.SalesPersonPaymentAgingInquiry_IsAccessible();
    const checkPaymentHistoryInquiryIsAccessible = SecurityAccessManager.CheckPaymentHistoryInquiry_IsAccessible();
    const cardPaymentHistoryInquiryIsAccessible = SecurityAccessManager.CardPaymentHistoryInquiry_IsAccessible();
    const postedARACHPaymentRegisterInquiryIsAccessible = SecurityAccessManager.PostedARACHPaymentRegisterInquiry_IsAccessible();
    const achPaymentHistoryInquiryIsAccessible = SecurityAccessManager.ACHPaymentHistoryInquiry_IsAccessible();
    const wirePaymentHistoryInquiryIsAccessible = SecurityAccessManager.WirePaymentHistoryInquiry_IsAccessible();
    const bouncedCheckInquiryIsAccessible = SecurityAccessManager.BouncedCheckInquiry_IsAccessible();
    const unPostedARListInquiryIsAccessible = SecurityAccessManager.UnPostedARListInquiry_IsAccessible();
    const creditMemoPaymentHistoryInquiryIsAccessible = SecurityAccessManager.CreditMemoPaymentHistoryInquiry_IsAccessible();
    const CashPaymentActivityInquiryIsAccessible = SecurityAccessManager.CashPaymentActivityInquiry_IsAccessible();
    const PostDatedChecksDetailInquiryIsAccessible = SecurityAccessManager.PostDatedChecksInquiry_IsAccessible();
    const skuBatchInventoryInquiryIsAccessible = SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible();
    const rollingInventoryReportDetailsInquiryIsAccessible = SecurityAccessManager.RollingInventoryReportDetailsInquiry_IsAccessible();
    const skuInventoryTrackInquiryIsAccessible = SecurityAccessManager.SkuInventoryTrackInquiry_IsAccessible();
    const skuBatchInventoryTrackInquiryIsAccessible = SecurityAccessManager.SkuBatchInventoryTrackInquiry_IsAccessible();
    const binLocationInventoryInquiryIsAccessible = SecurityAccessManager.BinInventoryInquiry_IsAccessible();
    const inventoryBinSummaryInquiryIsAccessible = SecurityAccessManager.SkuBatchInventoryBinSummaryInquiry_IsAccessible();
    const skuInventoryLotBasedInquiryIsAccessible = SecurityAccessManager.FabricStyleInventoryLotBasedInquiry_IsAccessible();
    const physicalVerificationTrackInquiryIsAcessible = SecurityAccessManager.SkuBatchInventoryPhysicalVerificationInquiry_IsAccessible();
    const holdingWareHouseInventoryInquiryIsAccessible = SecurityAccessManager.HoldingWareHouseInventoryInquiry_IsAccessible();
    const fabricStyleInventoryValuationInfosInquiryIsAcessible = SecurityAccessManager.FabricStyleInventoryValuationInfosInquiry_IsAccessible();
    const customerAllocationIntransitInfoInquiryIsAccessible = SecurityAccessManager.CustomerAllocationInTransitInfosInquiry_IsAccessible();
    const skuInventorySkuBasedInquiryIsAccessible = SecurityAccessManager.SkuInventorySkuBasedInquiry_IsAccessible();
    const obseleteInventoryInquiryIsAccessible = SecurityAccessManager.ObseleteInventoryInquiry_IsAccessible();
    const webInventoryMaintenanceIsAccessible = SecurityAccessManager.WebInventoryMaintenance_IsAccessible();
    const dailyInventoryTrackMaintenanceIsAccessible = SecurityAccessManager.DailyInventoryTrackInquiry_IsAccessible();
    const lotBasedInventoryInOutInquiryIsAccessible = SecurityAccessManager.LotBasedInventoryInOutInquiry_IsAccessible();
    const dailyInventoryProcessTrackDetailInquiry = SecurityAccessManager.DailyInventoryProcessTrackInquiry_IsAccessible();
    const purchaseOrderSummaryInfoInquiryIsAccessible = SecurityAccessManager.PurchaseOrderSummaryInfoInquiry_IsAccessible();
    const invoiceSummaryInfoInquiryIsAccessible = SecurityAccessManager.InvoiceSummaryInfoInquiry_IsAccessible();
    const purchaseOrderReceiptSummaryInfoInquiryIsAccessible = SecurityAccessManager.PurchaseOrderReceiptSummaryInfoInquiry_IsAccessible();
    const salesOrderSummaryInfoInquiryIsAccessible = SecurityAccessManager.SalesOrderSummaryInfoInquiry_IsAccessible();
    const pickTicketSummaryInfoInquiryIsAccessible = SecurityAccessManager.PickTicketSummaryInfoInquiry_IsAccessible();
    const creditMemoSummaryInfoInquiryIsAccessible = SecurityAccessManager.PickTicketSummaryInfoInquiry_IsAccessible();
    const fabricInfoInquiryIsAccessible = SecurityAccessManager.FabricInfoInquiry_IsAccessible();
    const fabricStyleSKUIsAccessible = SecurityAccessManager.FabricStyleSKU_IsAccessible();
    const customerInfoInquiryIsAccessible = SecurityAccessManager.CustomerInfoInquiry_IsAccessible();
    const vendorInfoInquiryIsAccessible = SecurityAccessManager.VendorInfoInquiry_IsAccessible();
    const productAvailabilityInquiryIsAccessible = SecurityAccessManager.ProductAvailabilityInquiry_IsAccessible();
    const fabricStyleSalesInquiryIsAccessible = SecurityAccessManager.FabricStyleSalesInquiry_IsAccessible();
    const salesOrderInquiryIsAccessible = SecurityAccessManager.SalesOrderStatusInquiry_IsAccessible();
    const salesAnalysisInquiryIsAccessible = SecurityAccessManager.SalesAnalysisInquiry_IsAccessible();
    const customerSalesAnalysisInquiryIsAccessible = SecurityAccessManager.CustomerSalesAnalysisInquiry_IsAccessible();
    const FiscalYearBookingInquiryIsAccessible = SecurityAccessManager.FiscalYearBookingInquiry_IsAccessible();
    const FabricStyleYearlyInquiryIsAccessible = SecurityAccessManager.FabricStyleYearlySalesAnalysisInquiry_IsAccessible();
    const yearlySalesAnalysisInquiryIsAccessible = SecurityAccessManager.YearlySalesAnalysisInquiry_IsAccessible();
    const customerStatisticsInquiryIsAccessible = SecurityAccessManager.CustomerStatiticsInquiry_IsAccessible();
    const vendorStatisticsInquiryIsAccessible = SecurityAccessManager.VendorStatiticsInquiry_IsAccessible();
    const poUnApprovedInfoInquiryIsAccessible = SecurityAccessManager.PurchaseOrderUnApprovedDetails_IsAccessible();
    const fabricStylePurchaseHistoryInquiryIsAccessible = SecurityAccessManager.FabricStylePurchaseHistoryInquiry_IsAccessible();
    const poInTransitInfoInquiryIsAccessible = SecurityAccessManager.PurchaseOrderInTransitInfosInquiry_IsAccessible();
    const purchaseOrderReceiptDetailsInquiryIsAccessible = SecurityAccessManager.PurchaseorderReceiptInquiry_IsAccessible();
    const receiptRollBinDetailsInquiryIsAccessible = SecurityAccessManager.ReceiptRollBinSummaryInquiry_IsAccessible();
    const inboundReceiptNotInvoicedIsAccessible = SecurityAccessManager.InboundOpenOrderNotReceivedDetailsInquirylsInquiry_IsAccessible();
    const inboundOpenOrderNotReceivedIsAccessible = SecurityAccessManager.InboundReceiptNotInvoicedInquiry_IsAccessible();
    const fabricStatisticsIsAccessible = SecurityAccessManager.FabricStatisticsInquiry_IsAccessible();
    const customerStatementInquiryIsAccessible = SecurityAccessManager.CustomerStatementInquiry_IsAccessible();
    const inventoryAdjustmentHistoryInquiryIsAccessible = SecurityAccessManager.InventoryAdjustmentHistoryInquiry_IsAccessible();
    const invoicFabricStyleYearlyInquiryIsAccessible = SecurityAccessManager.InvoiceFabricStyleYearlyInquiry_IsAccessible();
    const latePurchaseOrderDetailsInquiryIsAccessible = SecurityAccessManager.LatePurchaseOrderDetailsInquiry_IsAccessible();
    const fabricStylesReceivedDetailsInquiryIsAccessible = SecurityAccessManager.FabricStylesReceivedDetailsInquiry_IsAccessible();
    const printOutTrackInquiryIsAccessible = SecurityAccessManager.PrintOutTrackInquiry_IsAccessible();
    const fabricStylePriceListPriceCostInquiryIsAccessible = SecurityAccessManager.FabricStylePriceListPriceCostInquiry_IsAccessible();
    const creditMemoDetailsInquiryIsAccessible = SecurityAccessManager.CreditMemoDetailsInquiry_IsAccessible();
    const customerSalesOrderAndInvoiceDetailReportInquiryIsAccessible = SecurityAccessManager.CustomerSalesOrderAndInvoiceDetailInquiry_IsAccessible();
    const mostRecentCustomerSalesDetailInquiryIsAccessible = SecurityAccessManager.MostRecentCustomerSalesDetailInquiry_IsAccessible();
    const salesServiceReportDetailsInquiryIsAccessible = SecurityAccessManager.SalesServiceDetailsInquiry_IsAccessible();
    const salesCommodityReportDetailsInquiryIsAccessible = SecurityAccessManager.SalesCommodityDetailsInquiry_IsAccessible();
    const salesPriceInquiryIsAccessible = SecurityAccessManager.salesPriceInquiry_IsAccessible();
    const salesAndPurchaseDetailsInquiryIsAccessible = SecurityAccessManager.salesAndPurchaseDetailsInquiry_IsAccessible();
     const salesYearlyInquiryIsAccessible = SecurityAccessManager.SalesYearly_IsAccessible();

         const fabricCatalogIsAccessible = SecurityAccessManager.FabricCatalog_IsAccessible();


    // Inquiry SubGroups
    const accountsInquiryMeuIsAccessible =
      customerBalanceInquiryIsAccessible ||
      customerStatementInquiryIsAccessible ||
      bankBalanceInquiryIsAccessible ||
      pastDueInvoiceWithCCPaymentInquiryIsAccessible ||
      customerCurrentAgingInquiryIsAccessible ||
      allCustomerOnlineAgingInquiryIsAccessible ||
      customerTransactionInquiryIsAccessible ||
      creditMemoDetailsInquiryIsAccessible ||
      salesPersonCurrentAgingInquiryIsAccessible;

    const paymentHistoryInquiryMenuIsAccessible =
      postedARDayRegisterInquiryIsAccessible ||
      postedAndBouncedCheckInquiryIsAccessible ||
      postedARCashPaymentRegisterInquiryIsAccessible ||
      postedARCardPaymentRegisterInquiryIsAccessible ||
      postedARWireTransferPaymentRegisterInquiryIsAccessible ||
      postedARCheckPaymentRegisterInquiryIsAccessible ||
      checkPaymentHistoryInquiryIsAccessible ||
      cardPaymentHistoryInquiryIsAccessible ||
      postedARACHPaymentRegisterInquiryIsAccessible ||
      achPaymentHistoryInquiryIsAccessible ||
      wirePaymentHistoryInquiryIsAccessible ||
      bouncedCheckInquiryIsAccessible ||
      unPostedARListInquiryIsAccessible ||
      creditMemoPaymentHistoryInquiryIsAccessible ||
      CashPaymentActivityInquiryIsAccessible ||
      PostDatedChecksDetailInquiryIsAccessible;

    const infoListInquiryIsAccessible =
      fabricInfoInquiryIsAccessible ||
      fabricStyleSKUIsAccessible ||
      customerInfoInquiryIsAccessible ||
      vendorInfoInquiryIsAccessible ||
      productAvailabilityInquiryIsAccessible;

    const summaryInfoInquiryIsAccessible =
      purchaseOrderSummaryInfoInquiryIsAccessible ||
      invoiceSummaryInfoInquiryIsAccessible ||
      salesOrderSummaryInfoInquiryIsAccessible ||
      pickTicketSummaryInfoInquiryIsAccessible ||
      purchaseOrderReceiptSummaryInfoInquiryIsAccessible ||
      creditMemoSummaryInfoInquiryIsAccessible;

    const inventoryInquiryIsAccessible =
      lotBasedInventoryInOutInquiryIsAccessible ||
      skuBatchInventoryInquiryIsAccessible ||
      skuInventoryTrackInquiryIsAccessible ||
      inventoryAdjustmentHistoryInquiryIsAccessible ||
      binLocationInventoryInquiryIsAccessible ||
      inventoryBinSummaryInquiryIsAccessible ||
      skuInventoryLotBasedInquiryIsAccessible ||
      physicalVerificationTrackInquiryIsAcessible ||
      holdingWareHouseInventoryInquiryIsAccessible ||
      fabricStyleInventoryValuationInfosInquiryIsAcessible ||
      customerAllocationIntransitInfoInquiryIsAccessible ||
      skuBatchInventoryTrackInquiryIsAccessible ||
      skuInventorySkuBasedInquiryIsAccessible ||
      obseleteInventoryInquiryIsAccessible ||
      webInventoryMaintenanceIsAccessible ||
      rollingInventoryReportDetailsInquiryIsAccessible;

    const salesAndAnalysisInquiryIsAccessible =
      fabricStyleSalesInquiryIsAccessible ||
      salesOrderInquiryIsAccessible ||
      salesAnalysisInquiryIsAccessible ||
      customerSalesAnalysisInquiryIsAccessible ||
      FiscalYearBookingInquiryIsAccessible ||
      FabricStyleYearlyInquiryIsAccessible ||
      yearlySalesAnalysisInquiryIsAccessible;

    const purchaseInquiryIsAccessible =
      poUnApprovedInfoInquiryIsAccessible ||
      fabricStylePurchaseHistoryInquiryIsAccessible ||
      poInTransitInfoInquiryIsAccessible ||
      purchaseOrderReceiptDetailsInquiryIsAccessible ||
      receiptRollBinDetailsInquiryIsAccessible ||
      latePurchaseOrderDetailsInquiryIsAccessible ||
      fabricStylesReceivedDetailsInquiryIsAccessible;

    const statisticsInquiryIsAccessible =
      customerStatisticsInquiryIsAccessible ||
      vendorStatisticsInquiryIsAccessible;

    const onOrderInquiryIsAccessible =
      customerOnOrderInquiryIsAccessible ||
      vendorOnOrderInquiryIsAccessible ||
      fabricOnOrderInquiryIsAccessible ||
      customerServiceSalesOrderInquiryIsAccessible;

    const salesInquiryIsAccessible =
      customerSalesDetailsInquiryIsAccessible ||
      invoicFabricStyleYearlyInquiryIsAccessible ||
      invoiceRegisterInquiryIsAccessible ||
      salesOrderRegisterInquiryIsAccessible ||
      salesBackOrderInquiryIsAccessible ||
      CustomerServiceInquiry_IsAccessible ||
      pickedAndNotInvoicedListInquiry_IsAccessible ||
      invoicedAndNotApprovedListInquiry_IsAccessible ||
      upsPickupSummaryInquiry_IsAccessible ||
      openPickTicketInquiry_IsAcessible ||
      pickTicketPickerDetailInquiry_isAcessible ||
      pickedAndShippedListInquiry_IsAcessible ||
      salesOrderRegisterDetailsInquiry_IsAcessible ||
      salesOrderCancelDetailsInquiry_isAcessible ||
      bookingReportInquiry_IsAcessible ||
      shippingReportInquiry_IsAcessible ||
      salesPersonCommisionInquiry_IsAcessble ||
      returnSalesPersonCommissionInquiry_IsAcessible ||
      customerSalesOrderAndInvoiceDetailReportInquiryIsAccessible ||
      mostRecentCustomerSalesDetailInquiryIsAccessible ||
      customerAndFabricSalesInquiry_IsAcessible ||
      salesServiceReportDetailsInquiryIsAccessible ||
      salesCommodityReportDetailsInquiryIsAccessible ||
      salesPriceInquiryIsAccessible ||
      salesYearlyInquiryIsAccessible ||
      salesAndPurchaseDetailsInquiryIsAccessible;

    const LogisticsIsAccessible =
      inboundReceiptNotInvoicedIsAccessible ||
      inboundOpenOrderNotReceivedIsAccessible;

    const cpmInquiryIsAccessible = cpmReportInquiryIsAccessible;

    const inquiryIsAccessible =
      allFabricAtsIsAccessible ||
      fabricCatalogIsAccessible ||
      printOutTrackInquiryIsAccessible ||
      fabricStylePriceListPriceCostInquiryIsAccessible ||
      fabricStatisticsIsAccessible ||
      allFabricCustomerATSIsAccessible ||
      customerFabricsATSIsAccessible ||
      mailTrackIsAccessible ||
      // trackIsAccessible||
      fabricWeeklyMonthlyAtsIsAccessible ||
      onOrderInquiryIsAccessible ||
      salesInquiryIsAccessible ||
      salesAndAnalysisInquiryIsAccessible ||
      purchaseInquiryIsAccessible ||
      statisticsInquiryIsAccessible ||
      accountsInquiryMeuIsAccessible ||
      paymentHistoryInquiryMenuIsAccessible ||
      inventoryInquiryIsAccessible ||
      infoListInquiryIsAccessible ||
      summaryInfoInquiryIsAccessible ||
      LogisticsIsAccessible ||
      cpmInquiryIsAccessible;

    // ===========================
    // SECURITY MODULE
    // ===========================
    const userMaintenanceIsAccessible = SecurityAccessManager.UserRoleMaintenance_IsAccessible();
    const roleMaintenanceIsAccessible = SecurityAccessManager.RoleMaintenance_IsAccessible();

    const securityModuleIsAccessible =
      userMaintenanceIsAccessible ||
      roleMaintenanceIsAccessible;

    // ===========================
    // SYSTEM MODULE
    // ===========================
    const releaseLockIsAccessible = SecurityAccessManager.EntityLockDisplay_IsAccessible();
    const systemModuleIsAccessible = releaseLockIsAccessible;

    // ===========================
    // RETURN ALL PERMISSIONS AS A SINGLE OBJECT
    // ===========================


    return {
      // System Config
      is3PL: this.state.is3PL,
      isVersion_2: this.state.isVersion_2,
      isVersion_1: this.state.isVersion_1,
      isVersion_3: this.state.isVersion_3,

      // Top-Level Module Flags
      attributeIsAccessible,
      masterIsAccessible,
      salesIsAccessible,
      purchaseIsAccessible,
      // workIsAccessible,
      accountModuleIsAccessible,
      logisticModuleIsAccessible,
      inventoryModuleIsAccessible,
      JobModuleIsAccessible,
      CpmIsAccessible,
      inquiryIsAccessible,
      securityModuleIsAccessible,
      systemModuleIsAccessible,

      // Attribute Modules
      generalAttributeIsAccessible,
      customerAttributeIsAccessible,
      vendorAttributeIsAccessible,
      productionAttributeIsAccessible,
      accountAttributeIsAccessible,
      webAttributeIsAccessible,
      fabricDetailAttributeIsAccessible,

      // General Attributes (Individual Items)
      serviceDetailsIsAccessible,
      invoicePrintoutTypeIsAccessible,
      businessDivisionIsAccessible,
      uomIsAccessible,
      currencyIsAccessible,
      styleIsAccessible,
      styleTypeIsAccessible,
      typeCategoryIsAccessible,
      contentIsAccessible,
      productDivisionIsAccessible,
      colorIsAccessible,
      compositionTypeIsAccessible,
      styleItemTypeIsAccessible,
      countryIsAccessible,
      seasonIsAccessible,
      locationIsAccessible,
      binLocationIsAccessible,
      royaltyClientIsAccessible,
      inventoryAdjustmentReasonIsAccessible,
      currencyExchangeRateIsAccessible,
      employeeIsAccessible,
      harmonizedTariffScheduleIsAccessible,
      productStatusIsAccessible,
      fabricVendorMiscellaneousCostDetailIsAccessible,
      fiscalYearIsAccessible,
      commentIsAccessible,
      shipToIsAccessible,

      // Customer Attributes
      customerDivisionIsAccessible,
      cityIsAccessible,
      logisticMethodIsAccessible,
      customerSpecialTypeIsAccessible,
      customerTypesIsAccessible,
      shipViaIsAccessible,
      freightMethodIsAccessible,
      customerSalesZoneIsAccessible,
      boxTypeIsAccessible,
      paymentTermIsAccessible,
      stateIsAccessible,
      invoiceTemplateIsAccessible,
      paymentMethodIsAccessible,
      customerDeliveryIsAccessible,
      invoiceCancelReasonIsAccessible,
      invoiceUnApprovalReasonIsAccessible,
      invoiceNonMerchandiseReasonIsAccessible,
      periodSalesCommissionAdjustmentReasonIsAccessible,

      // Vendor Attributes
      vendorTypeIsAccessible,
      fobCityIsAccessible,
      incoTermIsAccessible,
      vendorShipViaIsAccessible,
      vendorTermIsAccessible,
      shipmentTermIsAccessible,
      vendorCategoryIsAccessible,
      purchaseOrderCancelReasonIsAccessible,
      purchaseOrderUnApprovalReasonIsAccessible,
      miscellaneousChargeReasonIsAccessible,
      purchaseOrderModelIsAccessible,

      // Production Attributes
      preProductionChangeReasonIsAccessible,
      stageCollectionIsAccessible,

      // Account Attributes (Ledger)
      generalLedgerAccountTypeIsAccessible,
      generalLedgerAccountIsAccessible,
      accountReceivableDiscountIsAccessible,
      customerTenderReasonIsAccessible,
      customerTenderCancelReasonIsAccessible,
      customerTenderUnApprovalReasonIsAccessible,
      accountReceivableReversalReasonIsAccessible,
      expenseTypeIsAccessible,
      expenseSubTypeIsAccessible,
      bankAdjustmentReasonIsAccessible,
      depositCancelReasonIsAccessible,
      depositReversalReasonIsAccessible,
      bankAccountIsAccessible,

      // Web Attributes
      targetWebSiteDetailAttributeIsAccessible,

      // Fabric Attributes
      fabricConstructAccessible,
      designDirectionIsAccessible,
      backedIsAccessible,
      backedTypesIsAccessible,
      boundBackTypesIsAccessible,
      cardedOrCombedIsAccessible,
      fabricDetailsIsAccessible,
      fillingYarnsTexturedIsAccessible,
      fillingYarnsTwistedIsAccessible,
      nappedIsAccessible,
      printedIsAccessible,
      warpYarnsIsAccessible,
      warpYarnsTexturedIsAccessible,
      warpYarnsTwistedIsAccessible,
      washedIsAccessible,

      // Master Module Items
      itemIsAccessible,
      customerIsAccessible,
      vendorIsAccessible,
      fabricCostIsAccessible,
      styleMasterIsAccessible,
	  fabricStatisticsDetailIsAccessible,

      // Sales Module Items
      salesOrderIsAccessible,
      pickTicketIsAccessible,
      massSalesOrderPickTicketGenerationIsAccessible,
      invoiceIsAccessible,
      salesCommissionIsAcessible,
      massMaintenanceIsAccessible,
      approveSalesOrderIsAccessible,
      cancelBackOrderIsAccessible,
      massCancelSalesOrderIsAccessible,
      generatePickTicketIsAccessible,
      generateInvoiceIsAccessible,
      approveInvoiceIsAccessible,
      printBulkPickTicketMaintenanceIsAccessible,
      massSalesOrderPrintModule_IsAccessible,
      pickTicketRollUtilityIsAccessible,
      commercialInvoiceForInvoicesIsAccessible,
      advancedMassSalesOrderPickTicketGenerationIsAccessible,
      invoiceForMultiplePickTicketIsAccessible,
      mailInvoicesIsAccessible,

      // Purchase Module Items
      purchaseOrderIsAccessible,
      purchaseOrderReceiptIsAccessible,
      purchaseOrderInTransitIsAccessible,
      massPurchaseOrderIsAccessible,
      massCancelPurchaseIsAccessible,
      vendorInvoiceIsAccessible,

      // Work Order Module Items
      // workOrderIsAccessible,
      // workOrderReceiptIsAccessible,

      // Account Module Items
      accountReceivableIsAccessible,
      creditMemoIsAccessible,
      checkTransactionIsAccessible,
      batchCheckTransactionModuleIsAccessible,
      bankAdjustmentIsAccessible,
      depositIsAccessible,
      locIsAccessible,
      checkBounceIsAccessible,
      customerReturnIsAcessible,
      postDatedCheckEntryIsAccessible,
      debitMemoIsAccessible,

      // Logistic Module Items
      logisticOrderAccessible,
      logisticReceiptAccessible,
      palletBarCodeGeneratorModuleIsAccessible,

      // Inventory Module Items
      inventoryAdjustmentIsAccessible,
      inventoryTransferIsAccessible,
      printRollIsAccessible,
      printPOInTransitRollIsAccessible,
      massInventoryTransferIsAccessible,
      physicalInventoryAdjustmentsIsAccessible,
      rollInventoryIsAccessible,
      manualInventoryAllocationIsAccessible,
      rollDataConversionIsAccessible,

      // Job Module Items
      WebItemExportIsAccessible,
      WebItemImportIsAccessible,
      WebSKUInventoryExportIsAccessible,
      ecomJobStatusDetailsIsAccessible,
      ecomWebOrderStatusDetailsIsAccessible,
      webItemExcelToERPImportIsAcessible,

      // CPM Module Items
      developmentCPMIsAccessible,
      cpmEntryMaintenanceIsAccessible,
      cpmReportInquiryIsAccessible,
      cpmInquiryIsAccessible,

      // Inquiry Module (All Items)
      testIsAccessible,
      allFabricAtsIsAccessible,
      allFabricCustomerATSIsAccessible,
      customerFabricsATSIsAccessible,
      mailTrackIsAccessible,
      // trackIsAccessible,
      fabricWeeklyMonthlyAtsIsAccessible,

      // Inquiry SubGroups
      onOrderInquiryIsAccessible,
      customerOnOrderInquiryIsAccessible,
      vendorOnOrderInquiryIsAccessible,
      fabricOnOrderInquiryIsAccessible,
      customerServiceSalesOrderInquiryIsAccessible,

      salesInquiryIsAccessible,
      customerSalesDetailsInquiryIsAccessible,
      invoiceRegisterInquiryIsAccessible,
      salesOrderRegisterInquiryIsAccessible,
      salesBackOrderInquiryIsAccessible,
      CustomerServiceInquiry_IsAccessible,
      pickedAndNotInvoicedListInquiry_IsAccessible,
      invoicedAndNotApprovedListInquiry_IsAccessible,
      upsPickupSummaryInquiry_IsAccessible,
      openPickTicketInquiry_IsAcessible,
      pickTicketPickerDetailInquiry_isAcessible,
      pickedAndShippedListInquiry_IsAcessible,
      salesOrderRegisterDetailsInquiry_IsAcessible,
      salesOrderCancelDetailsInquiry_isAcessible,
      bookingReportInquiry_IsAcessible,
      shippingReportInquiry_IsAcessible,
      salesPersonCommisionInquiry_IsAcessble,
      returnSalesPersonCommissionInquiry_IsAcessible,
      customerAndFabricSalesInquiry_IsAcessible,
      customerSalesOrderAndInvoiceDetailReportInquiryIsAccessible,
      mostRecentCustomerSalesDetailInquiryIsAccessible,
      salesServiceReportDetailsInquiryIsAccessible,
      salesCommodityReportDetailsInquiryIsAccessible,
      salesPriceInquiryIsAccessible,
      salesAndPurchaseDetailsInquiryIsAccessible,
      salesYearlyInquiryIsAccessible,

      accountsInquiryMeuIsAccessible,
      customerBalanceInquiryIsAccessible,
      bankBalanceInquiryIsAccessible,
      pastDueInvoiceWithCCPaymentInquiryIsAccessible,
      customerCurrentAgingInquiryIsAccessible,
      allCustomerOnlineAgingInquiryIsAccessible,
      customerTransactionInquiryIsAccessible,
      creditMemoDetailsInquiryIsAccessible,
      salesPersonCurrentAgingInquiryIsAccessible,

      paymentHistoryInquiryMenuIsAccessible,
      postedARDayRegisterInquiryIsAccessible,
      postedAndBouncedCheckInquiryIsAccessible,
      postedARCashPaymentRegisterInquiryIsAccessible,
      postedARCardPaymentRegisterInquiryIsAccessible,
      postedARWireTransferPaymentRegisterInquiryIsAccessible,
      postedARCheckPaymentRegisterInquiryIsAccessible,
      checkPaymentHistoryInquiryIsAccessible,
      cardPaymentHistoryInquiryIsAccessible,
      postedARACHPaymentRegisterInquiryIsAccessible,
      achPaymentHistoryInquiryIsAccessible,
      wirePaymentHistoryInquiryIsAccessible,
      bouncedCheckInquiryIsAccessible,
      unPostedARListInquiryIsAccessible,
      creditMemoPaymentHistoryInquiryIsAccessible,
      CashPaymentActivityInquiryIsAccessible,
      PostDatedChecksDetailInquiryIsAccessible,

      inventoryInquiryIsAccessible,
      skuBatchInventoryInquiryIsAccessible,
      rollingInventoryReportDetailsInquiryIsAccessible,
      skuInventoryTrackInquiryIsAccessible,
      skuBatchInventoryTrackInquiryIsAccessible,
      binLocationInventoryInquiryIsAccessible,
      inventoryBinSummaryInquiryIsAccessible,
      skuInventoryLotBasedInquiryIsAccessible,
      physicalVerificationTrackInquiryIsAcessible,
      holdingWareHouseInventoryInquiryIsAccessible,
      fabricStyleInventoryValuationInfosInquiryIsAcessible,
      customerAllocationIntransitInfoInquiryIsAccessible,
      skuInventorySkuBasedInquiryIsAccessible,
      obseleteInventoryInquiryIsAccessible,
      webInventoryMaintenanceIsAccessible,
      dailyInventoryTrackMaintenanceIsAccessible,
      lotBasedInventoryInOutInquiryIsAccessible,
      dailyInventoryProcessTrackDetailInquiry,
      inventoryAdjustmentHistoryInquiryIsAccessible,

      summaryInfoInquiryIsAccessible,
      purchaseOrderSummaryInfoInquiryIsAccessible,
      invoiceSummaryInfoInquiryIsAccessible,
      purchaseOrderReceiptSummaryInfoInquiryIsAccessible,
      salesOrderSummaryInfoInquiryIsAccessible,
      pickTicketSummaryInfoInquiryIsAccessible,
      creditMemoSummaryInfoInquiryIsAccessible,

      infoListInquiryIsAccessible,
      fabricInfoInquiryIsAccessible,
      fabricStyleSKUIsAccessible,
      customerInfoInquiryIsAccessible,
      vendorInfoInquiryIsAccessible,
      productAvailabilityInquiryIsAccessible,

      salesAndAnalysisInquiryIsAccessible,
      fabricStyleSalesInquiryIsAccessible,
      salesOrderInquiryIsAccessible,
      salesAnalysisInquiryIsAccessible,
      customerSalesAnalysisInquiryIsAccessible,
      FiscalYearBookingInquiryIsAccessible,
      FabricStyleYearlyInquiryIsAccessible,
      yearlySalesAnalysisInquiryIsAccessible,

      purchaseInquiryIsAccessible,
      poUnApprovedInfoInquiryIsAccessible,
      fabricStylePurchaseHistoryInquiryIsAccessible,
      poInTransitInfoInquiryIsAccessible,
      purchaseOrderReceiptDetailsInquiryIsAccessible,
      receiptRollBinDetailsInquiryIsAccessible,
      latePurchaseOrderDetailsInquiryIsAccessible,
      fabricStylesReceivedDetailsInquiryIsAccessible,

      statisticsInquiryIsAccessible,
      customerStatisticsInquiryIsAccessible,
      vendorStatisticsInquiryIsAccessible,

      fabricStatisticsIsAccessible,
      customerStatementInquiryIsAccessible,
      invoicFabricStyleYearlyInquiryIsAccessible,
      printOutTrackInquiryIsAccessible,
      fabricStylePriceListPriceCostInquiryIsAccessible,
      fabricCatalogIsAccessible,

      LogisticsIsAccessible,
      inboundReceiptNotInvoicedIsAccessible,
      inboundOpenOrderNotReceivedIsAccessible,

      // Security Module Items
      userMaintenanceIsAccessible,
      roleMaintenanceIsAccessible,

      // System Module Items
      releaseLockIsAccessible
    };
  };


   componentDidMount() {
    const { appData } = this.context;

    this.companyCode = appData.companyCode;

    // ── Read all config values ──
    const is3PL           = ConfigManager.isPurchaseBasedOnCustomerFlag();
    const isStandard      = ConfigManager.isTexcoFabricKey();
    const isShowbinLookup = ConfigManager.isShowBinLocationLookup();
    const moduleVersion   = ConfigManager.getModuleVersion();
    const isVersion_2     = moduleVersion === "version_2";
    const isVersion_3     = moduleVersion === "version_3";
    const isVersion_1     = !isVersion_2 && !isVersion_3;
    const userCode        = this.props.loginSession?.code ?? "";
    const showDashboard   = ConfigManager.isShowDashBoard();


    
    
    
  
    
    
    
 

    // ── Single batched setState (replaces 7 separate setStates) ──
    this.setState({
      appVersion:     appData.applicationName,
      is3PL,
      isStandard,
      isShowbinLookup,
      isVersion_1,
      isVersion_2,
      isVersion_3,
      userCode,
      moduleList:     [],
      ...(showDashboard ? { selectedModuleKey: "dashBoard" } : {}),
    });

    if (showDashboard) {
     const displayModule = this.allModuleList["dashBoard"];
  if (displayModule) {
    displayModule.icon = <LayoutDashboard size={16} />;
  }
  this.addModule("dashBoard");
    }

    this.applyMenuTitles();

    // ── Calculate permissions after state is set ──
    setTimeout(() => {
      const permissions = this.calculatePermissions();
      this.mainMenus = getMainMenus(permissions);

      this.setState({
        permissions,
        openMenus:    {},
        openSubMenus: {},
        permissionsLoaded: true,
      });
    }, 0);

    // document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    // document.removeEventListener("mousedown", this.handleClickOutside);
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const docBody = document.body;

  //   if (this.state.isSidebarOpen) {
  //     docBody.classList.add("overflow_hide");
  //   } else {
  //     docBody.classList.remove("overflow_hide");
  //   }
  //   this.applyMenuTitles();
  // }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isSidebarOpen !== prevState.isSidebarOpen) {
      document.body.classList.toggle("overflow_hide", this.state.isSidebarOpen);
    }
  }


  menuItemOnclick = (menuItem, icon = null) => {
   

    
    if (menuItem == null) return;
    const displayModule = this.allModuleList[menuItem];
    if (displayModule == null) return;

    // Build new moduleList inline — no separate addModule setState
    const tempModuleList = this.state.moduleList;
    if (!(menuItem in tempModuleList)) {
      displayModule.reff = menuItem.concat("Ref");
      displayModule.icon = icon; // ✅ store the icon from the clicked menu item
      tempModuleList[menuItem] = displayModule;
    }

    // Single setState — closes menu + selects tab + updates list in ONE render
    this.setState({
      moduleList: tempModuleList,
      selectedModuleKey: menuItem,
      openMenus: {},
      openSubMenus: {},
      activeTopMenu: null,
      activeTopSubMenu: null,
      activeSubMenu: null,
      activeMenuKey: menuItem,
    });
  };

  applyMenuTitles = () => {
    const items = document.querySelectorAll(".icon-with-text");
    items.forEach(item => {
      const text = item.textContent?.trim();
      if (text && !item.getAttribute("title")) {
        item.setAttribute("title", text);
      }
    });
  };

  addModule = (moduleKey) => {
    if (moduleKey == null) return;
    const displayModule = this.allModuleList[moduleKey];
    if (displayModule == null) return;

    const tempModuleList = { ...this.state.moduleList };
    if (moduleKey in tempModuleList) {
      this.setState({ selectedModuleKey: moduleKey });
      return;
    }
    displayModule.reff = moduleKey.concat("Ref");
    tempModuleList[moduleKey] = displayModule;
    this.setState({ moduleList: tempModuleList, selectedModuleKey: moduleKey });
  };

  tabSelected = (moduleKey) => {
    this.setState({ selectedModuleKey: moduleKey });
  };

  removeModule = (moduleKey) => {
    const tempModuleList = { ...this.state.moduleList };
    const keysArray = Object.keys(tempModuleList);
    const currentIndex = keysArray.indexOf(moduleKey);
    const nextModuleKey = keysArray.length > 1
      ? keysArray[currentIndex + 1 >= keysArray.length ? currentIndex - 1 : currentIndex + 1]
      : null;

    delete tempModuleList[moduleKey];
    // Single setState — no setTimeout delay
    this.setState({ moduleList: tempModuleList, selectedModuleKey: nextModuleKey });
  };

  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };

  handleReleaseResponse = (response) => { };

  releaselock = (entity) => {
    if (entity != null && entity != undefined && entity > 0) {
      const request = new EntityLockBean();
      request.companyCode = this.companyCode;
      const session = JSON.parse(localStorage.getItem("session"));
      if (session != null && session != undefined) {
        const { code } = session;
        request.createdBy = code;
      }
      request.lockType = entity;
      EntityLockService.releaseLockBasedOnLockType(
        request,
        this.handleReleaseResponse,
        this.errorCallBack
      );
    }
  };

  remove_Module = (moduleKey) => {
    const tempModuleList = { ...this.state.moduleList };
    const keysArray = Object.keys(tempModuleList);
    const currentIndex = keysArray.indexOf(moduleKey);
    const nextModuleKey = keysArray.length > 1
      ? keysArray[currentIndex + 1 >= keysArray.length ? currentIndex - 1 : currentIndex + 1]
      : null;

    delete tempModuleList[moduleKey];
    // Single setState — no setTimeout delay
    this.setState({ moduleList: tempModuleList, selectedModuleKey: nextModuleKey });

    const entity = ConfigManager.getLockType(moduleKey.concat("_lockType"));
    this.releaselock(entity);
  };

  handleResponse = (response) => {
   
    
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (!isEmpty(response.data.attributeCache)) {
          const { appData, setAppData } = this.context;
          setAppData({
            ...appData,
            cache: { ...response.data.attributeCache },
          });
        }
      } else {
        if (response.errors != null) {
          let errMsg = "";
          let errList = [];
          response.errors.map(
            (err) => (
              (errMsg = errMsg + err.messageDescription),
              errList.push(err.messageDescription)
            )
          );
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };

  

  refreshCache = () => {
      this.setState({
        isLoading: true,
        loadingText: "Refreshing Cache",
      });
      const request = new RestAttributeCacheInputBean();
      request.companyCode = this.companyCode;
      MasterService.getAttributeCache(
        request,
        this.handleResponse,
        this.errorCallBack
      );
    }

  // ─────────────────────────────────────────────────────────────────
  // refreshCache_v1 — Resets the ENTIRE MODULE (re-mounts active tab)
  //   • Removes the currently active module from the tab list
  //   • Re-adds it in the next tick to force a clean full re-mount
  //   • Does NOT touch website cache or API — module state only
  // ─────────────────────────────────────────────────────────────────
  refreshCache_v1 = () => {
    const { selectedModuleKey, moduleList } = this.state;

    // If no active module, nothing to reset
    if (!selectedModuleKey || !moduleList[selectedModuleKey]) {
      console.warn("[refreshCache_v1] No active module to reset.");
      return;
    }

    console.log(`[refreshCache_v1] Resetting module: ${selectedModuleKey}`);
    this.setState({ isLoading: true, loadingText: "Resetting Module..." });

    // Snapshot the current module entry
    const currentModule = moduleList[selectedModuleKey];

    // Remove the module to unmount it completely
    const tempModuleList = { ...moduleList };
    delete tempModuleList[selectedModuleKey];

    // Re-add it in the next tick to force a clean re-mount
    this.setState({ moduleList: tempModuleList }, () => {
      const restoredList = { ...this.state.moduleList };
      restoredList[selectedModuleKey] = currentModule;
      this.setState(
        { moduleList: restoredList, selectedModuleKey },
        () => {
          this.setState({ isLoading: false, loadingText: "" });
          console.log(`[refreshCache_v1] Module reset complete: ${selectedModuleKey}`);
        }
      );
    });
  };



// Refreshes (re-mounts) the currently active module tab without touching the cache
  // handleRefresh = () => {
  //   const { selectedModuleKey, moduleList } = this.state;
  //   if (!selectedModuleKey || !moduleList[selectedModuleKey]) return;

  //   // Snapshot the current module entry
  //   const currentModule = moduleList[selectedModuleKey];

  //   // Remove the module from the list to unmount it
  //   const tempModuleList = { ...moduleList };
  //   delete tempModuleList[selectedModuleKey];

  //   // Re-add it in the next tick to force a clean re-mount
  //   this.setState({ moduleList: tempModuleList }, () => {
  //     const restoredList = { ...this.state.moduleList };
  //     restoredList[selectedModuleKey] = currentModule;
  //     this.setState({ moduleList: restoredList, selectedModuleKey });
  //   });
  // };

    // Re-mounts the active module tab — no API call
  handleRefresh = () => {
    const { selectedModuleKey, moduleList } = this.state;
    if (!selectedModuleKey || !moduleList[selectedModuleKey]) return;

    const currentModule = moduleList[selectedModuleKey];
    const tempModuleList = { ...moduleList };
    delete tempModuleList[selectedModuleKey];

    this.setState({ moduleList: tempModuleList }, () => {
      const restoredList = { ...this.state.moduleList };
      restoredList[selectedModuleKey] = currentModule;
      this.setState({ moduleList: restoredList, selectedModuleKey });
    });
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };

  erpEmbedDashboard = () => {
    this.setState({
      selectedModuleKey: "erp-I-dashBoard",
      // activeMenuKey: "erpEmbedDashboard",  
      openMenus: "erpEmbedDashboard",
      openSubMenus: {},
      sidebarOpen:true,
      activeTopMenu: null, activeTopSubMenu: null
    });
    this.addModule("erp-I-dashBoard");
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  };

  handleClickOutside = (event) => {
    const clickedInsideSidebar    = this.sidebarRef.current?.contains(event.target);
    const clickedInsideFlyout     = event.target.closest('.submenu-flyout-panel');
    const clickedInsideTopMenu    = this.topMenuRef.current?.contains(event.target);
    const clickedInsidePortalMenu = event.target.closest('[data-top-menu-portal]');

    this.setState({
      ...(!clickedInsideSidebar && !clickedInsideFlyout
        ? { openMenus: {}, activeSubMenu: null, activeSubmenu: null, flyoutItemRect: null }
        : {}),
      ...(!clickedInsideTopMenu && !clickedInsidePortalMenu
        ? { activeTopMenu: null, activeTopSubMenu: null, searchQuery: "", searchResults: [], isSearchFocused: false }
        : {}),
    });
  };

  toggleSidebar = () => {
    // this.setState(prev => ({
    //   sidebarOpen: !prev.sidebarOpen,
    //   openMenus: prev.sidebarOpen ? {} : prev.openMenus,
    //   openSubMenus: prev.sidebarOpen ? {} : prev.openSubMenus,
    //   activeSubMenu: null
    // }));
    this.setState(prev => {
    const newSidebarOpen = !prev.sidebarOpen;
    
    // Toggle parent context-container visibility
    const contextContainer = document.querySelector('.context-container');
    // if (contextContainer) {
      // if (newSidebarOpen) {
      //   contextContainer.style.display = 'block';
      // } else {
        // contextContainer.style.display = 'none';
      // }
    // }
    
    return {
      sidebarOpen: newSidebarOpen,
      openMenus: newSidebarOpen ? prev.openMenus : {},
      openSubMenus: newSidebarOpen ? prev.openSubMenus : {},
      activeSubMenu: null
    };
  });
  };

  toggleMenu = (menuKey) => {
   
    
    const isCurrentlyOpen = !!this.state.openMenus[menuKey];

    if (isCurrentlyOpen) {
      // Already open — just close it
      this.setState({ openMenus: {}, activeSubMenu: null, flyoutItemRect: null });
      return;
    }

    if (!this.state.sidebarOpen) {
      // Sidebar is collapsed — expand it first, then open menu after transition
      this.setState({ sidebarOpen: true, openMenus: {}, activeSubMenu: null, flyoutItemRect: null });
      setTimeout(() => {
        this.setState({ openMenus: { [menuKey]: true } });
      }, 230); // wait for CSS transition (0.22s) to finish
    } else {
      // Sidebar already expanded — open immediately
      this.setState({ openMenus: { [menuKey]: true }, activeSubMenu: null });
    }
  };
closeMenu = () => {
    this.setState({ openMenus: {}, activeSubMenu: null, flyoutItemRect: null });
  };

  toggleSubMenu = (menuKey, subKey) => {

    const compoundKey = `${menuKey}_${subKey}`;

    this.setState(prev => {
      const updated = { ...prev.openSubMenus };

      Object.keys(updated).forEach(k => {
        if (k.startsWith(menuKey + "_") && k !== compoundKey) {
          updated[k] = false;
        }
      });

      updated[compoundKey] = !prev.openSubMenus[compoundKey];

      return { openSubMenus: updated };
    });
  };

  changeMenu = () => {
     const next = !this.state.isChangeMenu;
    localStorage.setItem("isChangeMenu", next);
    this.setState({
      isChangeMenu: next,
      activeSubMenu: null,
      activeTopMenu: null,
      activeTopSubMenu: null,
      openMenus: {},
      openSubMenus: {},
      openSlideMenus: {},
      searchQuery: "",
      searchResults: [],
      isSearchFocused: false,
      searchHighlightIndex: -1,
    });
  };

  // ========== SEARCH METHODS ==========
  handleSearchChange = (e) => {
    const query = e.target.value;
    if (!query.trim()) {
      this.setState({ searchQuery: query, searchResults: [], searchHighlightIndex: -1 });
      return;
    }
    const results = this.buildSearchResults(query.trim().toLowerCase());
    this.setState({ searchQuery: query, searchResults: results, searchHighlightIndex: -1 });
  };

  clearSearch = () => {
    this.setState({ searchQuery: "", searchResults: [], isSearchFocused: false, searchHighlightIndex: -1, searchTooltip: null });
    clearTimeout(this._tooltipHideTimer);
  };

  // Show tooltip — calculates smart position based on available screen space
  showSearchTooltip = (e, result) => {
    clearTimeout(this._tooltipHideTimer);
    const r      = e.currentTarget.getBoundingClientRect();
    const tipW   = 240;
    const tipH   = 160; // approx
    const spaceR = window.innerWidth - r.right;
    const spaceL = r.left;
    // prefer right; flip left if not enough room
    const left = spaceR >= tipW + 12
      ? r.right + 8
      : spaceL >= tipW + 12
        ? r.left - tipW - 8
        : Math.max(8, Math.min(r.left, window.innerWidth - tipW - 8));
    // clamp top so tooltip doesn't go off bottom
    const top = Math.min(r.top, window.innerHeight - tipH - 8);
    this.setState({ searchTooltip: { result, left, top } });
  };

  hideSearchTooltip = () => {
    this._tooltipHideTimer = setTimeout(() => {
      this.setState({ searchTooltip: null });
    }, 120); // small delay so moving mouse to tooltip doesn't flicker
  };

  keepSearchTooltip = () => {
    clearTimeout(this._tooltipHideTimer);
  };

  handleSearchKeyDown = (e) => {
    const { searchResults, searchHighlightIndex } = this.state;
    if (!searchResults.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const next = searchHighlightIndex < searchResults.length - 1 ? searchHighlightIndex + 1 : 0;
      this.setState({ searchHighlightIndex: next }, () => {
        this.scrollSearchItemIntoView(next);
        this.showTooltipForIndex(next);
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const prev = searchHighlightIndex > 0 ? searchHighlightIndex - 1 : searchResults.length - 1;
      this.setState({ searchHighlightIndex: prev }, () => {
        this.scrollSearchItemIntoView(prev);
        this.showTooltipForIndex(prev);
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      const idx = searchHighlightIndex >= 0 ? searchHighlightIndex : 0;
      if (searchResults[idx]) {
        this.handleSearchResultClick(searchResults[idx]);
      }
    } else if (e.key === "Escape") {
      this.clearSearch();
    }
  };

  scrollSearchItemIntoView = (idx) => {
    // scroll the highlighted item into view inside both possible dropdowns
    const containers = document.querySelectorAll(".search-results-dropdown");
    containers.forEach(container => {
      const items = container.querySelectorAll(".search-result-item");
      if (items[idx]) {
        items[idx].scrollIntoView({ block: "nearest" });
      }
    });
  };

  // Show tooltip anchored to the DOM item at position idx (used for keyboard nav)
  showTooltipForIndex = (idx) => {
    const { searchResults } = this.state;
    if (!searchResults[idx]) return;
    clearTimeout(this._tooltipHideTimer);

    // Find the highlighted item across any rendered dropdown
    const containers = document.querySelectorAll(".search-results-dropdown");
    let el = null;
    containers.forEach(container => {
      const items = container.querySelectorAll(".search-result-item");
      if (items[idx]) el = items[idx];
    });
    if (!el) return;

    const r    = el.getBoundingClientRect();
    const tipW = 240;
    const tipH = 160;
    const spaceR = window.innerWidth - r.right;
    const spaceL = r.left;
    const left = spaceR >= tipW + 12
      ? r.right + 8
      : spaceL >= tipW + 12
        ? r.left - tipW - 8
        : Math.max(8, Math.min(r.left, window.innerWidth - tipW - 8));
    const top = Math.min(r.top, window.innerHeight - tipH - 8);
    this.setState({ searchTooltip: { result: searchResults[idx], left, top } });
  };

  buildSearchResults = (query) => {
    const results = [];
    if (!this.mainMenus) return results;

    Object.entries(this.mainMenus).forEach(([menuKey, menu]) => {
      if (!menu.isAccessible) return;

      Object.entries(menu.subMenus).forEach(([subKey, sub]) => {
        if (!sub.isAccessible) return;
        const displayLabel = sub.label || subKey;

        // directRoute submenus (no children) — match the submenu label itself
        if (sub.directRoute) {
          if (displayLabel.toLowerCase().includes(query) || subKey.toLowerCase().includes(query)) {
            results.push({
              type: "direct",
              menuKey,
              subKey,
              label: displayLabel,
              icon: sub.icon,
              directKey: sub.directKey,
              breadcrumb: `${menuKey} › ${displayLabel}`,
            });
          }
          return;
        }

        // submenus with items — match sub label or item labels
        if (displayLabel.toLowerCase().includes(query) || subKey.toLowerCase().includes(query)) {
          results.push({
            type: "submenu",
            menuKey,
            subKey,
            label: displayLabel,
            icon: sub.icon,
            breadcrumb: `${menuKey} › ${displayLabel}`,
          });
        }

        if (sub.items) {
          sub.items.forEach((item) => {
            if (!item.isAccessible) return;
            if (item.label.toLowerCase().includes(query) || item.key.toLowerCase().includes(query)) {
              results.push({
                type: "item",
                menuKey,
                subKey,
                itemKey: item.key,
                label: item.label,
                icon: item.icon,
                breadcrumb: `${menuKey} › ${displayLabel} › ${item.label}`,
              });
            }
          });
        }
      });
    });

    return results.slice(0, 30); // cap at 30 results
  };

  handleSearchResultClick = (result) => {
    if (result.type === "direct") {
      this.menuItemOnclick(result.directKey);
    } else if (result.type === "item") {
      this.menuItemOnclick(result.itemKey);
    } else if (result.type === "submenu") {
      // open the parent menu and expand the submenu
      if (this.state.isChangeMenu) {
        this.setState({
          activeTopMenu: result.menuKey,
          activeTopSubMenu: null,
        });
      } else {
        this.setState(
          { sidebarOpen: true, openMenus: { [result.menuKey]: true } },
          () => {
            this.setState({
              openSubMenus: { [`${result.menuKey}_${result.subKey}`]: true },
            });
          }
        );
      }
    }
    this.clearSearch();
  };

  

// ── Cached footer height — avoids repeated DOM queries on every click ──
  _cachedFooterHeight = () => {
    if (this._footerHeight !== undefined) return this._footerHeight;
    const footer = document.querySelector('footer') ||
                   document.querySelector('.footer') ||
                   document.querySelector('[class*="footer"]') ||
                   document.querySelector('[class*="copyright"]');
    this._footerHeight = footer ? footer.offsetHeight : 0;
    return this._footerHeight;
  };
calculateFlyoutPosition = (element, itemRect) => {
  const isTopMenuMode = this.state.isChangeMenu;
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;
  const flyoutWidth = 400;

  // ── FALLBACK ─────────────────────────────────────────────────────────────
  if (!itemRect && !element) {
    return {
      position: 'fixed',
      top: '100px',
      left: '520px',
      maxHeight: '50vh',
      width: `${flyoutWidth}px`,
      zIndex: 99999,
    };
  }

  // ── Item position — use stored click-time rect (most accurate) ────────────
  let itemTop, itemRight, itemLeft;
  if (itemRect) {
    itemTop   = itemRect.top;
    itemRight = itemRect.right;
    itemLeft  = itemRect.left;
  } else {
    const r = element.getBoundingClientRect();
    itemTop   = r.top;
    itemRight = r.right;
    itemLeft  = r.left;
  }

  // ── HORIZONTAL: right of the submenu panel ────────────────────────────────
  let left;
  const panel = element
    ? (element.closest('.submenu-flyout-panel') || element.closest('.dropdown-item-with-submenu'))
    : null;

  if (panel) {
    const panelRect = panel.getBoundingClientRect();
    const isDropdownItem = panel.classList.contains('dropdown-item-with-submenu');
    left = isDropdownItem ? itemRight + 4 : panelRect.right + 4;
  } else {
    const sidebarEl = this.sidebarRef?.current;
    left = sidebarEl
      ? sidebarEl.getBoundingClientRect().right + 6
      : (this.state.sidebarOpen ? 226 : 70);
  }

  // Flip left if off-screen right
  if (left + flyoutWidth > viewportWidth - 20) {
    left = panel
      ? (panel.classList.contains('dropdown-item-with-submenu')
          ? itemLeft - flyoutWidth - 4
          : panel.getBoundingClientRect().left - flyoutWidth - 4)
      : 20;
    if (left < 20) left = 20;
  }

  // ── VERTICAL: align with item, anchor bottom when near footer ─────────────
  const footerHeight = this._cachedFooterHeight();
  const minTop       = isTopMenuMode ? 70 : 60;
  // The boundary we must not cross (above footer / bottom of viewport)
  const bottomBoundary = viewportHeight - footerHeight - 20;

  // Space available below the item
  const spaceBelow = bottomBoundary - itemTop;

  if (spaceBelow >= 120) {
    // Enough room: start at the item's top, scroll if content is tall
    const top       = Math.max(itemTop, minTop);
    const maxHeight = Math.min(bottomBoundary - top, viewportHeight * 0.75);
    return {
      position: 'absolute',
      top:       `${top}px`,
      left:      `${left}px`,
      maxHeight: `${maxHeight}px`,
      width:     `${flyoutWidth}px`,
      zIndex:    99999,
    };
  } else {
    // Near footer: anchor the flyout's BOTTOM to the boundary so it grows upward
    // and always stays fully visible above the footer.
    const bottom    = viewportHeight - bottomBoundary;   // distance from viewport bottom
    const maxHeight = Math.min(bottomBoundary - minTop, viewportHeight * 0.75);
    return {
      position:  'absolute',
      bottom:    `${bottom}px`,
      left:      `${left}px`,
      maxHeight: `${maxHeight}px`,
      width:     `${flyoutWidth}px`,
      zIndex:    99999,
    };
  }
};
calculateFlyoutPosition_v1 = (element, itemRect) => {
   // ─────────────────────────────────────────────────────────────────────────
  // Context: styles `.top-menu-dropdown.level-3`
  //
  // This element is NOT portalled — it lives inside `.dropdown-item-with-submenu`
  // which has `position: relative`. The CSS already handles the base case:
  //   .top-menu-dropdown.level-3 { position:absolute; top:0; left:100%; }
  //
  // This function's ONLY job is to handle viewport edge cases:
  //   - Flip LEFT  when flyout would bleed off the right edge
  //   - Cap height when flyout would bleed below the viewport / footer
  //
  // We use position:'absolute' always (relative to the parent item),
  // and only override `left` and `maxHeight` — never `top` (CSS handles it).
  // ─────────────────────────────────────────────────────────────────────────

  const viewportWidth  = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const flyoutWidth    = 400;
  const footerHeight   = this._cachedFooterHeight();
  const bottomBoundary = viewportHeight - footerHeight - 8;

  // No element ref — return safe CSS-driven defaults
  if (!element) {
    return {
      position:  'absolute',
      top:       '0',
      left:      '100%',
      width:     `${flyoutWidth}px`,
      maxHeight: '60vh',
      overflowY: 'auto',
      zIndex:    1001,
    };
  }

  const rect = element.getBoundingClientRect();

  // ── HORIZONTAL ────────────────────────────────────────────────────────────
  // Default: CSS puts it to the right (left:100% of parent).
  // The parent's right edge in viewport coords is rect.right.
  // Check if flyout would overflow the viewport right edge.
  const spaceRight = viewportWidth - rect.right;
  const flipLeft   = spaceRight < flyoutWidth + 8;

  // When flipping left: position is relative to parent, so use negative offset.
  // Parent width ≈ rect.width. Flyout left edge = -(flyoutWidth + margin).
  const leftValue  = flipLeft
    ? `calc(-${flyoutWidth}px - 8px)`   // flip: appear to the left of parent
    : '100%';                            // default: appear to the right

  // ── VERTICAL ──────────────────────────────────────────────────────────────
  // rect.top = top of the parent item in viewport coords.
  // Flyout starts at top:0 of parent = same as rect.top.
  // Calculate how much vertical space is available downward from there.
  const spaceBelow = bottomBoundary - rect.top;
  const maxHeight  = Math.min(
    Math.max(spaceBelow - 4, 80),  // at least 80px always
    viewportHeight * 0.7            // never more than 70% of screen
  );

  // If there's very little space below, anchor bottom of flyout to boundary.
  // This is done via maxHeight cap — the flyout scrolls internally.
  const topValue = spaceBelow < 120 && rect.bottom < bottomBoundary
    ? `calc(${bottomBoundary - rect.bottom - maxHeight}px)`  // nudge up
    : '0';

  return {
    position:  'absolute',
    top:       topValue,
    left:      leftValue,
    width:     `${flyoutWidth}px`,
    maxHeight: `${maxHeight}px`,
    overflowY: 'auto',
    zIndex:    1001,
  };
};
//   const isTopMenuMode = this.state.isChangeMenu;
//   const viewportHeight = window.innerHeight;
//   const viewportWidth = window.innerWidth;
//   const flyoutWidth = 400;

//   // ── FALLBACK ─────────────────────────────────────────────────────────────
//   if (!itemRect && !element) {
//     return {
//       position: 'absolute',
//       // top: '100px',
//       left: '0',
//       maxHeight: '50vh',
//       width: `${flyoutWidth}px`,
//       zIndex: 99999,
//     };
//   }

//   // ── Item position — use stored click-time rect (most accurate) ────────────
//   let itemTop, itemRight, itemLeft;
//   if (itemRect) {
//     itemTop   = itemRect.top;
//     itemRight = itemRect.right;
//     itemLeft  = itemRect.left;
//   } else {
//     const r = element.getBoundingClientRect();
//     itemTop   = r.top;
//     itemRight = r.right;
//     itemLeft  = r.left;
//   }

//   // ── HORIZONTAL: right of the submenu panel ────────────────────────────────
//   let left;
//   const panel = element
//     ? (element.closest('.submenu-flyout-panel') || element.closest('.dropdown-item-with-submenu'))
//     : null;

//   if (panel) {
//     const panelRect = panel.getBoundingClientRect();
//     const isDropdownItem = panel.classList.contains('dropdown-item-with-submenu');
//     left = isDropdownItem ? itemRight + 4 : panelRect.right + 4;
//   } else {
//     const sidebarEl = this.sidebarRef?.current;
//     left = sidebarEl
//       ? sidebarEl.getBoundingClientRect().right + 6
//       : (this.state.sidebarOpen ? 226 : 70);
//   }

//   // Flip left if off-screen right
//   if (left + flyoutWidth > viewportWidth - 20) {
//     left = panel
//       ? (panel.classList.contains('dropdown-item-with-submenu')
//           ? itemLeft - flyoutWidth - 4
//           : panel.getBoundingClientRect().left - flyoutWidth - 4)
//       : 20;
//     if (left < 20) left = 20;
//   }

//   // ── VERTICAL: align with item, anchor bottom when near footer ─────────────
//   const footerHeight = this._cachedFooterHeight();
//   const minTop       = isTopMenuMode ? 70 : 60;
//   // The boundary we must not cross (above footer / bottom of viewport)
//   const bottomBoundary = viewportHeight - footerHeight - 20;

//   // Space available below the item
//   const spaceBelow = bottomBoundary - itemTop;

//   if (spaceBelow >= 120) {
//     // Enough room: start at the item's top, scroll if content is tall
//     const top       = Math.max(itemTop, minTop);
//     const maxHeight = Math.min(bottomBoundary - top, viewportHeight * 0.75);
//     return {
//       position: 'absolute',
//       // top:       `${top}px`,
//       left:      `${left}px`,
//       maxHeight: `${maxHeight}px`,
//       width:     `${flyoutWidth}px`,
//       zIndex:    99999,
//     };
//   } else {
//     // Near footer: anchor the flyout's BOTTOM to the boundary so it grows upward
//     // and always stays fully visible above the footer.
//     const bottom    = viewportHeight - bottomBoundary;   // distance from viewport bottom
//     const maxHeight = Math.min(bottomBoundary - minTop, viewportHeight * 0.75);
//     return {
//       position:  'absolute',
//       bottom:    `${bottom}px`,
//       left:      `${left}px`,
//       maxHeight: `${maxHeight}px`,
//       width:     `${flyoutWidth}px`,
//       zIndex:    99999,
//     };
//   }
// };

// getDropdownStyle = () => {
//   const el = this.topMenuItemRefs[menuKey];  // ref on the button
//   const rect = el.getBoundingClientRect();   // exact screen position
//   return {
//     position: 'fixed',
//     top: `${rect.bottom + 4}px`,   // exactly below the button
//     left: `${rect.left}px`,        // aligned to button left
//     maxHeight: '75vh',             // never overflows screen
//     overflowY: 'auto',             // scrollable if many items
//   };
// };

calculateSubmenuPosition = (element) => {
  const isTopMenuMode = this.state.isChangeMenu;
  
  // ========== TOP MENU MODE ==========
  if (isTopMenuMode) {
    if (!element) {
      return { 
        position: 'absolute', 
        top: '100px', 
        left: '20px',
        maxHeight: '70vh',
        width: '280px',
        zIndex: 99998,
      };
    }

    const rect = element.getBoundingClientRect();
    const left = rect.left;
    const top = rect.bottom + 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const panelWidth = 280;
    
    // Adjust left position if it would go off-screen
    let adjustedLeft = left;
    if (left + panelWidth > viewportWidth) {
      adjustedLeft = viewportWidth - panelWidth - 20;
    }
    if (adjustedLeft < 20) {
      adjustedLeft = 20;
    }
    
    const maxHeight = Math.min(viewportHeight - top - 20, viewportHeight * 0.7);
    return {
      position: 'absolute',
      top: `${top}px`,
      left: `${adjustedLeft}px`,
      maxHeight: `${maxHeight}px`,
      width: '280px',
      zIndex: 99998,
    };
  }

  // ========== SIDEBAR MODE WITH FOOTER HANDLING ==========
  // Always read actual sidebar right edge from DOM — handles collapsed/expanded correctly
  const sidebarEl = this.sidebarRef?.current;
  const left = sidebarEl ? sidebarEl.getBoundingClientRect().right + 6
                         : (this.state.sidebarOpen ? 196 : 66);

  if (!element) {
    return { 
      position: 'absolute', 
      top: '60px', 
      left: `${left}px`,
      maxHeight: '60vh',
      width: '280px',
      zIndex: 99998,
    };
  }

  const rect = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  
  // GET FOOTER HEIGHT
  // const footer = document.querySelector('footer') || 
  //                document.querySelector('.footer') ||
  //                document.querySelector('[class*="footer"]') ||
  //                document.querySelector('[class*="copyright"]');
  
  // const footerHeight = footer ? footer.offsetHeight : 40; 

    const footerHeight = this._cachedFooterHeight(); // cached DOM lookup
  
  // Calculate available space (viewport - footer)
  const availableHeight = viewportHeight - footerHeight;
  const panelEstimatedHeight = 300;

  // Start panel at the top of the clicked menu item
  let top = rect.top;

  // If panel would overflow into the footer, shift it up
  if (top + panelEstimatedHeight > availableHeight - 20) {
    top = Math.max(availableHeight - panelEstimatedHeight - 20, 60);
  }

  // Never go above viewport top
  if (top < 60) top = 60;

  // Calculate maxHeight accounting for footer
  const maxHeight = Math.min(
    availableHeight - top - 20, 
    availableHeight * 0.78
  );


  return {
    position: 'absolute',
    top: `${top}px`,
    left: `${left}px`,
    maxHeight: `${maxHeight}px`,
    width: '280px',
    zIndex: 99998,
  };
};





  render() {
   
    if (!this.state.permissionsLoaded || !this.mainMenus || Object.keys(this.mainMenus).length === 0) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
          color: '#666'
        }}>
          Loading menus...
        </div>
      );
    }

    const { isOpen } = this.state;

    return (
      <div className="main-container">
        <ProgressBar
          progressLoadingText={this.state.loadingText}
          isShowPopup={this.state.isLoading}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <div className="">
          <div className={this.state.isChangeMenu ? "align-site_v2" : "align-site"}>

           


           {!this.state.isChangeMenu && (
  <div className={`sidebar ${this.state.sidebarOpen ? "expanded" : "collapsed"}`} ref={this.sidebarRef}>

    {/* ── SIDEBAR HEADER: Logo (centered) + collapse toggle (top-right) ── */}
    <div className="sidebar-header" style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 8px 6px" }}>
      {this.state.sidebarOpen && (
        <div>
        <img src={logo} alt="Advance ERP Logo" style={{ height: "36px", objectFit: "contain" }} />
           {/* Company version */}
      {this.state.sidebarOpen && (
        <div className="info-item" style={{ flexShrink: 0 }}>
          <span 
          // style={{ fontWeight: 700, fontSize: "11px", letterSpacing: "0.5px", opacity: 0.7 }}
          >{this.state.appVersion}</span>
        </div>
      )}
        
          </div>
      )}
      <div
        className="sidebar-toggle"
        onClick={this.toggleSidebar}
        style={{ position: "absolute", right: "6px", top: "50%", transform: "translateY(-50%)" }}
      >
        {this.state.sidebarOpen ? <FaChevronLeft size={13} /> : <FaChevronRight size={13} />}
      </div>
    </div>

    {/* ── TOP / SIDE toggle ── */}
    {this.state.sidebarOpen && (
      <div style={{ display: "flex", justifyContent: "center", padding: "4px 8px 6px" }}>
        <button
          className={`menu-mode-toggle ${this.state.isChangeMenu ? "is-top" : "is-side"}`}
          onClick={this.changeMenu}
        >
          <span className="mmt-option mmt-top">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <rect x="2" y="3" width="20" height="4" rx="1"/>
              <rect x="2" y="10" width="20" height="2" rx="1" opacity="0.5"/>
              <rect x="2" y="15" width="14" height="2" rx="1" opacity="0.5"/>
            </svg>
            TOP
          </span>
          <span className="mmt-track"><span className="mmt-thumb" /></span>
          <span className="mmt-option mmt-side">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <rect x="2" y="3" width="6" height="18" rx="1"/>
              <rect x="11" y="3" width="11" height="2" rx="1" opacity="0.5"/>
              <rect x="11" y="8" width="9" height="2" rx="1" opacity="0.5"/>
              <rect x="11" y="13" width="11" height="2" rx="1" opacity="0.5"/>
            </svg>
            SIDE
          </span>
        </button>
      </div>
    )}

    {/* ── Refresh row ── */}
    <div
      onClick={() => this.refreshCache()}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "11px",
        padding: "10px 14px",
        margin: "2px 6px",
        borderRadius: "9px",
        cursor: "pointer",
        color: "rgba(226,232,240,0.75)",
      }}
      onMouseEnter={e => e.currentTarget.style.background = "rgba(56,189,248,0.10)"}
      onMouseLeave={e => e.currentTarget.style.background = "transparent"}
    >
      <REFRESHICON />
      {this.state.sidebarOpen && (
        <span style={{ fontSize: "13.5px", fontWeight: 500, whiteSpace: "nowrap", color: "rgba(226,232,240,0.88)" }}>
          Refresh Cache
        </span>
      )}
    </div>
    <div>
        {/* ── Inline Search — right of admin ── */}
      {this.state.sidebarOpen && (
        <div className="sidebar-inline-search" ref={(el) => { this._sidebarSearchRef = el; }}>
          <span className="search-icon">
            <RiSearchEyeFill size={13} />
          </span>
          <input
            type="text"
            placeholder="Search…"
            value={this.state.searchQuery}
            onChange={this.handleSearchChange}
            onKeyDown={this.handleSearchKeyDown}
            onFocus={() => this.setState({ isSearchFocused: true })}
          />
          {this.state.searchQuery && (
            <span className="search-clear" onClick={this.clearSearch}>✕</span>
          )}

          {/* Search results dropdown — portalled */}
          {this.state.searchQuery && ReactDOM.createPortal(
            <div
              data-top-menu-portal="true"
              className="search-results-dropdown"
              style={{
                position: "fixed",
                top:  (() => { const r = this._sidebarSearchRef?.getBoundingClientRect(); return r ? r.bottom + 6 : 100; })(),
                left: (() => { const r = this._sidebarSearchRef?.getBoundingClientRect(); return r ? r.left : 10; })(),
                width: "240px",
                background: "#fff",
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.14)",
                zIndex: 99999,
                maxHeight: "320px",
                overflowY: "auto",
              }}
              onMouseEnter={this.keepSearchTooltip}
              onMouseLeave={this.hideSearchTooltip}
            >
              {this.state.searchResults.length === 0 ? (
                <div style={{ padding: "14px 12px", fontSize: "12px", color: "#999", textAlign: "center" }}>
                  No results found
                </div>
              ) : (
                this.state.searchResults.map((result, idx) => (
                  <div
                    key={idx}
                    className="search-result-item"
                    onClick={(e) => { e.stopPropagation(); this.handleSearchResultClick(result); }}
                    onMouseEnter={(e) => { this.setState({ searchHighlightIndex: idx }); this.showSearchTooltip(e, result); }}
                    onMouseLeave={this.hideSearchTooltip}
                    style={{
                      padding: "7px 12px",
                      cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                      display: "flex",
                      alignItems: "flex-start",
                      background: this.state.searchHighlightIndex === idx ? "#e8eeff" : "transparent",
                      borderLeft: this.state.searchHighlightIndex === idx ? "3px solid #4a6cf7" : "3px solid transparent",
                      transition: "background 0.1s",
                    }}
                  >
                    <span style={{ flexShrink: 0, width: "22px", paddingTop: "2px", opacity: 0.6, display: "flex", alignItems: "center", justifyContent: "center" }}>{result.icon}</span>
                    <div style={{ flex: 1, minWidth: 0, paddingLeft: "6px" }}>
                      <div style={{ fontSize: "12px", fontWeight: 600, color: "#222", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{result.label}</div>
                      <div style={{ fontSize: "10px", color: "#888", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: "1px" }}>{result.breadcrumb}</div>
                    </div>
                  </div>
                ))
              )}
            </div>,
            document.body
          )}
        </div>
      )}
      </div>

    {/* ── EyeDashboard ── */}
    <div className={`Submenu-item ${this.state.openMenus === 'erpEmbedDashboard' ? 'active' : ''}`} onClick={this.erpEmbedDashboard}>
      <FaEye size={20} />
      {this.state.sidebarOpen && (
        <span className="menu-text">EyeDashboard</span>
      )}
    </div>

    {/* DYNAMIC MENU ITEMS */}
    {Object.entries(this.mainMenus).map(([menuKey, menu]) => {
      if (!menu.isAccessible) return null;

      const isMenuOpen = this.state.openMenus[menuKey];
       const isActive = this.state.activeMenuKey && 
                   this.state.activeMenuKey.startsWith(menuKey);  // ← Match menu family

      return (
        <div key={menuKey}>

          {/* ── Top-level menu row — ref captured for submenu positioning ── */}
          <div
            className={`Submenu-item ${isMenuOpen ? 'active' : ''}`}
            ref={(el) => (this.menuRefs = this.menuRefs || {}) && (this.menuRefs[menuKey] = el)}
            onClick={() => this.toggleMenu(menuKey)}
          >
            {menu.icon}

            {this.state.sidebarOpen && (
              <span className="menu-text">{menuKey}</span>
            )}

            {this.state.sidebarOpen && (
              <FaChevronDown
                size={16}
                className={`chevron ${isMenuOpen ? "rotate" : ""}`}
              />
            )}
          </div>

          {/* ── Submenu: rendered as fixed flyout via portal (outside sidebar DOM) ── */}
          {isMenuOpen && ReactDOM.createPortal(
            <div
              className="submenu-flyout-panel"
              style={this.calculateSubmenuPosition(this.menuRefs?.[menuKey])}
            >
              {/* Panel header */}
              <div className="submenu-flyout-title">{menuKey}</div>

              {/* Items */}
              {Object.entries(menu.subMenus).map(([subKey, sub]) => {
                if (!sub.isAccessible) return null;

                const compoundKey = `${menuKey}_${subKey}`;
                const isActive = this.state.activeSubMenu === compoundKey;

                const displayLabel = sub.label || subKey;
                const isLong = displayLabel.length > 30;
                const truncatedLabel = isLong
                  ? displayLabel.slice(0,30) + "..."
                  : displayLabel;

                // ── directRoute: plain clickable row ──
                if (sub.directRoute) {
                  return (
                    <OverlayTrigger
                      key={subKey}
                      placement="right"
                      overlay={
                        isLong ? (
                          <Popover id={`popover-${subKey}`}>
                            <Popover.Body>{displayLabel}</Popover.Body>
                          </Popover>
                        ) : <span />
                      }
                    >
                      <div
                        className="submenu-flyout-item"
                        onClick={() => {
                          if (sub.label === "Refresh Cache") {
                            this.refreshCache_v1();
                          } else {
                            this.menuItemOnclick(sub.directKey, sub.icon); // ✅ pass icon
                          }
                        }}
                      >
                        <span className="submenu-flyout-item-icon">{sub.icon}</span>
                        <span>{truncatedLabel}</span>
                      </div>
                    </OverlayTrigger>
                  );
                }

                // ── has nested items (e.g. MassMaintenance) ──
                return (
                  <div
                    key={subKey}
                    className="submenu-item-wrapper"
                    ref={(el) => this.submenuRefs[compoundKey] = el}
                  >
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        isLong ? (
                          <Popover id={`popover-${subKey}`}>
                            <Popover.Body>{displayLabel}</Popover.Body>
                          </Popover>
                        ) : <span />
                      }
                    >
                      <div
                        className={`submenu-flyout-item has-children ${isActive ? 'active' : ''}`}
                        onClick={(e) => {
                          if (isActive) {
                            this.setState({ activeSubMenu: null, flyoutItemRect: null });
                          } else {
                            // Capture the exact screen position of THIS item right now
                            const rect = e.currentTarget.getBoundingClientRect();
                            this.setState({
                              activeSubMenu: compoundKey,
                              flyoutItemRect: {
                                top: rect.top,
                                bottom: rect.bottom,
                                left: rect.left,
                                right: rect.right,
                              }
                            });
                          }
                        }}
                      >
                        <span className="submenu-flyout-item-icon">{sub.icon}</span>
                        <span>{truncatedLabel}</span>
                        <span className="arrow-right">›</span>
                      </div>
                    </OverlayTrigger>

                    {/* Level-3 flyout — portalled outside panel, onMouseDown fires before handleClickOutside */}
                    {isActive && ReactDOM.createPortal(
                      <div
                        className="flyout"
                        style={this.calculateFlyoutPosition(this.submenuRefs[compoundKey], this.state.flyoutItemRect)}
                      >
                        {sub.items.map(item =>
                          item.isAccessible && (
                            <div
                              key={item.key}
                              className="flyout-item"
                              onMouseDown={(e) => {
                                e.stopPropagation();
                                this.menuItemOnclick(item.key, item.icon); // ✅ pass icon
                              }}
                            >
                              {item.icon && <span className="flyout-item-icon">{item.icon}</span>}
                              <span>{item.label}</span>
                            </div>
                          )
                        )}
                      </div>,
                      document.body
                    )}
                  </div>
                );
              })}
            </div>,
            document.body
          )}

        </div>
      );
    })}

    {/* ── Logout pinned at bottom of sidebar ── */}
   {/* ── Bottom Section ── */}
<div
  style={{
    marginTop: "auto",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    paddingTop: "8px",
    paddingBottom: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  }}
>
  {/* ── User Info ── */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "11px",
      padding: "10px 14px",
      margin: "0 6px",
      borderRadius: "9px",
      color: "rgba(226,232,240,0.80)",
    }}
  >
    <span style={{ fontSize: "18px", flexShrink: 0, lineHeight: 1 }}>👤</span>
    {this.state.sidebarOpen && (
      <span style={{ fontSize: "13.5px", fontWeight: 500, whiteSpace: "nowrap", color: "rgba(226,232,240,0.88)", overflow: "hidden", textOverflow: "ellipsis" }}>
        {this.state.userCode}
      </span>
    )}
  </div>

  {/* ── Logout ── */}
  <a
    href="logout"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "11px",
      padding: "10px 14px",
      margin: "0 6px",
      borderRadius: "9px",
      cursor: "pointer",
      color: "rgba(226,232,240,0.80)",
      textDecoration: "none",
    }}
    onMouseEnter={e => e.currentTarget.style.background = "rgba(56,189,248,0.10)"}
    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      style={{ flexShrink: 0, color: "rgba(226,232,240,0.80)" }}
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
    {this.state.sidebarOpen && (
      <span style={{ fontSize: "13.5px", fontWeight: 500, whiteSpace: "nowrap", color: "rgba(226,232,240,0.88)" }}>Logout</span>
    )}
  </a>
</div>
  </div>
)}


         
            {this.state.isChangeMenu && (
  <div className="top-menubar" ref={this.topMenuRef} style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "nowrap", overflow: "hidden" }}>

    {/* ── LEFT GROUP: Logo ── */}
    <div style={{ flexShrink: 0, display: "flex", alignItems: "center", paddingLeft: "8px" }}>
      <img src={logo} alt="Advance ERP Logo" style={{ height: "30px", objectFit: "contain" }} />
    {/* ── Company code ── */}
    <div className="info-item" style={{ flexShrink: 0 }}>
      <span style={{ fontWeight: 700, fontSize: "11px", letterSpacing: "0.4px" }}>{this.state.appVersion}</span>
    </div>
    </div>

    {/* ── TOP / SIDE toggle ── */}
    <div style={{ flexShrink: 0 }}>
      <button
        className={`menu-mode-toggle ${this.state.isChangeMenu ? "is-top" : "is-side"}`}
        onClick={this.changeMenu}
      >
        <span className="mmt-option mmt-top">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <rect x="2" y="3" width="20" height="4" rx="1"/>
            <rect x="2" y="10" width="20" height="2" rx="1" opacity="0.5"/>
            <rect x="2" y="15" width="14" height="2" rx="1" opacity="0.5"/>
          </svg>
          TOP
        </span>
        <span className="mmt-track"><span className="mmt-thumb" /></span>
        <span className="mmt-option mmt-side">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <rect x="2" y="3" width="6" height="18" rx="1"/>
            <rect x="11" y="3" width="11" height="2" rx="1" opacity="0.5"/>
            <rect x="11" y="8" width="9" height="2" rx="1" opacity="0.5"/>
            <rect x="11" y="13" width="11" height="2" rx="1" opacity="0.5"/>
          </svg>
          SIDE
        </span>
      </button>
    </div>

    

    {/* ── Refresh ── */}
    <div className="refresh-icon-wrap_v1" style={{ flexShrink: 0 }} onClick={() => this.refreshCache()}>
      <REFRESHICON />
    </div>

    

    {/* ── EyeDashboard ── */}
    <div className="top-menu-item" style={{ flexShrink: 0 }} onClick={() => this.erpEmbedDashboard()}>
      <FaEye size={18} />
      {/* <span style={{
        //  fontSize: "11px",
         marginLeft: "4px" }}>EyeDashboard</span> */}
    </div>

    {/* ── MENUS (center-scrollable area) ── */}
    <div className="top-menu-items" style={{ flex: 1, minWidth: 0, display: "flex", alignItems: "center", overflow: "auto" }}>

      {Object.entries(this.mainMenus).map(([menuKey, menu]) => {
        if (!menu.isAccessible) return null;
        const isOpen = this.state.activeTopMenu === menuKey;
        return (
          <div
            key={menuKey}
            className="top-menu-item"
            style={{ flexShrink: 0 }}
            ref={(el) => { this._topNavRefs = this._topNavRefs || {}; this._topNavRefs[menuKey] = el; }}
            onClick={() => {
              const el = this._topNavRefs?.[menuKey];
              const rect = el ? el.getBoundingClientRect() : null;
              this.setState((prev) => ({
                activeTopMenu: prev.activeTopMenu === menuKey ? null : menuKey,
                activeTopSubMenu: null,
                _activeMenuRect: rect,
              }));
            }}
          >
            <div className={`top-menu-label ${isOpen ? "active" : ""}`}>{menuKey}</div>

            {isOpen && (() => {
              const el   = this._topNavRefs?.[menuKey];
              const rect = el ? el.getBoundingClientRect() : null;
              const top  = rect ? rect.bottom + 2 : 50;
              const left = rect ? Math.max(0, Math.min(rect.left, window.innerWidth - 240)) : 0;
              return ReactDOM.createPortal(
                <div
                  data-top-menu-portal="true"
                  className="top-menu-dropdown level-2"
                  style={{ position: "fixed", top, left, margin: 0 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {Object.entries(menu.subMenus).map(([subKey, sub]) => {
                    if (!sub.isAccessible) return null;
                    const compoundKey = `${menuKey}_${subKey}`;
                    if (sub.directRoute) {
                      return (
                        <div key={subKey} className="dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            sub.label === "Refresh Cache" ? this.refreshCache_v1() : this.menuItemOnclick(sub.directKey, sub.icon); // ✅ pass icon
                          }}
                        >
                          {sub.icon}<span>{sub.label || subKey}</span>
                        </div>
                      );
                    }
                    return (
                      <div
                        key={subKey}
                        className="dropdown-item-with-submenu"
                        ref={(el) => (this.submenuRefs[compoundKey] = el)}
                        onClick={(e) => {
                        
                          
                          e.stopPropagation();
                          this.setState((prev) => ({
                            activeTopSubMenu: prev.activeTopSubMenu === compoundKey ? null : compoundKey,
                          }));
                        }}
                      >
                        <div className={`dropdown-item-label ${this.state.activeTopSubMenu === compoundKey ? "active" : ""}`}>
                          {sub.icon}<span>{subKey}</span><span className="arrow-right">›</span>
                        </div>
                        {this.state.activeTopSubMenu === compoundKey && (() => {
                          const subEl  = this.submenuRefs[compoundKey];
                          const subRect = subEl ? subEl.getBoundingClientRect() : null;
                          


                          // ── viewport dims (already CSS-pixel-corrected by browser at any zoom) ──
                          const vw = window.innerWidth;
                          const vh = window.innerHeight;

                          // ── dynamic flyout width: shrink on smaller/zoomed viewports ──
                          const flyW = Math.min(380, Math.floor(vw * 0.38));

                          // ── top-menu bar height guard ──
                          const topBarH = (() => {
                            const bar = document.querySelector('.top-menubar');
                            return bar ? bar.getBoundingClientRect().bottom + 4 : 46;
                          })();

                          // ── HORIZONTAL ──────────────────────────────────────────────
                          // space to the RIGHT of the level-2 panel item
                          const spaceRight = subRect ? vw - subRect.right - 6 : 0;
                          // space to the LEFT of the level-2 panel item
                          const spaceLeft  = subRect ? subRect.left - 6 : 0;

                          let l3Left;
                          if (spaceRight >= flyW) {
                            // fits on the right → open to the right
                            l3Left = subRect.right + 4;
                          } else if (spaceLeft >= flyW) {
                            // fits on the left → flip to the left
                            l3Left = subRect.left - flyW - 4;
                          } else {
                            // neither side has room → centre over available space
                            l3Left = Math.max(4, Math.floor((vw - flyW) / 2));
                          }
                          // Final clamp so it never bleeds off either edge
                          l3Left = Math.max(4, Math.min(l3Left, vw - flyW - 4));

                          // ── VERTICAL ────────────────────────────────────────────────
                          // Start aligned to the hovered row; pull up if near bottom.
                          const MARGIN = 8;
                          let l3Top = subRect ? subRect.top : topBarH;

                          // guarantee at least 150 px is visible below the starting top
                          const minVisible = 150;
                          if (l3Top + minVisible > vh - MARGIN) {
                            l3Top = Math.max(vh - minVisible - MARGIN, topBarH);
                          }
                          // never overlap the top menu bar
                          l3Top = Math.max(l3Top, topBarH);

                          // available height from l3Top to bottom of viewport
                          const maxH = Math.max(vh - l3Top - MARGIN, minVisible);
                        
                          return ReactDOM.createPortal(
                            <div
                              data-top-menu-portal="true"
                              className="top-menu-dropdown level-3"
                              style={{
                                position:  "fixed",
                                top:       l3Top,
                                left:      l3Left,
                                width:     flyW,
                                maxHeight: maxH,
                                overflowY: "auto",
                                margin:    0,
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >  
                            
                              {sub.items.map((item) => item.isAccessible && (

                               
                                <div key={item.key} className="dropdown-item"
                                  onClick={(e) => { e.stopPropagation(); this.menuItemOnclick(item.key, item.icon); }} // ✅ pass icon
                                >  
                               
                                  {item.icon}<span>{item.label}</span>
                                </div>
                              ))}
                            </div>,
                            document.body
                          );
                        })()}
                      </div>
                    );
                  })}
                </div>,
                document.body
              );
            })()}
          </div>
        );
      })}

      </div>{/* end top-menu-items */}

      {/* ── SEARCH BAR (top menu mode) ── */}
      <div
        ref={(el) => { this._searchBarRef = el; }}
        style={{ position: "relative", display: "flex", alignItems: "center", marginRight: "8px", flexShrink: 0 }}
      >
        <RiSearchEyeFill
          size={15}
          style={{ position: "absolute", left: "9px", color: "#888", pointerEvents: "none", zIndex: 1 }}
        />
        <input
          type="text"
          placeholder="Search menus..."
          value={this.state.searchQuery}
          onChange={this.handleSearchChange}
          onKeyDown={this.handleSearchKeyDown}
          onFocus={() => this.setState({ isSearchFocused: true })}
          style={{
            width: "180px",
            padding: "5px 26px 5px 28px",
            borderRadius: "8px",
            border: "1px solid #ddd",
            fontSize: "12px",
            outline: "none",
            background: "#f5f5f5",
          }}
        />
        {this.state.searchQuery && (
          <span
            onClick={this.clearSearch}
            style={{ position: "absolute", right: "8px", cursor: "pointer", color: "#999", fontSize: "14px", lineHeight: 1, zIndex: 1 }}
          >✕</span>
        )}

        {/* Search Results — portalled so overflow:auto can't clip it */}
        {this.state.searchQuery && ReactDOM.createPortal(
          <div
            data-top-menu-portal="true"
            className="search-results-dropdown"
            style={{
              position: "fixed",
              top:   (() => { const r = this._searchBarRef?.getBoundingClientRect(); return r ? r.bottom + 4 : 60; })(),
              right: (() => { const r = this._searchBarRef?.getBoundingClientRect(); return r ? window.innerWidth - r.right : 16; })(),
              width: "280px",
              background: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
              zIndex: 99999,
              maxHeight: "380px",
              overflowY: "auto",
            }}
            onMouseEnter={this.keepSearchTooltip}
            onMouseLeave={this.hideSearchTooltip}
          >
            {this.state.searchResults.length === 0 ? (
              <div style={{ padding: "12px", fontSize: "12px", color: "#999", textAlign: "center" }}>No results found</div>
            ) : (
              this.state.searchResults.map((result, idx) => (
                <div key={idx} className="search-result-item"
                  onClick={(e) => { e.stopPropagation(); this.handleSearchResultClick(result); }}
                  onMouseEnter={(e) => { this.setState({ searchHighlightIndex: idx }); this.showSearchTooltip(e, result); }}
                  onMouseLeave={this.hideSearchTooltip}
                  style={{
                    padding: "7px 12px", cursor: "pointer", borderBottom: "1px solid #f0f0f0",
                    display: "flex", alignItems: "flex-start", gap: "0px",
                    background: this.state.searchHighlightIndex === idx ? "#e8eeff" : "transparent",
                    borderLeft: this.state.searchHighlightIndex === idx ? "3px solid #4a6cf7" : "3px solid transparent",
                    transition: "background 0.1s",
                  }}
                >
                  <span style={{ flexShrink: 0, width: "22px", paddingTop: "2px", opacity: 0.6, display: "flex", alignItems: "center", justifyContent: "center" }}>{result.icon}</span>
                  <div style={{ flex: 1, minWidth: 0, paddingLeft: "6px" }}>
                    <div style={{ fontSize: "12px", fontWeight: 600, color: "#222", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "left" }}>{result.label}</div>
                    <div style={{ fontSize: "10px", color: "#888", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "left", marginTop: "1px" }}>{result.breadcrumb}</div>
                  </div>
                </div>
              ))
            )}
          </div>,
          document.body
        )}
      </div>

      {/* ── Logout — pinned to right ── */}
     {/* ── Right Section ── */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "16px",
    marginRight: "12px",
  }}
>
  {/* ── Admin (userCode) ── */}
  <div
    className="info-item"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      whiteSpace: "nowrap",
    }}
  >
    <span style={{ fontSize: "18px" }}>👤</span>
    <span className="top-menu-label">{this.state.userCode}</span>
  </div>

  {/* ── Logout ── */}
  <Nav.Link
    href="logout"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      borderRadius: "12px",
      padding: "6px 12px",
      cursor: "pointer",
      whiteSpace: "nowrap",
    }}
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>

    <span className="linkText">Logout</span>
  </Nav.Link>
</div>

  </div>
)}

            {/* MAIN CONTENT AREA */}
            <div
              className={
                this.state.isChangeMenu
                  ? "parent context-container"
                  : `parent context-container ${this.state.sidebarOpen ? "open" : "closed"}`
              }
            >
              <ModuleTabs
                moduleList={this.state.moduleList}
                selectedModuleKey={this.state.selectedModuleKey}
                OntabSelect={this.tabSelected}
                OnRemoveModule={this.removeModule}
                onRemove_Module={this.remove_Module}
                key="moduleTabsKey"
              />
            </div>
          </div>
        </div>

        {/* ── Search tooltip — smart positioned portal, closes properly ── */}
        {this.state.searchTooltip && (() => {
          const { result, left, top } = this.state.searchTooltip;
          const tipW = 240;
          const typeLabel = result.type === "direct"  ? "Direct Link"
                          : result.type === "submenu" ? "Sub Menu"
                          : "Menu Item";
          const typeColor = result.type === "direct"  ? "#10b981"
                          : result.type === "submenu" ? "#6366f1"
                          : "#f59e0b";
          const arrowOnRight = left > window.innerWidth / 2;
          return ReactDOM.createPortal(
            <div
              data-top-menu-portal="true"
              onMouseEnter={this.keepSearchTooltip}
              onMouseLeave={this.hideSearchTooltip}
              style={{
                position: "fixed", top, left, width: tipW, zIndex: 999999,
                background: "#1e293b", color: "#fff", borderRadius: "10px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.28)",
                padding: "12px 14px", fontSize: "12px", lineHeight: 1.5,
                animation: "fadeInTooltip 0.12s ease", cursor: "default",
              }}
            >
              {!arrowOnRight && <div style={{ position:"absolute", left:"-6px", top:"14px", width:0, height:0, borderTop:"6px solid transparent", borderBottom:"6px solid transparent", borderRight:"6px solid #1e293b" }} />}
              {arrowOnRight  && <div style={{ position:"absolute", right:"-6px", top:"14px", width:0, height:0, borderTop:"6px solid transparent", borderBottom:"6px solid transparent", borderLeft:"6px solid #1e293b" }} />}
              <div style={{ marginBottom: "8px" }}>
                <span style={{ background: typeColor, color:"#fff", borderRadius:"4px", padding:"2px 7px", fontSize:"10px", fontWeight:700, letterSpacing:"0.4px" }}>{typeLabel}</span>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:"7px", marginBottom:"8px" }}>
                <span style={{ opacity:0.8, fontSize:"15px", flexShrink:0 }}>{result.icon}</span>
                <span style={{ fontWeight:700, fontSize:"13px", color:"#f1f5f9", wordBreak:"break-word" }}>{result.label}</span>
              </div>
              <div style={{ background:"rgba(255,255,255,0.08)", borderRadius:"6px", padding:"6px 8px" }}>
                <div style={{ fontSize:"9px", color:"#94a3b8", marginBottom:"3px", letterSpacing:"0.5px", textTransform:"uppercase" }}>Path</div>
                {result.breadcrumb.split(" › ").map((part, i, arr) => (
                  <span key={i} style={{ color: i === arr.length - 1 ? "#7dd3fc" : "#cbd5e1" }}>
                    {part}{i < arr.length - 1 && <span style={{ color:"#475569", margin:"0 4px" }}>›</span>}
                  </span>
                ))}
              </div>
              <div style={{ marginTop:"8px", fontSize:"10px", color:"#64748b", textAlign:"right" }}>Click to open</div>
            </div>,
            document.body
          );
        })()}

      </div>
    );
  }
}

// ========== MODULE TABS COMPONENT ==========
export class ModuleTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { key: this.props.selectedModuleKey };
    this.testRef = React.createRef();
  }

  // Only re-render when tabs or selected tab actually change
  // Blocks re-render from sidebar open/close, menu toggles, flyout state, etc.
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.moduleList !== this.props.moduleList ||
      nextProps.selectedModuleKey !== this.props.selectedModuleKey
    );
  }

  componentDidUpdate(prevProps) { }
  componentDidMount = () => { };

  tabOnSelect = (k) => {
    this.setState({ key: k });
  };

  closeTab = (moduleKey) => {
    this.props.OnRemoveModule(moduleKey);
  };

  close_tab = (moduleKey) => {
    this.props.onRemove_Module(moduleKey);
  };

  render() {
 
    return (
      <Tabs
        id="moduleTabs"
        activeKey={this.props.selectedModuleKey}
        variant="pills"
        onSelect={this.props.OntabSelect}
      >
        
        
        {Object.values(this.props.moduleList).map((m, i) => (
          
          <Tab
            key={m.key}
            eventKey={m.key}
            title={
              <TabTitle
                title={m.title}
                icon={m.icon}
                onTabClose={() => this.close_tab(m.key)}
              />
            }
          >
            {m.getModuleObject(m.key, () => this.closeTab(m.key), this.testRef)}
          </Tab>
        ))}
      </Tabs>
    );
  }
}

// ========== TAB TITLE COMPONENT ==========
// const TabTitle = (props) => {
//   console.log("TabTitle",props);
  
//   return (
//     <span>
//       <span className="font-weight-bold px-2">{props.title}</span>
//     </span>
//   );
// };
// ========== TAB TITLE COMPONENT ==========
const TabTitle = (props) => {
  return (
    <span className="d-flex align-items-center gap-1">
      {props.icon && (
        <span style={{ display: "flex", alignItems: "center",
          //  marginRight: "2px",
        marginLeft:"5px" }}>
          {props.icon}
        </span>
      )}
      <span className="font-weight-bold"
      //  px-2
      >{props.title}</span>
    </span>
  );
};

// ========== MAIN MODULE WRAPPER ==========
const MainModule = (props) => {
  const appData = props.appData;
  const setAppData = props.setAppData;
//UseAutoLogout(60 * 60 * 1000); 
// useServerHealthCheck();
  if (isEmpty(props.location) || isEmpty(props.location.state)) {
    return <Navigate to="/login" />;
  } else {
    let loginSession = props.location.state.loginSession;
    return (
      <div className="App">
        <AppContext.Provider value={{ appData, setAppData }}>
          <AppStarter
            name="ERP"
            loginSession={loginSession}
            appData={appData}
          />
        </AppContext.Provider>
      </div>
    );
  }
};

export default MainModule;